var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustRealityAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 520 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);filter:url(#luminosity-noclip-9);}.cls-10,.cls-12,.cls-14,.cls-16,.cls-2,.cls-25,.cls-4,.cls-54,.cls-6,.cls-8{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{mask:url(#mask-2);filter:url(#luminosity-noclip-14);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{mask:url(#mask-3);filter:url(#luminosity-noclip-15);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{mask:url(#mask-4);filter:url(#luminosity-noclip-16);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{mask:url(#mask-5);filter:url(#luminosity-noclip-10);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{mask:url(#mask-6);filter:url(#luminosity-noclip-11);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{mask:url(#mask-7);filter:url(#luminosity-noclip-12);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{mask:url(#mask-8);filter:url(#luminosity-noclip-13);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:#e4dfe7;}.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-18{fill:#696969;}.cls-19{fill:#d3ccd8;}.cls-20{fill:none;}.cls-21{fill:#efa4fc;}.cls-22{fill:#ec92fc;}.cls-23{isolation:isolate;}.cls-24,.cls-365{fill:#fff;}.cls-26{fill:#d7d1db;}.cls-27{clip-path:url(#clip-path);}.cls-28{clip-path:url(#clip-path-2);}.cls-29{clip-path:url(#clip-path-3);}.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-30{fill:#ec94fc;}.cls-31{fill:#e35efa;}.cls-32{clip-path:url(#clip-path-4);}.cls-33{fill:#b0b0b0;}.cls-34{fill:url(#linear-gradient-9);}.cls-35{clip-path:url(#clip-path-5);}.cls-36{clip-path:url(#clip-path-6);}.cls-37{clip-path:url(#clip-path-7);}.cls-38{fill:#f5f4f6;}.cls-313,.cls-39{fill:#f9dcfe;}.cls-40{fill:#919191;}.cls-41{fill:#f6cbfd;}.cls-42{opacity:0.7;}.cls-43{fill:url(#linear-gradient-10);}.cls-44{opacity:0.6;}.cls-45{fill:url(#linear-gradient-11);}.cls-46,.cls-51{opacity:0.8;}.cls-47{fill:url(#linear-gradient-12);}.cls-48{fill:url(#linear-gradient-13);}.cls-49{fill:#525252;}.cls-50{fill:#e87dfb;}.cls-51,.cls-80{fill:#f7cffe;}.cls-52{fill:url(#linear-gradient-14);}.cls-53{fill:url(#linear-gradient-15);}.cls-54{fill:#878787;opacity:0.2;}.cls-307,.cls-55{fill:#f8d8fe;}.cls-56{fill:#2b2b2b;}.cls-57{fill:#1a1a1a;}.cls-298,.cls-58{fill:#f7d2fe;}.cls-59{fill:#f5c5fd;}.cls-60{fill:#949494;}.cls-105,.cls-113,.cls-122,.cls-61{opacity:0.5;}.cls-102,.cls-110,.cls-119,.cls-365,.cls-62{opacity:0;}.cls-63{opacity:0.17;}.cls-346,.cls-64{fill:#fdf2ff;}.cls-65{opacity:0.33;}.cls-328,.cls-66{fill:#fbe6fe;}.cls-309,.cls-67{fill:#f9d9fe;}.cls-68{opacity:0.67;}.cls-69{fill:#f6ccfe;}.cls-70{opacity:0.83;}.cls-71{fill:#f4c0fd;}.cls-72{fill:#f2b3fd;}.cls-73{clip-path:url(#clip-path-8);}.cls-74{clip-path:url(#clip-path-9);}.cls-75{clip-path:url(#clip-path-10);}.cls-76{fill:#f0aafc;}.cls-77{fill:url(#linear-gradient-16);}.cls-78{fill:url(#linear-gradient-17);}.cls-79{fill:url(#linear-gradient-18);}.cls-81{fill:url(#linear-gradient-19);}.cls-82{mask:url(#mask-9);}.cls-83{fill:url(#linear-gradient-20);}.cls-84{mask:url(#mask-10);}.cls-85{fill:url(#linear-gradient-21);}.cls-86{mask:url(#mask-11);}.cls-87{fill:url(#linear-gradient-22);}.cls-88{mask:url(#mask-12);}.cls-89{fill:url(#linear-gradient-23);}.cls-90{mask:url(#mask-13);}.cls-91{fill:url(#linear-gradient-24);}.cls-92{opacity:0.9;}.cls-93{fill:url(#linear-gradient-25);}.cls-94{mask:url(#mask-14);}.cls-95{fill:url(#linear-gradient-26);}.cls-96{mask:url(#mask-15);}.cls-97{fill:url(#linear-gradient-27);}.cls-98{mask:url(#mask-16);}.cls-99{fill:url(#linear-gradient-28);}.cls-100,.cls-310,.cls-311{fill:#f9dafe;}.cls-101{mix-blend-mode:screen;}.cls-103,.cls-111,.cls-120{opacity:0.17;}.cls-104,.cls-112,.cls-121{opacity:0.33;}.cls-106,.cls-114,.cls-123{opacity:0.67;}.cls-107,.cls-115,.cls-124{opacity:0.83;}.cls-108{fill:url(#linear-gradient-29);}.cls-109{fill:url(#linear-gradient-30);}.cls-116{fill:url(#linear-gradient-31);}.cls-117{fill:url(#linear-gradient-32);}.cls-118{fill:url(#linear-gradient-33);}.cls-125{fill:url(#linear-gradient-34);}.cls-126{fill:url(#linear-gradient-35);}.cls-127{fill:url(#linear-gradient-36);}.cls-128{fill:url(#linear-gradient-37);}.cls-129{clip-path:url(#clip-path-11);}.cls-130{clip-path:url(#clip-path-12);}.cls-131{clip-path:url(#clip-path-13);}.cls-132{clip-path:url(#clip-path-14);}.cls-133{fill:url(#linear-gradient-38);}.cls-134{clip-path:url(#clip-path-15);}.cls-135{clip-path:url(#clip-path-16);}.cls-136{clip-path:url(#clip-path-17);}.cls-137{fill:#3b3b3b;}.cls-138{fill:#e87bfb;}.cls-139,.cls-306{fill:#f8d7fe;}.cls-140{opacity:0.67;}.cls-141,.cls-317,.cls-318{fill:#fadffe;}.cls-142,.cls-330{fill:#fbe7ff;}.cls-143{opacity:0.33;}.cls-144,.cls-341,.cls-342{fill:#fcefff;}.cls-145{opacity:0.17;}.cls-146,.cls-353{fill:#fef7ff;}.cls-147{clip-path:url(#clip-path-18);}.cls-148{clip-path:url(#clip-path-19);}.cls-149{clip-path:url(#clip-path-20);}.cls-150{fill:#9e8ea8;}.cls-151{fill:url(#linear-gradient-39);}.cls-152{fill:url(#linear-gradient-40);}.cls-153{clip-path:url(#clip-path-21);}.cls-154{fill:#e25cfa;}.cls-155{fill:#e360fa;}.cls-156{fill:#e464fa;}.cls-157{fill:#e466fa;}.cls-158{fill:#e56afa;}.cls-159{fill:#e56cfa;}.cls-160{fill:#e66efb;}.cls-161{fill:#e258fa;}.cls-162{fill:#e156fa;}.cls-163{fill:#e154fa;}.cls-164{fill:#e981fb;}.cls-165{clip-path:url(#clip-path-22);}.cls-166{fill:#e775fb;}.cls-167{clip-path:url(#clip-path-23);}.cls-168{clip-path:url(#clip-path-24);}.cls-169{fill:url(#linear-gradient-41);}.cls-170{fill:url(#linear-gradient-42);}.cls-171{opacity:0.71;}.cls-172{fill:url(#linear-gradient-43);}.cls-173{fill:url(#linear-gradient-44);}.cls-174{fill:#fcfcfc;}.cls-175{clip-path:url(#clip-path-25);}.cls-176{clip-path:url(#clip-path-26);}.cls-177{clip-path:url(#clip-path-27);}.cls-178{clip-path:url(#clip-path-28);}.cls-179{clip-path:url(#clip-path-29);}.cls-180{clip-path:url(#clip-path-30);}.cls-181{fill:#f1b3fc;}.cls-182{fill:#f3c1fc;}.cls-183{fill:#f6d0fc;}.cls-184{fill:#f8dffc;}.cls-185{fill:#faedfc;}.cls-186{fill:#bdbdbd;}.cls-187{fill:#cacaca;}.cls-188{fill:#d8d8d8;}.cls-189{fill:#e5e5e5;}.cls-190{fill:#f2f2f2;}.cls-191{opacity:0.98;}.cls-192{fill:#efa6fc;}.cls-193{opacity:0.96;}.cls-194{fill:#f0a7fc;}.cls-195{opacity:0.94;}.cls-196{fill:#f0a9fc;}.cls-197{opacity:0.92;}.cls-198{fill:#f0abfc;}.cls-199{opacity:0.9;}.cls-200{fill:#f0adfc;}.cls-201{opacity:0.88;}.cls-202{fill:#f1aefc;}.cls-203{opacity:0.86;}.cls-204{fill:#f1b0fc;}.cls-205{opacity:0.84;}.cls-206{fill:#f1b2fc;}.cls-207{opacity:0.82;}.cls-208{fill:#f1b4fc;}.cls-209{opacity:0.8;}.cls-210{fill:#f2b5fc;}.cls-211{opacity:0.78;}.cls-212{fill:#f2b7fc;}.cls-213{opacity:0.76;}.cls-214{fill:#f2b9fc;}.cls-215{opacity:0.75;}.cls-216{fill:#f2bafc;}.cls-217{opacity:0.73;}.cls-218{fill:#f3bcfc;}.cls-219{opacity:0.71;}.cls-220{fill:#f3befc;}.cls-221{opacity:0.69;}.cls-222{fill:#f3c0fc;}.cls-223{opacity:0.65;}.cls-224{fill:#f4c3fc;}.cls-225{opacity:0.63;}.cls-226{fill:#f4c5fc;}.cls-227{opacity:0.61;}.cls-228{fill:#f4c7fc;}.cls-229{opacity:0.59;}.cls-230{fill:#f4c8fc;}.cls-231{opacity:0.57;}.cls-232{fill:#f5cafc;}.cls-233{opacity:0.55;}.cls-234{fill:#f5ccfc;}.cls-235{opacity:0.53;}.cls-236{fill:#f5cdfc;}.cls-237{opacity:0.51;}.cls-238{fill:#f5cffc;}.cls-239{opacity:0.49;}.cls-240{fill:#f6d1fc;}.cls-241{opacity:0.47;}.cls-242{fill:#f6d3fc;}.cls-243{opacity:0.45;}.cls-244{fill:#f6d4fc;}.cls-245{opacity:0.43;}.cls-246{fill:#f6d6fc;}.cls-247{opacity:0.41;}.cls-248{fill:#f7d8fc;}.cls-249{opacity:0.39;}.cls-250{fill:#f7d9fc;}.cls-251{opacity:0.37;}.cls-252{fill:#f7dbfc;}.cls-253{opacity:0.35;}.cls-254{fill:#f7ddfc;}.cls-255{opacity:0.31;}.cls-256{fill:#f8e0fc;}.cls-257{opacity:0.29;}.cls-258{fill:#f8e2fc;}.cls-259{opacity:0.27;}.cls-260{fill:#f8e4fc;}.cls-261{opacity:0.25;}.cls-262{fill:#f9e6fc;}.cls-263{opacity:0.24;}.cls-264{fill:#f9e7fc;}.cls-265{opacity:0.22;}.cls-266{fill:#f9e9fc;}.cls-267{opacity:0.2;}.cls-268{fill:#f9ebfc;}.cls-269{opacity:0.18;}.cls-270{fill:#faecfc;}.cls-271{opacity:0.16;}.cls-272{fill:#faeefc;}.cls-273{opacity:0.14;}.cls-274{fill:#faf0fc;}.cls-275{opacity:0.12;}.cls-276{fill:#faf2fc;}.cls-277{opacity:0.1;}.cls-278{fill:#fbf3fc;}.cls-279{opacity:0.08;}.cls-280{fill:#fbf5fc;}.cls-281{opacity:0.06;}.cls-282{fill:#fbf7fc;}.cls-283{opacity:0.04;}.cls-284{fill:#fbf9fc;}.cls-285{opacity:0.02;}.cls-286{fill:#fcfafc;}.cls-287{fill:url(#linear-gradient-45);}.cls-288{fill:#f3b9fd;}.cls-289{fill:#b8adbf;}.cls-290{fill:#ece8ee;}.cls-291{fill:#d6d0da;}.cls-292{fill:#545454;}.cls-293{clip-path:url(#clip-path-31);}.cls-294{fill:#dd3df9;}.cls-295,.cls-296{fill:#f7d0fe;}.cls-295{opacity:0.99;}.cls-296{opacity:0.97;}.cls-297{fill:#f7d1fe;opacity:0.96;}.cls-298{opacity:0.94;}.cls-299{fill:#f8d2fe;opacity:0.93;}.cls-300{fill:#f8d3fe;opacity:0.92;}.cls-301,.cls-302{fill:#f8d4fe;}.cls-301{opacity:0.9;}.cls-302{opacity:0.89;}.cls-303{fill:#f8d5fe;opacity:0.87;}.cls-304,.cls-305{fill:#f8d6fe;}.cls-304{opacity:0.86;}.cls-305{opacity:0.85;}.cls-306{opacity:0.83;}.cls-307{opacity:0.82;}.cls-308{fill:#f9d8fe;opacity:0.8;}.cls-309{opacity:0.79;}.cls-310{opacity:0.77;}.cls-311{opacity:0.76;}.cls-312{fill:#f9dbfe;opacity:0.75;}.cls-313{opacity:0.73;}.cls-314,.cls-315{fill:#f9ddfe;}.cls-314{opacity:0.72;}.cls-315{opacity:0.7;}.cls-316{fill:#f9defe;opacity:0.69;}.cls-317{opacity:0.68;}.cls-318{opacity:0.66;}.cls-319{fill:#fae0fe;opacity:0.65;}.cls-320,.cls-321{fill:#fae1fe;}.cls-320{opacity:0.63;}.cls-321{opacity:0.62;}.cls-322{fill:#fae2fe;opacity:0.61;}.cls-323,.cls-324{fill:#fae3fe;}.cls-323{opacity:0.59;}.cls-324{opacity:0.58;}.cls-325{fill:#fae4fe;opacity:0.56;}.cls-326,.cls-327{fill:#fbe5fe;}.cls-326{opacity:0.55;}.cls-327{opacity:0.54;}.cls-328{opacity:0.52;}.cls-329{fill:#fbe7fe;opacity:0.51;}.cls-330{opacity:0.49;}.cls-331{fill:#fbe8ff;opacity:0.48;}.cls-332,.cls-333{fill:#fbe9ff;}.cls-332{opacity:0.46;}.cls-333{opacity:0.45;}.cls-334{fill:#fceaff;opacity:0.44;}.cls-335,.cls-336{fill:#fcebff;}.cls-335{opacity:0.42;}.cls-336{opacity:0.41;}.cls-337{fill:#fcecff;opacity:0.39;}.cls-338,.cls-339{fill:#fcedff;}.cls-338{opacity:0.38;}.cls-339{opacity:0.37;}.cls-340{fill:#fceeff;opacity:0.35;}.cls-341{opacity:0.34;}.cls-342{opacity:0.32;}.cls-343{fill:#fdf0ff;opacity:0.31;}.cls-344,.cls-345{fill:#fdf1ff;}.cls-344{opacity:0.3;}.cls-345{opacity:0.28;}.cls-346{opacity:0.27;}.cls-347{fill:#fdf3ff;opacity:0.25;}.cls-348,.cls-349{fill:#fdf4ff;}.cls-348{opacity:0.24;}.cls-349{opacity:0.23;}.cls-350{fill:#fdf5ff;opacity:0.21;}.cls-351{fill:#fdf6ff;opacity:0.2;}.cls-352{fill:#fef6ff;opacity:0.18;}.cls-353{opacity:0.17;}.cls-354,.cls-355{fill:#fef8ff;}.cls-354{opacity:0.15;}.cls-355{opacity:0.14;}.cls-356{fill:#fef9ff;opacity:0.13;}.cls-357,.cls-358{fill:#fefaff;}.cls-357{opacity:0.11;}.cls-358{opacity:0.1;}.cls-359{fill:#fefbff;opacity:0.08;}.cls-360{fill:#fefcff;opacity:0.07;}.cls-361{fill:#fffcff;opacity:0.06;}.cls-362{fill:#fffdff;opacity:0.04;}.cls-363,.cls-364{fill:#fffeff;}.cls-363{opacity:0.03;}.cls-364{opacity:0.01;}.cls-366{filter:url(#luminosity-noclip-8);}.cls-367{filter:url(#luminosity-noclip-7);}.cls-368{filter:url(#luminosity-noclip-6);}.cls-369{filter:url(#luminosity-noclip-5);}.cls-370{filter:url(#luminosity-noclip-4);}.cls-371{filter:url(#luminosity-noclip-3);}.cls-372{filter:url(#luminosity-noclip-2);}.cls-373{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 119.49,
    y: -8392,
    width: 0.27,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 119.49,
    y: -8392,
    width: 0.27,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 119.46,
    y1: 69.64,
    x2: 119.75,
    y2: 78.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 169.81,
    y: -8392,
    width: 2.39,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 169.81,
    y: -8392,
    width: 2.39,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 169.81,
    y1: 144.13,
    x2: 171.75,
    y2: 134.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 174.74,
    y: -8392,
    width: 2.39,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 174.74,
    y: -8392,
    width: 2.39,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-371"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 174.8,
    y1: 147.34,
    x2: 176.67,
    y2: 138.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 180.07,
    y: -8392,
    width: 2.4,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 180.07,
    y: -8392,
    width: 2.4,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-370"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 179.31,
    y1: 149.75,
    x2: 182.98,
    y2: 136.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 124.7,
    y: -8392,
    width: 0.27,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 124.7,
    y: -8392,
    width: 0.27,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-369"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 124.68,
    y1: 72.64,
    x2: 124.96,
    y2: 81.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 135.97,
    y: -8392,
    width: 0.27,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 135.97,
    y: -8392,
    width: 0.27,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-368"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 135.95,
    y1: 73.79,
    x2: 136.24,
    y2: 82.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 129.92,
    y: -8392,
    width: 0.27,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 129.92,
    y: -8392,
    width: 0.27,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 129.89,
    y1: 69.04,
    x2: 130.18,
    y2: 77.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 139.52,
    y: -8392,
    width: 0.27,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 139.52,
    y: -8392,
    width: 0.27,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 139.49,
    y1: 70.89,
    x2: 139.78,
    y2: 79.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M403.92,156v3.22a3.36,3.36,0,0,1-2,2.75V158.7A3.36,3.36,0,0,0,403.92,156Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.8,159.13v-3.22a3.4,3.4,0,0,0,2,2.79v3.22A3.4,3.4,0,0,1,319.8,159.13Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M366.88,178.59v3.22a11,11,0,0,1-9.77,0v-3.22A11,11,0,0,0,366.88,178.59Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M376.73,154.16V155c0,2.1-1.38,4.19-4.14,5.8C367,164,358,164,352.45,160.79c-2.81-1.62-4.21-3.75-4.21-5.88v-.83c0,2.12,1.4,4.25,4.21,5.87,5.58,3.22,14.59,3.22,20.14,0C375.34,158.35,376.72,156.26,376.73,154.16Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 369.77,
    y1: 161.5,
    x2: 355.13,
    y2: 146.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec94fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7cffe"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M331.18,133.78l1.6.93a1,1,0,0,1-.43-1l-1.6-.92A1.06,1.06,0,0,0,331.18,133.78Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M355.46,73.75l-1.6-.92a1,1,0,0,0-1.05.1l1.59.93A1.07,1.07,0,0,1,355.46,73.75Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M333.7,85.81l-1.6-.93a3.28,3.28,0,0,0-1.48,2.57l1.6.93A3.28,3.28,0,0,1,333.7,85.81Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 363.52,
    y1: 113.87,
    x2: 333.8,
    y2: 95.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 337.28,
    y1: 94.73,
    x2: 360.23,
    y2: 113.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 357.53,
    y1: 102.71,
    x2: 341,
    y2: 93.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec92fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7cffe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 345.55,
    y1: 95.19,
    x2: 353.32,
    y2: 101.11,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 372.02,
    y1: 85.76,
    x2: 373.47,
    y2: 80.11,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 371.13,
    y1: 80.99,
    x2: 374.37,
    y2: 90.92,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M205.55,142.64l0,5.82c0,1.8-1.18,3.6-3.54,5v-5.82C204.36,146.24,205.55,144.44,205.55,142.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M57,148.4l0-5.82c0,1.82,1.2,3.64,3.6,5l0,5.82C58.21,152,57,150.22,57,148.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M140.15,183.56l0,5.82c-4.75,2.76-12.47,2.76-17.25,0l0-5.82C127.68,186.32,135.4,186.32,140.15,183.56Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 178.86,
    y1: 137.3,
    x2: 126.61,
    y2: 74.12,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 179.5,
    y1: 100.52,
    x2: 159.49,
    y2: 93.52,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 132.56,
    y1: 103.98,
    x2: 137.04,
    y2: 93.16,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 139.57,
    y1: 88.22,
    x2: 120.22,
    y2: 60.02,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 119.49,
    y: 70.18,
    width: 0.27,
    height: 8.85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 119.49,
    y: 70.18,
    width: 0.27,
    height: 8.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.76 70.32 119.73 79.02 119.49 78.88 119.51 70.17 119.76 70.32"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 119.46,
    y1: 69.64,
    x2: 119.75,
    y2: 78.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6a6a6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 124.7,
    y: 73.18,
    width: 0.27,
    height: 8.85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 124.7,
    y: 73.18,
    width: 0.27,
    height: 8.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "124.97 73.32 124.95 82.03 124.7 81.89 124.72 73.18 124.97 73.32"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 124.68,
    y1: 72.64,
    x2: 124.96,
    y2: 81.58,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-11",
    x: 135.97,
    y: 74.33,
    width: 0.27,
    height: 8.85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 135.97,
    y: 74.33,
    width: 0.27,
    height: 8.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "136.24 74.47 136.22 83.18 135.97 83.03 136 74.33 136.24 74.47"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 135.95,
    y1: 73.79,
    x2: 136.24,
    y2: 82.73,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-12",
    x: 129.92,
    y: 69.57,
    width: 0.27,
    height: 8.85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 129.92,
    y: 69.57,
    width: 0.27,
    height: 8.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "130.19 69.72 130.16 78.42 129.91 78.28 129.94 69.57 130.19 69.72"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 129.89,
    y1: 69.04,
    x2: 130.18,
    y2: 77.97,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-13",
    x: 139.52,
    y: 71.43,
    width: 0.27,
    height: 8.85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 139.52,
    y: 71.43,
    width: 0.27,
    height: 8.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "139.79 71.58 139.76 80.28 139.52 80.14 139.54 71.43 139.79 71.58"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 139.49,
    y1: 70.89,
    x2: 139.78,
    y2: 79.83,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 190.37,
    y1: 121.54,
    x2: 172.16,
    y2: 135.85,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-14",
    x: 169.81,
    y: 132.25,
    width: 2.39,
    height: 11.59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 169.81,
    y: 132.25,
    width: 2.39,
    height: 11.59,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "172.2 133.61 172.17 143.84 169.81 142.47 169.84 132.25 172.2 133.61"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 169.81,
    y1: 144.13,
    x2: 171.75,
    y2: 134.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec94fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6a6a6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-15",
    x: 174.74,
    y: 137.1,
    width: 2.39,
    height: 9.58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 174.74,
    y: 137.1,
    width: 2.39,
    height: 9.58,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "177.13 138.46 177.11 146.68 174.74 145.32 174.77 137.1 177.13 138.46"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 174.8,
    y1: 147.34,
    x2: 176.67,
    y2: 138.35,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-16",
    x: 180.07,
    y: 135.09,
    width: 2.4,
    height: 14.71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 180.07,
    y: 135.09,
    width: 2.4,
    height: 14.71,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "182.47 136.46 182.44 149.8 180.07 148.43 180.11 135.09 182.47 136.46"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 179.31,
    y1: 149.75,
    x2: 182.98,
    y2: 136.12,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 113.07,
    y1: 93.59,
    x2: 103.17,
    y2: 122.79,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 114.08,
    y1: 93.46,
    x2: 112.58,
    y2: 129.57,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 95.82,
    y1: 130.35,
    x2: 99.31,
    y2: 116.46,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 107.9,
    y1: 125.65,
    x2: 100.57,
    y2: 117.58,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 94.72,
    y1: 112.07,
    x2: 107.69,
    y2: 112.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6a6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 92.51,
    y1: 122.62,
    x2: 86.24,
    y2: 134.16,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 91.98,
    y1: 124.57,
    x2: 97.25,
    y2: 134,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 505.37,
    y1: 160.95,
    x2: 524.93,
    y2: 169.9,
    gradientTransform: "translate(-374.99)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 525.22,
    y1: 173.84,
    x2: 514.16,
    y2: 168.9,
    gradientTransform: "translate(-374.99)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M204.13,293.42l0,5c0,1.55-1,3.09-3,4.27v-5C203.11,296.5,204.12,295,204.13,293.42Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M76.57,298.36v-5c0,1.56,1,3.13,3.1,4.32l0,5C77.6,301.48,76.56,299.92,76.57,298.36Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M148,328.55v5a16.33,16.33,0,0,1-14.82,0l0-5A16.31,16.31,0,0,0,148,328.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M110.78,292.14v1.75c0,4.41,2.91,8.81,8.7,12.18,11.65,6.77,30.59,6.77,42.31,0,5.9-3.41,8.85-7.88,8.84-12.34V292c0,4.46-2.93,8.93-8.83,12.34-11.73,6.77-30.67,6.76-42.32,0C113.69,301,110.79,296.55,110.78,292.14Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 169.77,
    y1: 307.25,
    x2: 122.41,
    y2: 281.35,
    gradientTransform: "matrix(-1, 0, 0, 1, 281.41, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M113.88,286.23l2,1.19a1.33,1.33,0,0,1-.55-1.22l-2-1.18A1.3,1.3,0,0,0,113.88,286.23Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M144.75,209.9l-2-1.18a1.33,1.33,0,0,0-1.34.13l2,1.18A1.33,1.33,0,0,1,144.75,209.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M117.08,225.23l-2-1.18a4.12,4.12,0,0,0-1.88,3.26l2,1.18A4.15,4.15,0,0,1,117.08,225.23Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M498.39,269l0,5.82c0,1.8-1.19,3.59-3.55,5l0-5.82C497.2,272.59,498.38,270.8,498.39,269Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M349.85,274.75l0-5.82c0,1.82,1.19,3.64,3.6,5l0,5.82C351.05,278.39,349.84,276.57,349.85,274.75Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M433,309.91l0,5.82c-4.75,2.76-12.47,2.76-17.25,0v-5.82C420.51,312.67,428.24,312.67,433,309.91Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 314,
    y1: 210.79,
    x2: 350.31,
    y2: 229.94,
    gradientTransform: "translate(71.71)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 319.69,
    y1: 218.24,
    x2: 356.26,
    y2: 229.67,
    gradientTransform: "translate(71.71)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M472,218l.17,60.19a.55.55,0,0,0,.32.46,1.76,1.76,0,0,0,1.58,0,.57.57,0,0,0,.34-.47L474.24,218a.57.57,0,0,1-.34.47,1.76,1.76,0,0,1-1.58,0A.55.55,0,0,1,472,218Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M465.36,255.35l-.46.26c1.13-.65,1.83-2,1.83-4l.46-.27C467.18,253.31,466.48,254.7,465.36,255.35Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M456.23,225.07l17.12-9.95c1.17-.68,2.79-.59,4.58.45l-17.12,10C459,224.48,457.4,224.39,456.23,225.07Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M460.81,225.52l17.12-10a14.14,14.14,0,0,1,6.42,11.12l-17.12,9.95A14.14,14.14,0,0,0,460.81,225.52Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 296.6,
    y1: 268.6,
    x2: 273.04,
    y2: 234.08,
    gradientTransform: "matrix(-1, 0, 0, 1, 662.53, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 268.81,
    y1: 218.24,
    x2: 278.24,
    y2: 242.79,
    gradientTransform: "matrix(-1, 0, 0, 1, 662.53, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 217.88,
    y1: 225.99,
    x2: 192.38,
    y2: 214.5,
    gradientTransform: "translate(248.41)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 204.36,
    y1: 202.48,
    x2: 213.01,
    y2: 207.45,
    gradientTransform: "translate(248.41)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M352.64,215.58l0,10.25c0,1.71-1.12,3.41-3.36,4.71l0-10.25C351.52,219,352.63,217.29,352.64,215.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M149.59,225.77l0-10.25c0,1.73,1.14,3.46,3.42,4.77l0,10.25C150.72,229.23,149.58,227.5,149.59,225.77Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M259.63,272.39l0,10.25c-4.5,2.61-11.84,2.61-16.37,0l0-10.25C247.79,275,255.13,275,259.63,272.39Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M332.13,211.45l0,8.2c0,1.57-1,3.13-3.09,4.33l0-8.2C331.1,214.59,332.13,213,332.13,211.45Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M170.73,219.59l0-8.2c0,1.59,1,3.18,3.14,4.4l0,8.19C171.78,222.77,170.73,221.18,170.73,219.59Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M259.22,256.35l0,8.2a16.59,16.59,0,0,1-15.06,0l0-8.2A16.57,16.57,0,0,0,259.22,256.35Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 283.68,
    y1: 224.55,
    x2: 206.47,
    y2: 188.61,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M218.74,219.32l0,12.37a3.06,3.06,0,0,1-1.79,2.52,9.65,9.65,0,0,1-8.77,0,3.1,3.1,0,0,1-1.84-2.56l0-12.37a3.1,3.1,0,0,0,1.83,2.56,9.65,9.65,0,0,0,8.77,0A3.06,3.06,0,0,0,218.74,219.32Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M468.4,219.4c9.25,5.34,9.29,14,.11,19.32L269.07,354.63c-9.18,5.33-24.12,5.34-33.36,0L35,238.73c-9.24-5.34-9.28-14-.1-19.32L234.3,103.5c9.18-5.33,24.11-5.33,33.36,0ZM269.06,352.89,465.52,238.73c9.18-5.34,9.14-14-.1-19.33L267.67,105.23c-9.24-5.34-24.18-5.33-33.36,0L37.85,219.41c-9.18,5.33-9.13,14,.11,19.32L235.7,352.89c9.25,5.34,24.18,5.34,33.36,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M401.88,167.16c2.71,1.53,2.72,4,0,5.54l-35,19.89a11,11,0,0,1-9.77,0L321.85,172.7c-2.71-1.53-2.72-4,0-5.54l35-19.89a11,11,0,0,1,9.77,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M403.92,156v3.22a3.36,3.36,0,0,1-2,2.75V158.7A3.36,3.36,0,0,0,403.92,156Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M403.92,156v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M403.92,156v3.22a2.6,2.6,0,0,1-.05.39v-3.23a2.32,2.32,0,0,0,.05-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M403.87,156.39v3.23a2,2,0,0,1-.11.38v-3.22a1.9,1.9,0,0,0,.11-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M403.76,156.78V160a3.26,3.26,0,0,1-.18.38v-3.22c.07-.13.13-.26.18-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M403.58,157.16v3.22a2.63,2.63,0,0,1-.28.4v-3.22a3.6,3.6,0,0,0,.28-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M403.3,157.56v3.22a4.6,4.6,0,0,1-.43.46V158a3.64,3.64,0,0,0,.43-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M402.87,158v3.23a5.69,5.69,0,0,1-.88.63v-3.22a5.12,5.12,0,0,0,.88-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M402,158.65v3.22l-.08,0V158.7l.08,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.8,159.13v-3.22a3.4,3.4,0,0,0,2,2.79v3.22A3.4,3.4,0,0,1,319.8,159.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M321.85,158.7v3.22a3.4,3.4,0,0,1-2-2.79v-3.22a3.4,3.4,0,0,0,2,2.79Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "401.91 158.7 401.9 161.92 366.87 181.81 366.88 178.59 401.91 158.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "357.11 178.59 357.1 181.81 321.84 161.92 321.85 158.69 357.11 178.59"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M366.88,178.59v3.22a11,11,0,0,1-9.77,0v-3.22A11,11,0,0,0,366.88,178.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M366.88,178.59v3.22a7.9,7.9,0,0,1-1.51.65v-3.22a7.9,7.9,0,0,0,1.51-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M365.37,179.24v3.22a9.28,9.28,0,0,1-1.31.32v-3.22a10.89,10.89,0,0,0,1.31-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M364.06,179.56v3.22c-.29.05-.58.09-.88.12v-3.22c.3,0,.59-.07.88-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M363.18,179.68v3.22c-.25,0-.51,0-.77,0v-3.22l.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M362.41,179.73V183c-.23,0-.47,0-.7,0v-3.22c.24,0,.48,0,.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M361.7,179.73V183q-.34,0-.69,0V179.7l.68,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M361,179.7v3.22l-.67-.07v-3.23c.22,0,.45.06.67.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M360.35,179.62v3.23l-.68-.12v-3.22l.68.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M359.67,179.51v3.22l-.72-.17v-3.22l.72.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M359,179.34v3.22c-.29-.08-.57-.18-.84-.28v-3.22c.27.1.55.2.84.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M358.11,179.06v3.22a7.66,7.66,0,0,1-1-.47v-3.22a7.66,7.66,0,0,0,1,.47Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M401.88,153.16c2.71,1.53,2.72,4,0,5.54l-35,19.89a11,11,0,0,1-9.77,0L321.85,158.7c-2.71-1.53-2.72-4,0-5.54l35-19.89a11,11,0,0,1,9.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M375.9,147.51c7.47,4.31,7.51,11.29.09,15.6s-19.47,4.31-26.93,0-7.5-11.29-.09-15.6S368.44,143.2,375.9,147.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349,147.51c7.41-4.31,19.47-4.31,26.93,0,3.39,2,5.25,4.47,5.57,7,.39-3.1-1.46-6.28-5.57-8.65-7.46-4.31-19.52-4.31-26.93,0-4.05,2.35-5.87,5.5-5.48,8.57C343.81,151.93,345.64,149.45,349,147.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M376.73,154.16V155c0,2.1-1.38,4.19-4.14,5.8C367,164,358,164,352.45,160.79c-2.81-1.62-4.21-3.75-4.21-5.88v-.83c0,2.12,1.4,4.25,4.21,5.87,5.58,3.22,14.59,3.22,20.14,0C375.34,158.35,376.72,156.26,376.73,154.16Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M376.73,154.16v.12s0-.08,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M376.72,154.28v.84a5.58,5.58,0,0,1-.09.81v-.83a4.48,4.48,0,0,0,.09-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M376.63,155.1v.83a6.15,6.15,0,0,1-.23.81v-.84a4.55,4.55,0,0,0,.23-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M376.4,155.9v.84a5.9,5.9,0,0,1-.38.81v-.84a5.4,5.4,0,0,0,.38-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M376,156.71v.84a8.41,8.41,0,0,1-.57.85v-.84a6.31,6.31,0,0,0,.57-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M375.45,157.56v.84a9.76,9.76,0,0,1-.89.95v-.84a7.17,7.17,0,0,0,.89-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M374.56,158.51v.84a10.77,10.77,0,0,1-1.8,1.33v-.83a11.38,11.38,0,0,0,1.8-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M372.76,159.85v.83l-.18.11a16.64,16.64,0,0,1-3.12,1.37v-.84a16.11,16.11,0,0,0,3.13-1.37l.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M369.46,161.32v.84a21.15,21.15,0,0,1-2.69.67V162a20.75,20.75,0,0,0,2.69-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M366.77,162v.83c-.6.11-1.21.19-1.82.25v-.83c.61-.06,1.22-.15,1.82-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M365,162.25v.83c-.52,0-1.05.09-1.58.11v-.84c.53,0,1.06,0,1.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M363.37,162.35v.84c-.49,0-1,0-1.46,0v-.83c.49,0,1,0,1.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M361.91,162.36v.83c-.47,0-.94,0-1.4-.07v-.83c.47,0,.93.06,1.4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M360.51,162.29v.83c-.47,0-.93-.09-1.39-.16v-.83c.45.07.92.12,1.38.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M359.13,162.13V163q-.71-.09-1.41-.24v-.83q.69.13,1.41.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M357.72,161.89v.83c-.5-.11-1-.23-1.48-.37v-.83c.49.14,1,.26,1.49.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M356.23,161.52v.83a16,16,0,0,1-1.73-.58v-.83c.56.22,1.14.41,1.73.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M354.5,160.94v.83a14.89,14.89,0,0,1-2.05-1c-2.81-1.62-4.21-3.75-4.21-5.88v-.83c0,2.12,1.4,4.25,4.21,5.87a16.19,16.19,0,0,0,2.05,1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M372.52,148.29c5.58,3.22,5.61,8.44.07,11.66s-14.56,3.22-20.14,0-5.61-8.44-.07-11.66S366.94,145.07,372.52,148.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M371.08,148.86c4.78,2.75,4.8,7.22.05,10s-12.46,2.76-17.24,0-4.8-7.23-.05-10S366.3,146.1,371.08,148.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M331.18,133.78l1.6.93a1,1,0,0,1-.43-1l-1.6-.92A1.06,1.06,0,0,0,331.18,133.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "332.35 133.75 330.75 132.83 330.75 132.83 332.35 133.76 332.35 133.75 332.35 133.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M332.35,133.76l-1.6-.93a1.37,1.37,0,0,0,0,.36l1.6.93a1.37,1.37,0,0,1,0-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M332.39,134.12l-1.6-.93a.86.86,0,0,0,.39.59l1.6.93a.88.88,0,0,1-.39-.59Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M355.46,73.75l-1.6-.92a1,1,0,0,0-1.05.1l1.59.93A1.07,1.07,0,0,1,355.46,73.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M355.46,73.75l-1.6-.92a.75.75,0,0,0-.45-.1l1.59.93a.76.76,0,0,1,.46.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M355,73.66l-1.59-.93a1.32,1.32,0,0,0-.32.07l1.6.92a1.21,1.21,0,0,1,.31-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M354.69,73.72l-1.6-.92a1.17,1.17,0,0,0-.28.13l1.59.93a2.53,2.53,0,0,1,.29-.14Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "332.22 88.38 330.62 87.45 330.75 132.83 332.35 133.75 332.22 88.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "354.4 73.86 352.81 72.93 332.1 84.88 333.7 85.81 354.4 73.86"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M333.7,85.81l-1.6-.93a3.28,3.28,0,0,0-1.48,2.57l1.6.93A3.28,3.28,0,0,1,333.7,85.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M333.7,85.81l-1.6-.93h0l1.59.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M333.68,85.82l-1.59-.93-.33.23,1.6.93a2.35,2.35,0,0,1,.32-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M333.36,86.05l-1.6-.93c-.11.1-.21.2-.31.31l1.6.93a3,3,0,0,1,.31-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M333.05,86.36l-1.6-.93a3.52,3.52,0,0,0-.57.9l1.6.93a3.35,3.35,0,0,1,.57-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M332.48,87.26l-1.6-.93a2.79,2.79,0,0,0-.14.37l1.6.93a2.35,2.35,0,0,1,.14-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M332.34,87.63l-1.6-.93a2.74,2.74,0,0,0-.09.39l1.6.93a2.74,2.74,0,0,1,.09-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M332.25,88l-1.6-.93a2.19,2.19,0,0,0,0,.36l1.6.93a2.19,2.19,0,0,1,0-.36Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M333.7,85.81a3.28,3.28,0,0,0-1.48,2.57l.13,45.37c0,.95.67,1.33,1.49.85l20.7-11.95a3.26,3.26,0,0,0,1.48-2.56l-.13-45.38c0-.95-.67-1.33-1.49-.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "332.22 90.05 332.34 132.35 356 118.69 355.88 76.39 332.22 90.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M342.91,81.78a.94.94,0,0,0-.42.72c0,.27.19.38.42.24l4.89-2.82a.9.9,0,0,0,.41-.72c0-.26-.19-.37-.41-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M341.42,82.53a1.26,1.26,0,0,0-.58,1c0,.37.26.52.58.34a1.3,1.3,0,0,0,.58-1C342,82.49,341.74,82.34,341.42,82.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "355.88 76.39 355.89 78.98 332.23 92.64 332.22 90.05 355.88 76.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "335.48 88.76 335.48 90.36 337.27 89.32 335.48 88.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M338.1,87.1a2.35,2.35,0,0,0-.89,1l.89.74.89-1.77S338.73,86.74,338.1,87.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "333.99 89.29 333.99 89.56 333.99 89.6 334.39 89.37 334.39 89.33 334.39 89.06 333.99 89.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "333.85 90.09 333.85 91.27 334.55 90.87 334.55 89.69 334.51 89.71 333.86 90.08 333.85 90.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M334,89.6l.4-.23v0l.19-.11v1.67l-.78.44V89.67l.19-.11Zm-.14,1.67.7-.4V89.69l0,0v-.38l-.65.38v.37h0v1.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "332.22 90.05 331.33 89.54 331.33 92.12 332.23 92.64 332.22 90.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M351.68,79.62v1.16l-.2.11V80a1.19,1.19,0,0,1-.25.29l0-.19a1.12,1.12,0,0,0,.31-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M352.56,79.82l.16-.09v.17l-.16.1v.27l-.19.11v-.27l-.49.28v-.16l.05-.13.38-.84.25-.15Zm-.19-.27a1,1,0,0,1,0-.17h0a1.8,1.8,0,0,1-.08.21l-.21.47,0,0,.31-.18v-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M353,79.74c.08,0,.13,0,.13.07A.26.26,0,0,1,353,80c-.08,0-.14,0-.14-.07A.27.27,0,0,1,353,79.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M353,79.4c-.09,0-.14,0-.14-.06a.24.24,0,0,1,.14-.22c.08-.05.13,0,.13.06A.26.26,0,0,1,353,79.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M354,78.28v.19l-.45.26,0,.3v0a.58.58,0,0,1,.22-.22c.19-.11.31,0,.31.18a.71.71,0,0,1-.38.62c-.17.11-.29.09-.37,0l.19-.23c0,.09.08.13.19.07a.35.35,0,0,0,.18-.3c0-.13-.07-.16-.18-.09a.37.37,0,0,0-.18.19l-.17.06.06-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M354.61,77.91c.26-.15.4,0,.4.36a.89.89,0,0,1-.4.83c-.26.15-.4,0-.4-.36A.89.89,0,0,1,354.61,77.91Zm0,1c.13-.08.19-.24.19-.51s-.06-.37-.19-.3-.19.24-.19.52.06.36.19.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "332.22 90.05 331.33 89.54 331.33 131.78 332.34 132.35 332.22 90.05"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M355.81,80.19c1.21-.7,2.19-.14,2.2,1.26l.08,30.34a4.81,4.81,0,0,1-2.18,3.79l-18.55,10.71c-1.21.7-2.2.14-2.2-1.26l-.09-30.34a4.85,4.85,0,0,1,2.19-3.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M358.06,81c1.21-.7,2.19-.14,2.2,1.26l.08,30.34a4.81,4.81,0,0,1-2.18,3.79l-18.55,10.71c-1.21.7-2.2.14-2.2-1.26l-.09-30.34a4.85,4.85,0,0,1,2.19-3.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "344.71 119.56 344.71 120.5 355.8 114.1 355.8 113.17 344.71 119.56"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "340.89 114.52 340.89 115.43 358.46 105.29 358.46 104.37 340.89 114.52"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "340.89 118.36 340.89 119.27 358.46 109.13 358.46 108.21 340.89 118.36"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M349.65,90.29c3.85-2.22,7-.43,7,4a15.3,15.3,0,0,1-6.94,12c-3.85,2.22-7,.44-7-4A15.33,15.33,0,0,1,349.65,90.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M350,92.71c2.81-1.63,5.11-.32,5.12,2.92a11.19,11.19,0,0,1-5.09,8.8c-2.82,1.63-5.11.32-5.12-2.91A11.19,11.19,0,0,1,350,92.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M347.8,100.13l0,0a2,2,0,0,0,.64-.9,2.28,2.28,0,0,1,.76-1,5.92,5.92,0,0,0,1.87-1.94c.14.68.63.39,1,.55s.14.33,1,.23l.05,0c.33-.19.6,0,.6.34a1.33,1.33,0,0,1-.6,1l-.06,0a6.58,6.58,0,0,1-2.63,4.13,1.64,1.64,0,0,1-2.61-1.11l-.1.07c-.33.19-.6,0-.6-.35a1.3,1.3,0,0,1,.59-1Zm2.62,1.51a1.64,1.64,0,0,0,.74-1.28l-1.48.86c0,.47.34.66.74.42Zm1.59-3.3c0-.34-.23-.47-.52-.3a1.14,1.14,0,0,0-.53.9c0,.33.24.47.53.3s0-1.2.52-.9Zm-2.65,2.13a1.15,1.15,0,0,0,.52-.9c0-.34-.23-.47-.52-.3a1.13,1.13,0,0,0-.52.9c0,.33.23.47.52.3Zm-.55-1.25s.08,0,.18,0a1.08,1.08,0,0,0,.26-.21c.22-.2.38-.44.35-.52s-.08,0-.18,0a1.3,1.3,0,0,0-.26.2c-.22.21-.38.44-.35.52Zm2.84-2a.67.67,0,0,0-.26.1.3.3,0,0,0-.18.19c0,.11.13.16.35.11a1.17,1.17,0,0,0,.26-.1.3.3,0,0,0,.18-.19c0-.11-.13-.16-.35-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.49,98.35a.54.54,0,0,0-.25.43.3.3,0,0,0,0,.1.21.21,0,0,1,.1-.14c.06,0,.1,0,.1.06a.23.23,0,0,1-.06.16l.09,0a.54.54,0,0,0,.25-.42C351.74,98.34,351.63,98.27,351.49,98.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M352,98.34a1.15,1.15,0,0,1-.52.9c-.29.17-.52,0-.53-.3a1.14,1.14,0,0,1,.53-.9C351.78,97.87,352,98,352,98.34Zm-.52.73a.83.83,0,0,0,.38-.65c0-.24-.17-.34-.38-.22a.84.84,0,0,0-.38.66c0,.24.17.34.38.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M351.87,98.42a.83.83,0,0,1-.38.65c-.21.13-.38,0-.38-.21a.84.84,0,0,1,.38-.66C351.7,98.08,351.87,98.18,351.87,98.42Zm-.62.51c0,.07.05.09.11.06l0,0,.09,0a.54.54,0,0,0,.25-.42c0-.16-.11-.23-.25-.15a.54.54,0,0,0-.25.43.3.3,0,0,0,0,.1.07.07,0,0,0,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M351.36,98.74a.21.21,0,0,0-.1.14.07.07,0,0,0,0,.05c0,.07.05.09.11.06l0,0a.23.23,0,0,0,.06-.16C351.46,98.74,351.42,98.71,351.36,98.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M349.68,101.22c0,.47.34.66.74.42a1.64,1.64,0,0,0,.74-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M349.23,100a.21.21,0,0,0-.1.14.07.07,0,0,0,0,0c0,.07.05.09.11.06s0,0,0,0a.23.23,0,0,0,.07-.15C349.34,100,349.29,99.94,349.23,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.36,99.58a.54.54,0,0,0-.25.43.3.3,0,0,0,0,.1.21.21,0,0,1,.1-.14c.06,0,.11,0,.11.06a.23.23,0,0,1-.07.15.16.16,0,0,0,.09,0,.54.54,0,0,0,.25-.43C349.61,99.57,349.5,99.5,349.36,99.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M349.88,99.57a1.15,1.15,0,0,1-.52.9c-.29.17-.52,0-.52-.3a1.13,1.13,0,0,1,.52-.9C349.65,99.1,349.88,99.23,349.88,99.57Zm-.52.73a.83.83,0,0,0,.38-.65c0-.24-.17-.34-.38-.22a.84.84,0,0,0-.38.66c0,.24.17.33.38.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M349.17,96.71a3.92,3.92,0,0,0-1.37,3.42l0,0a2,2,0,0,0,.64-.9,2.24,2.24,0,0,1,.75-1,6,6,0,0,0,1.88-2c.14.68.63.39,1,.55s.14.33,1,.23a2.54,2.54,0,0,0,0-.29c-.19-1.23-.55-1.59-1.25-1.52a4.17,4.17,0,0,1-.26.37s-.69.48-1.25.8c-.18.11-.35.19-.47.25A.67.67,0,0,1,349.17,96.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M353.07,97.08c0-.09,0-.19,0-.29A2.54,2.54,0,0,1,353.07,97.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M349.42,98.5a1.3,1.3,0,0,0-.26.2c-.22.21-.38.44-.35.52s.08,0,.18,0a1.08,1.08,0,0,0,.26-.21c.22-.2.38-.44.35-.52S349.52,98.44,349.42,98.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M349.74,99.65a.83.83,0,0,1-.38.65c-.21.12-.38,0-.38-.21a.84.84,0,0,1,.38-.66C349.57,99.31,349.74,99.41,349.74,99.65Zm-.62.51c0,.07.05.09.11.06s0,0,0,0a.16.16,0,0,0,.09,0,.54.54,0,0,0,.25-.43c0-.15-.11-.22-.25-.14a.54.54,0,0,0-.25.43.3.3,0,0,0,0,.1.07.07,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M351.39,97.32a.3.3,0,0,0-.18.19c0,.11.13.16.35.11a1.17,1.17,0,0,0,.26-.1.3.3,0,0,0,.18-.19c0-.11-.13-.16-.35-.11A.67.67,0,0,0,351.39,97.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M348.81,96.13c.09.6.35,1,.82.79.17-.08.34-.24.52-.34.57-.32,1.22-.78,1.26-.8a3.45,3.45,0,0,0,.25-.37c.91-1.48.08-2-1.14-1.57A2.37,2.37,0,0,0,348.81,96.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M335.35,93.69a2.79,2.79,0,0,0-1.25,2.17c0,.8.57,1.12,1.26.72a2.77,2.77,0,0,0,1.25-2.17C336.61,93.62,336,93.29,335.35,93.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M328.24,97.8A2.72,2.72,0,0,0,327,100c0,.79.56,1.12,1.26.72a2.79,2.79,0,0,0,1.25-2.17C329.49,97.72,328.93,97.4,328.24,97.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M331.8,95.74a2.79,2.79,0,0,0-1.26,2.18c0,.79.57,1.12,1.26.71a2.74,2.74,0,0,0,1.25-2.16C333.05,95.67,332.49,95.34,331.8,95.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M339.18,97.44l1.76,1.79-3.77.94-12.72,7.35,0-12.15,14.74-8.51Zm-7.38,1.19a2.74,2.74,0,0,0,1.25-2.16c0-.8-.56-1.13-1.25-.73a2.79,2.79,0,0,0-1.26,2.18c0,.79.57,1.12,1.26.71Zm-3.55,2.06a2.79,2.79,0,0,0,1.25-2.17c0-.8-.57-1.12-1.26-.72A2.72,2.72,0,0,0,327,100c0,.79.56,1.12,1.26.72Zm7.11-4.11a2.77,2.77,0,0,0,1.25-2.17c0-.79-.57-1.12-1.26-.72a2.79,2.79,0,0,0-1.25,2.17c0,.8.57,1.12,1.26.72Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M378.79,83.87a3.67,3.67,0,0,1,1.66,2.87l0,8.43c0,1.06-.75,1.48-1.67,1l-8.28-4.78-2.85,2-.24-3.82-.29-.17a3.67,3.67,0,0,1-1.66-2.87l0-8.43c0-1.06.75-1.48,1.66-1Zm-.7,10.06,0-8.83-10.32-6,0,8.83,10.32,6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "378.11 85.1 372.94 86.54 367.79 79.14 378.11 85.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "378.11 85.1 378.09 93.93 367.77 87.97 367.79 79.14 372.94 86.54 378.11 85.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M368.41,150.52c3.2,1.85,3.22,4.85,0,6.7a12.69,12.69,0,0,1-11.57,0c-3.21-1.85-3.23-4.85,0-6.7A12.77,12.77,0,0,1,368.41,150.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M357.42,98.7c-.61-.43-1-3.48-2.08-3.91s-2.09-.94-2.19-.65c-.17.46,1.73,1.14,1.68,1.59s-.76,1.49.1,2.22a3.79,3.79,0,0,1,1.16,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M368.31,109s-4.25-2.86-6.58-4.89a22.77,22.77,0,0,1-4.34-6l-2,.91a29,29,0,0,0,3.71,6.88c2.09,2.49,7.53,6.12,7.53,6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M363.63,154.25c.22.93.32,2.79-.83,2.78-2.06,0-1.47-1.14-2.81-1.39-3-.56-3.47-2.67-2.85-3.24s1.54,0,2.34.33c.48.21,2.41.92,2.41.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M363.68,154c.21.92.31,2.79-.83,2.77-2.07,0-1.48-1.14-2.82-1.39-3-.56-3.47-2.66-2.84-3.24s1.53,0,2.34.33c.47.22,2.4.93,2.4.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M367.81,152.87c.22.92.32,2.79-.83,2.77-2.07,0-1.48-1.14-2.82-1.39-3-.55-3.47-2.66-2.84-3.23s1.53-.05,2.34.32c.47.22,2.41.93,2.41.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.85,152.59c.22.93.32,2.79-.83,2.78-2.07,0-1.48-1.14-2.82-1.39-3-.56-3.47-2.67-2.84-3.24s1.53,0,2.34.33c.48.21,2.41.92,2.41.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M360.72,97.27c-1.23,0-1.33,1.23-1.34,1.77s.25,1.25.2,1.64a5.7,5.7,0,0,0-.1,1.8c.12.63,0,2.31,1.52,2.24,1.11,0,.3,2.09.3,2.09a3.34,3.34,0,0,0,2.08,1.06,4.07,4.07,0,0,0,2.2-.86s-1-2.21-.71-3.5a32.09,32.09,0,0,0,0-5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M364.87,103.51c0-.17.06-.39.08-.63l-1.22-.12a3.39,3.39,0,0,1-2.2,2.33,3.58,3.58,0,0,1-.23,1.72,3.69,3.69,0,0,0,.44.4c.69,0,3.26.09,3.33,0s.18-.23.39-.52A6.63,6.63,0,0,1,364.87,103.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.83,122.09s1.69,2.14.89,7.12-1.31,7.74-.93,10.27-.92,8.44-.7,10.77-.32,2.88-1,2.95-2.81.24-2.8-.74-.11-5.66-.31-7a35.34,35.34,0,0,1-.25-6.86c.13-2,0-3.87.13-6.26.18-2.86.86-7,.51-9.14C363.75,119.71,368.83,122.09,368.83,122.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M366.51,122.22s1.05,1.56.61,5.95c-.28,2.79-2.25,6.56-2.17,8.74a34.58,34.58,0,0,1-.12,8.27c-.58,3-.36,6.58-1,9.43-1.64.27-3.21-.42-3.3-.74-.17-.64-.17-4.53-.79-7.47a61.26,61.26,0,0,1-.83-13.69c.2-2.29-.34-4.59.11-9.61C359.39,119.35,366.51,122.22,366.51,122.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M367.89,105.29a4.73,4.73,0,0,0-2.85.52,7.05,7.05,0,0,1-2.94.64c-1.45,0-4.28.2-4.59,1.66s.67,7.6,1.14,9.35,0,5.93.34,6.49c.44.74,4.56.48,7.45.07s3.05-.52,2.95-3.18a30.32,30.32,0,0,1,.08-6.27C369.83,111.57,369.92,105.9,367.89,105.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M350.12,113.15a2.23,2.23,0,0,1-.89-.64c-.34-.44-1.08-2.1-1.54-1.9s.42,1,.21,1.15c-.43.27-2-2.2-2.38-2s.87,1.26.7,1.37a.48.48,0,0,0-.21.53c.08.16-.08.16-.14.36s.16.23.09.33a.37.37,0,0,0,0,.45,3.71,3.71,0,0,0,1.84,1.21c1.12.09,1.32.6,1.32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M358.54,107c2.11-.74,3.83,3,4.13,6.76.26,3.28-.61,5.14-1.77,6-2.8,2.06-12.29-5.28-12.29-5.28l1.09-1.81,8.3,3.21S356,107.88,358.54,107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M366.07,100.49a1.5,1.5,0,0,0,0-1.54c-.23-.31-.13-.44-.13-.93a1.06,1.06,0,0,0-1.08-.89c-.44.09-.63-.21-1-.57s-1.09,0-1.4,0-.37-.34-.72-.41c-.77-.16-.92.62-1.33.75-.59.17-.92,0-1.17.51-.35.79.35,1,.3,1.35a1.31,1.31,0,0,0,.77,1.17c.75.45,1.13.23,1.18.85,0,.22,0,.4,0,.82h0c.05.74.12.88-.29,1.07a3.76,3.76,0,0,1-1.72.13,2.38,2.38,0,0,0,.56,1.75,1.77,1.77,0,0,0,1.93,0c.56-.35.56-1.62.56-1.77,0-.44-.49-.49-.51-1.13l0-1.34s.49-.46.84,0-.57,1.18-.22,1.81a3.85,3.85,0,0,0,1.29,1.27c.43.23.59.66.92.34a3.59,3.59,0,0,1,.53-1c.42-.32.74-.92.58-1.27A.86.86,0,0,1,366.07,100.49Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M371,114.32c4.73,2.73,4.75,7.16.05,9.89s-12.34,2.74-17.07,0-4.76-7.16-.06-9.89S366.26,111.59,371,114.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M371,120.08c4.74,2.73,4.76,7.17.05,9.9s-12.36,2.74-17.1,0-4.76-7.18,0-9.91S366.27,117.34,371,120.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M371,125.83c4.75,2.74,4.77,7.19.06,9.93s-12.39,2.74-17.13,0-4.77-7.19-.06-9.93S366.28,123.09,371,125.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M371,131.59c4.75,2.74,4.77,7.19,0,9.94s-12.4,2.74-17.16,0-4.78-7.2-.05-9.94S366.28,128.84,371,131.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M371.05,137.34c4.76,2.75,4.79,7.21.05,10s-12.42,2.75-17.18,0-4.79-7.21-.06-10S366.29,134.6,371.05,137.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M371.06,143.1c4.77,2.75,4.8,7.22.06,10s-12.45,2.76-17.21,0-4.8-7.22-.06-10S366.3,140.35,371.06,143.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M371.08,148.86c4.78,2.75,4.8,7.22.05,10s-12.46,2.76-17.24,0-4.8-7.23-.05-10S366.3,146.1,371.08,148.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M202,159.61c4.78,2.76,4.8,7.24.05,10l-61.85,35.95c-4.75,2.76-12.47,2.76-17.25,0L60.63,169.61c-4.78-2.76-4.8-7.24-.06-10l61.86-35.94c4.75-2.76,12.48-2.76,17.26,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M205.55,142.64l0,5.82c0,1.8-1.18,3.6-3.54,5v-5.82C204.36,146.24,205.55,144.44,205.55,142.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M205.55,142.64l0,5.82v.11l0-5.82v-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M205.55,142.75l0,5.82a3.34,3.34,0,0,1-.08.7l0-5.82a4.17,4.17,0,0,0,.08-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M205.47,143.45l0,5.82a4.43,4.43,0,0,1-.19.69v-5.82a4.48,4.48,0,0,0,.2-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M205.27,144.14V150a5.41,5.41,0,0,1-.33.69l0-5.82a5.32,5.32,0,0,0,.32-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M205,144.83l0,5.82a5.48,5.48,0,0,1-.49.73v-5.82a5.57,5.57,0,0,0,.5-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M204.45,145.56v5.82a7.17,7.17,0,0,1-.76.82l0-5.82a7.05,7.05,0,0,0,.75-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M203.7,146.38l0,5.82a9.15,9.15,0,0,1-1.55,1.14l0-5.82a9.57,9.57,0,0,0,1.55-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M202.15,147.52l0,5.82-.14.09v-5.82l.15-.09Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M57,148.4l0-5.82c0,1.82,1.2,3.64,3.6,5l0,5.82C58.21,152,57,150.22,57,148.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M60.63,147.61l0,5.82c-2.4-1.39-3.6-3.21-3.6-5l0-5.82c0,1.82,1.2,3.64,3.6,5Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "202 147.61 201.99 153.43 140.13 189.38 140.15 183.56 202 147.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "122.89 183.56 122.88 189.38 60.62 153.43 60.63 147.61 122.89 183.56"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M140.15,183.56l0,5.82c-4.75,2.76-12.47,2.76-17.25,0l0-5.82C127.68,186.32,135.4,186.32,140.15,183.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M140.15,183.56l0,5.82a13.73,13.73,0,0,1-2.67,1.17v-5.82a14.1,14.1,0,0,0,2.68-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M137.47,184.73v5.82a19,19,0,0,1-2.31.58l0-5.82a18.87,18.87,0,0,0,2.3-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M135.17,185.31l0,5.82q-.77.13-1.56.21l0-5.82q.78-.08,1.56-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M133.61,185.52l0,5.82q-.68.07-1.35.09l0-5.82q.68,0,1.35-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M132.26,185.61l0,5.82c-.42,0-.83,0-1.25,0l0-5.82c.41,0,.83,0,1.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M131,185.62l0,5.82c-.4,0-.8,0-1.2-.07l0-5.81c.39,0,.8.05,1.2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M129.81,185.56l0,5.81c-.4,0-.8-.07-1.19-.13l0-5.82c.39.06.79.1,1.19.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M128.62,185.42l0,5.82c-.4-.06-.81-.13-1.21-.21l0-5.82c.4.08.8.15,1.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M127.41,185.21l0,5.82c-.43-.09-.85-.19-1.27-.31l0-5.82c.41.12.84.22,1.27.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M126.14,184.9l0,5.82c-.51-.15-1-.31-1.48-.5l0-5.82a13.53,13.53,0,0,0,1.48.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M124.66,184.4l0,5.82a13.6,13.6,0,0,1-1.76-.84l0-5.82a13.6,13.6,0,0,0,1.76.84Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M202,137.61c4.78,2.76,4.8,7.24.05,10l-61.85,35.95c-4.75,2.76-12.47,2.76-17.25,0L60.63,147.61c-4.78-2.76-4.8-7.24-.06-10l61.86-35.94c4.75-2.76,12.48-2.76,17.26,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "131.09 91.6 131.06 100.92 130.97 100.86 130.91 100.83 130.93 91.51 131.09 91.6"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M140.92,106.8l1.59,2-1.59.14V106.8Zm.19.47v1.38l1-.09-1-1.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M183.52,89.76A5.47,5.47,0,0,1,186,94.05l-.13,44.49c0,1.57-1.12,2.21-2.49,1.42l-56.93-32.87A5.45,5.45,0,0,1,124,102.8l.13-44.49c0-1.58,1.11-2.21,2.49-1.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "179.37 127.61 179.37 128.26 167.04 121.14 167.04 120.5 179.37 127.61"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "174.69 121.22 174.69 121.87 167.04 117.45 167.04 116.81 174.69 121.22"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "141.05 107.79 141.05 108.04 125.54 99.08 125.54 98.84 141.05 107.79"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M178.78,94a5.44,5.44,0,0,1,2.47,4.29l-.12,44.49c0,1.57-1.13,2.21-2.5,1.42L121.7,111.36a5.47,5.47,0,0,1-2.47-4.29l.12-44.49c0-1.58,1.12-2.21,2.49-1.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "151.45 95.03 151.67 95.16 151.67 95.29 151.66 99.16 151.44 99.03 151.45 95.16 151.45 95.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "154.74 96.94 154.96 97.06 154.96 97.19 154.95 101.06 154.73 100.94 154.74 97.06 154.74 96.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "158.03 98.84 158.25 98.96 158.25 99.09 158.24 102.96 158.02 102.84 158.03 98.96 158.03 98.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "161.5 116.47 161.51 112.94 161.73 113.06 161.72 116.59 161.5 116.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "148.09 116.09 148.1 112.77 148.32 112.9 148.31 116.21 148.31 116.34 148.09 116.21 148.09 116.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "154.68 119.89 154.69 116.58 154.91 116.7 154.9 120.02 154.9 120.14 154.68 120.02 154.68 119.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "151.39 114.42 151.4 110.89 151.62 111.02 151.61 114.55 151.39 114.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "148.11 108.74 148.12 105.2 148.34 105.33 148.33 108.86 148.11 108.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "157.97 121.79 157.98 118.48 158.2 118.6 158.19 121.92 158.19 122.04 157.97 121.92 157.97 121.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "154.69 116.33 154.7 112.79 154.92 112.92 154.91 116.45 154.69 116.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "148.12 104.95 148.13 101.42 148.35 101.55 148.34 105.08 148.12 104.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "157.98 118.22 157.99 114.69 158.21 114.82 158.2 118.35 157.98 118.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "151.42 106.85 151.43 103.32 151.65 103.45 151.63 106.98 151.42 106.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "161.48 123.82 161.49 120.51 161.71 120.63 161.7 123.94 161.7 124.07 161.48 123.94 161.48 123.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "157.99 114.44 158 110.91 158.22 111.03 158.21 114.57 157.99 114.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "151.43 103.07 151.44 99.29 151.66 99.41 151.65 103.2 151.43 103.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "148.16 93.13 148.38 93.26 148.37 93.39 148.36 97.26 148.14 97.13 148.16 93.26 148.16 93.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "165.01 118.5 165.01 118.75 164.9 118.68 161.72 116.85 161.5 116.72 158.21 114.82 157.99 114.69 154.92 112.92 154.7 112.79 151.62 111.02 151.4 110.89 148.33 109.11 148.11 108.99 145.04 107.22 144.93 107.15 144.93 106.9 145.04 106.96 148.11 108.74 148.33 108.86 151.41 110.64 151.62 110.77 154.7 112.54 154.92 112.67 157.99 114.44 158.21 114.57 161.5 116.47 161.72 116.59 164.9 118.43 165.01 118.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "158.01 106.87 158.02 103.09 158.24 103.22 158.23 107 158.01 106.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "148.1 112.52 148.11 108.99 148.33 109.11 148.32 112.65 148.1 112.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "165.03 110.93 165.03 111.18 164.92 111.12 161.74 109.28 161.52 109.15 158.23 107.25 158.01 107.13 154.94 105.35 154.72 105.22 151.65 103.45 151.43 103.32 148.35 101.55 148.13 101.42 145.06 99.65 144.95 99.58 144.95 99.33 145.06 99.4 148.13 101.17 148.35 101.3 151.43 103.07 151.65 103.2 154.72 104.97 154.94 105.1 158.01 106.87 158.23 107 161.53 108.9 161.74 109.03 164.93 110.86 165.03 110.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "151.41 110.64 151.41 107.11 151.63 107.23 151.62 110.77 151.41 110.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "165.04 106.89 165.04 107.14 164.94 107.08 161.75 105.24 161.53 105.12 158.24 103.22 158.02 103.09 154.95 101.31 154.73 101.19 151.66 99.41 151.44 99.29 148.36 97.51 148.14 97.39 145.07 95.61 144.96 95.55 144.96 95.3 145.07 95.36 148.14 97.13 148.36 97.26 151.44 99.03 151.66 99.16 154.73 100.94 154.95 101.06 158.02 102.84 158.24 102.96 161.54 104.86 161.75 104.99 164.94 106.83 165.04 106.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "165.02 114.71 165.02 114.96 164.91 114.9 161.73 113.06 161.51 112.94 158.22 111.03 158 110.91 154.93 109.13 154.71 109.01 151.63 107.23 151.41 107.11 148.34 105.33 148.12 105.2 145.05 103.43 144.94 103.37 144.94 103.11 145.05 103.18 148.12 104.95 148.34 105.08 151.42 106.85 151.63 106.98 154.71 108.75 154.93 108.88 158 110.66 158.22 110.78 161.51 112.68 161.73 112.81 164.91 114.65 165.02 114.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "161.55 100.86 161.77 100.99 161.77 101.12 161.75 104.99 161.54 104.86 161.55 100.99 161.55 100.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M144.86,91.11l-.06,23.33,20.3,11.72.07-23.33Zm20.18,16-.1-.06v3.78l.1.07v.25l-.11-.06v3.53h0l.11.06V115l-.11-.06v3.53l.11.06v.26l-.11-.07v3.54l.11.06v.25l-.11-.06v3.31l-3.18-1.84v.13l-.22-.13v-.12l-3.29-1.9V122l-.22-.12v-.13L154.9,120v.12l-.22-.12v-.13l-3.08-1.78v.13l-.22-.13V118l-3.07-1.78v.13l-.22-.13v-.12L145,114.31V111l-.11-.06v-.26l.11.07v-3.53l-.11-.07v-.25l.11.06v-3.53l-.11-.06v-.26l.11.07V99.65l-.11-.07v-.25l.11.07V95.61l-.11-.06V95.3l.11.06V91.49l3.08,1.77v-.13l.21.13v.13l3.08,1.77V95l.22.13v.13l3.07,1.77v-.12l.22.12v.13L158,99v-.12l.22.12v.13l3.3,1.9v-.13l.22.13v.13L165,103v3.88l.11.06v.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "151.38 117.99 151.39 114.67 151.61 114.8 151.6 118.11 151.6 118.24 151.38 118.11 151.38 117.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "154.7 112.54 154.71 109.01 154.93 109.13 154.92 112.67 154.7 112.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "148.13 101.17 148.14 97.39 148.36 97.51 148.35 101.3 148.13 101.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "154.71 108.75 154.72 105.22 154.94 105.35 154.93 108.88 154.71 108.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "161.49 120.25 161.5 116.72 161.72 116.85 161.71 120.38 161.49 120.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "165 122.28 165 122.53 164.89 122.47 161.71 120.63 161.49 120.51 158.2 118.6 157.98 118.48 154.91 116.7 154.69 116.58 151.61 114.8 151.39 114.67 148.32 112.9 148.1 112.77 145.03 111 144.92 110.94 144.92 110.68 145.03 110.75 148.1 112.52 148.32 112.65 151.39 114.42 151.61 114.55 154.69 116.33 154.91 116.45 157.98 118.22 158.2 118.35 161.49 120.25 161.71 120.38 164.89 122.22 165 122.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "158 110.66 158.01 107.13 158.23 107.25 158.22 110.78 158 110.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "154.72 104.97 154.73 101.19 154.95 101.31 154.94 105.1 154.72 104.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "161.51 112.68 161.52 109.15 161.74 109.28 161.73 112.81 161.51 112.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "161.53 108.9 161.53 105.12 161.75 105.24 161.74 109.03 161.53 108.9"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "157.66 91.01 157.66 91.65 145.33 84.53 145.33 83.89 157.66 91.01"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "153.15 90.83 153.14 91.48 145.49 87.06 145.5 86.42 153.15 90.83"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M177.83,94.85c0,6.87,0,10,0,10.17L159.12,94.24c0-.08,1-1.45,2.87-.36l.4.26c.25.18.49.34.71.47a3.24,3.24,0,0,0,3.9-.11,3.22,3.22,0,0,1,3.87-.12l.41.27.76.47C176,97.41,176.7,94.75,177.83,94.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "131.01 91.34 140.41 106.33 130.97 100.86 131.06 100.92 131.09 91.6 130.93 91.51 130.91 100.83 126.17 98.09 131.01 91.34"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "142.51 94.97 142.48 106.8 142.19 106.63 142.22 95.38 142.47 95.24 142.26 94.88 142.01 95.02 131.22 88.8 131.22 88.46 142.51 94.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "142.26 94.88 142.47 95.24 142.22 95.38 137.91 97.84 137.7 97.48 142.01 95.02 142.26 94.88"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M141.8,62.51a4.68,4.68,0,0,1,2.12,3.67L143.85,88c0,1.35-.95,1.89-2.13,1.21L118.57,75.85a4.66,4.66,0,0,1-2.11-3.67l.06-21.82c0-1.35,1-1.9,2.13-1.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "141.71 65.6 141.64 92.59 113.94 76.6 114.01 49.6 141.71 65.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M139.44,70l.21.41a4.63,4.63,0,0,0-2,1.78c-.4.57-.76,1.06-1.36,1.08a1,1,0,0,1-.51-.16,12.54,12.54,0,0,1-1.71-1.46,16.17,16.17,0,0,0-2.85-2.36,3.22,3.22,0,0,0-1.79-.52A3.13,3.13,0,0,0,127,70.66c-.68,1.08-1.28,2-3.13,1a10.19,10.19,0,0,1-1.31-.94,9,9,0,0,0-1-.69c-3.89-2.24-6.21,2.09-6.23,2.14l-.3-.33s2.43-4.55,6.53-2.18a7.07,7.07,0,0,1,1.06.74,9,9,0,0,0,1.23.87c1.66,1,2.2.11,2.85-.92a3.25,3.25,0,0,1,2.54-1.95,3.49,3.49,0,0,1,2,.56,17.38,17.38,0,0,1,3,2.43,10.79,10.79,0,0,0,1.6,1.39.76.76,0,0,0,.36.12c.51,0,.83-.46,1.23-1A4.71,4.71,0,0,1,139.44,70Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "138.75 69.77 140.3 69.31 139.77 71.04 138.75 69.77"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "119.76 70.32 119.73 79.02 119.49 78.88 119.51 70.17 119.76 70.32"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "124.97 73.32 124.95 82.03 124.7 81.89 124.72 73.18 124.97 73.32"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "136.24 74.47 136.22 83.18 135.97 83.03 136 74.33 136.24 74.47"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "130.19 69.72 130.16 78.42 129.91 78.28 129.94 69.57 130.19 69.72"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "139.79 71.58 139.76 80.28 139.52 80.14 139.54 71.43 139.79 71.58"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "185.15 121.77 185.06 153.22 167.73 143.22 167.82 111.76 185.15 121.77"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "171.48 124.37 171.48 122.02 171.69 122.14 171.68 124.48 171.48 124.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "176.59 124.73 176.6 122.38 176.8 122.5 176.79 124.85 176.59 124.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "179.04 126.14 179.05 123.8 179.25 123.92 179.25 126.26 179.04 126.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "183.79 131.47 183.79 131.71 183.68 131.65 181.48 130.38 181.28 130.26 179.24 129.08 179.03 128.96 176.79 127.67 176.58 127.55 174.13 126.13 173.93 126.02 171.68 124.72 171.48 124.6 169.18 123.28 169.08 123.22 169.08 122.98 169.18 123.04 171.48 124.37 171.68 124.48 173.93 125.78 174.13 125.9 176.58 127.31 176.79 127.43 179.03 128.73 179.24 128.85 181.28 130.03 181.49 130.14 183.68 131.41 183.79 131.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "179.06 121.32 179.26 121.44 179.26 121.56 179.25 123.68 179.05 123.56 179.06 121.44 179.06 121.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "183.8 126.31 183.8 126.54 183.7 126.48 181.5 125.21 181.29 125.1 179.25 123.92 179.05 123.8 176.8 122.5 176.6 122.38 174.15 120.97 173.94 120.85 171.69 119.55 171.49 119.44 169.19 118.11 169.09 118.05 169.09 117.82 169.2 117.88 171.49 119.2 171.7 119.32 173.94 120.62 174.15 120.73 176.6 122.15 176.8 122.27 179.05 123.56 179.25 123.68 181.29 124.86 181.5 124.98 183.7 126.25 183.8 126.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M169,115.4l14.91,8.6,0,10L169,125.43Zm14.8,11.14v-.23l-.1-.06v-2.13l-2.19-1.27v-.12l-.21-.11v.11l-2-1.18v-.11l-.2-.12v.12l-2.25-1.3V120l-.21-.12V120l-2.45-1.41v-.12l-.2-.12v.12l-2.25-1.3v-.12l-.2-.11v.11l-2.3-1.32v2.13l-.11-.06v.23l.11.06v2.35l-.1-.06v.23l.1.06V123l-.1-.06v.24l.1,0v2l2.3,1.33v.11l.2.12v-.12l2.25,1.3v.12l.2.12v-.12l2.45,1.41v.12l.2.12v-.12L179,131v.12l.2.12v-.12l2,1.18v.11l.21.12v-.12l2.2,1.27v-2l.11.06v-.24l-.11-.06v-2.35l.1.06v-.23l-.1-.06v-2.35l.1.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "171.47 126.64 171.47 126.75 171.67 126.87 171.68 126.75 171.68 124.72 171.48 124.6 171.47 126.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "173.92 128.05 173.93 126.02 174.13 126.13 174.13 128.17 174.13 128.29 173.92 128.17 173.92 128.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "171.48 121.78 171.49 119.44 171.69 119.55 171.69 121.9 171.48 121.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "173.93 125.78 173.93 123.43 174.14 123.55 174.13 125.9 173.93 125.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "176.58 129.59 176.58 127.55 176.79 127.67 176.78 129.7 176.78 129.82 176.58 129.7 176.58 129.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "173.94 123.2 173.94 120.85 174.15 120.97 174.14 123.31 173.94 123.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "176.58 127.31 176.59 124.97 176.79 125.08 176.79 127.43 176.58 127.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "179.03 131 179.03 128.96 179.24 129.08 179.23 131.12 179.23 131.24 179.03 131.12 179.03 131"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "181.27 132.3 181.28 130.26 181.48 130.38 181.48 132.41 181.48 132.53 181.27 132.41 181.27 132.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "179.03 128.73 179.04 126.38 179.25 126.5 179.24 128.85 179.03 128.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "176.6 119.9 176.81 120.02 176.81 120.14 176.8 122.27 176.6 122.15 176.6 120.02 176.6 119.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "181.28 130.03 181.29 127.68 181.49 127.8 181.49 130.14 181.28 130.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "181.29 127.44 181.29 125.1 181.5 125.21 181.49 127.56 181.29 127.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "183.79 128.89 183.79 129.12 183.69 129.06 181.49 127.8 181.29 127.68 179.25 126.5 179.04 126.38 176.79 125.08 176.59 124.97 174.14 123.55 173.93 123.43 171.69 122.14 171.48 122.02 169.19 120.69 169.09 120.63 169.09 120.4 169.19 120.46 171.48 121.78 171.69 121.9 173.94 123.2 174.14 123.31 176.59 124.73 176.79 124.85 179.04 126.15 179.25 126.26 181.29 127.44 181.49 127.56 183.69 128.83 183.79 128.89"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "171.5 116.96 171.7 117.07 171.7 117.19 171.7 119.32 171.49 119.2 171.5 117.07 171.5 116.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "173.95 118.37 174.15 118.49 174.15 118.61 174.15 120.73 173.94 120.62 173.95 118.49 173.95 118.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "181.3 122.62 181.51 122.73 181.5 122.85 181.5 124.98 181.29 124.86 181.3 122.73 181.3 122.62"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "172.2 133.61 172.17 143.84 169.81 142.47 169.84 132.25 172.2 133.61"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "177.13 138.46 177.11 146.68 174.74 145.32 174.77 137.1 177.13 138.46"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "182.47 136.46 182.44 149.8 180.07 148.43 180.11 135.09 182.47 136.46"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M131.85,140.53c-2.43,1.4-2.45,3.67,0,5.07a9.6,9.6,0,0,0,8.76,0c2.43-1.4,2.45-3.67,0-5.07A9.6,9.6,0,0,0,131.85,140.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25,102.19c-2.78-.3-3.46,5-4.09,8-.6,2.77,2.71,3.46,4.39,3.56S132.25,102.19,132.25,102.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M135.37,143.38c-.18.78-.26,2.35.7,2.34,1.74,0,1.25-1,2.37-1.17,2.51-.47,2.92-2.24,2.39-2.72s-1.29,0-2,.27c-.4.19-2,.78-2,.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M135.34,143.15c-.18.78-.27,2.35.7,2.34,1.74,0,1.24-1,2.37-1.17,2.5-.47,2.92-2.24,2.39-2.72s-1.29,0-2,.27c-.4.18-2,.78-2,.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M131.86,142.22c-.18.78-.26,2.35.7,2.34,1.74,0,1.25-1,2.37-1.17,2.51-.47,2.92-2.25,2.39-2.73s-1.29,0-2,.28c-.4.18-2,.78-2,.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.83,142c-.18.78-.27,2.35.7,2.33,1.74,0,1.24-.95,2.37-1.16,2.5-.47,2.92-2.25,2.39-2.73s-1.29,0-2,.28c-.4.18-2,.77-2,.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M137.83,95.46c1,0,1.12,1,1.12,1.48s-.21,1.06-.16,1.39a5.12,5.12,0,0,1,.08,1.51c-.1.53,0,1.94-1.28,1.88-.93,0-.25,1.76-.25,1.76a2.82,2.82,0,0,1-1.75.89,3.42,3.42,0,0,1-1.85-.72,6.34,6.34,0,0,0,.6-3,26.6,26.6,0,0,1,0-4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M134.34,100.7a5,5,0,0,1-.07-.53l1-.1a2.81,2.81,0,0,0,1.84,2,3.12,3.12,0,0,0,.2,1.45,3.52,3.52,0,0,1-.37.33c-.58,0-2.74.08-2.8,0s-.15-.19-.33-.43A5.69,5.69,0,0,0,134.34,100.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.18,96c.15.87-.25,1.24-1,1.68s-.94.19-1,.72c0,.21,0,.68,0,.74s-.42,0-.42,0l0-1.13s-.41-.39-.7,0,.48,1,.19,1.53a3.09,3.09,0,0,1-1.09,1.06c-.58.28-.5.56-.78.29s-2.15-3.3-1.3-5a3.5,3.5,0,0,1,4.09-1.76A2.48,2.48,0,0,1,139.18,96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M131,116.34s-1.42,1.8-.76,6,1.11,6.51.79,8.64.77,7.1.59,9.06.26,2.42.88,2.48,2.37.21,2.36-.62.09-4.76.26-5.91a29,29,0,0,0,.2-5.77c-.11-1.69,0-3.25-.1-5.26-.15-2.41-.73-5.91-.44-7.69C135.28,114.33,131,116.34,131,116.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M133,116.44s-.88,1.31-.52,5c.24,2.35,1.9,5.52,1.83,7.36a29.21,29.21,0,0,0,.1,6.95c.49,2.52.3,5.54.81,7.94a3.3,3.3,0,0,0,2.77-.63c.14-.53.15-3.8.67-6.28a51.83,51.83,0,0,0,.7-11.51c-.17-1.93.28-3.87-.1-8.09C138.94,114,133,116.44,133,116.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M131.79,102.2a4,4,0,0,1,2.4.44,6,6,0,0,0,2.48.54c1.22,0,4,.24,4.67,1.57.85,1.63-1.38,6.22-1.77,7.69a25.3,25.3,0,0,0-.17,5.34c0,.55-4,.52-6.38.18s-2.77-.55-2.88-2.75c0-.83,0-2.78-.38-5.54C129.46,107.14,130.09,102.72,131.79,102.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M147.8,105.35a1.87,1.87,0,0,0,.44-.87c.09-.49-.16-2.11.45-2.13.41,0,.08,1,.3,1,.45,0,.57-2.58,1.07-2.53s-.17,1.35,0,1.37.38.18.38.33.13.1.26.23,0,.25.06.3a.33.33,0,0,1,.17.36,3.31,3.31,0,0,1-1,1.7c-.85.54-.81,1-.81,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M139.85,103.84c-1.76.25-1.62,3.52-.47,6.27,1,2.42,2.3,3.42,3.43,3.6,2.72.44,6.87-8.07,6.87-8.07L148,104.49l-4.5,5.43S142,103.53,139.85,103.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "103.59 97.68 110.05 93.84 116.56 97.6 110.05 101.36 103.59 97.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "94.72 112.19 101.16 108.31 107.69 112.12 101.16 115.83 94.72 112.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.77 126.65 85.33 123 91.77 119.11 98.3 122.92 91.77 126.65"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "103.56 86.29 110.03 82.46 116.54 86.22 110.03 89.98 103.56 86.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "103.56 92.22 110.03 88.39 116.54 92.14 110.03 95.9 103.56 92.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "103.56 98.15 110.03 94.31 116.54 98.07 110.03 101.83 103.56 98.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "103.56 104.07 110.03 100.24 116.54 104 110.03 107.76 103.56 104.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "103.56 110 110.03 106.17 116.54 109.92 110.03 113.68 103.56 110"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "103.56 115.93 110.03 112.09 116.54 115.85 110.03 119.61 103.56 115.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "103.56 121.85 110.03 118.02 116.54 121.78 110.03 125.54 103.56 121.85"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "103.59 122.61 103.59 97.68 110.05 101.36 110.05 126.34 103.59 122.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "110.05 126.34 110.05 101.36 116.56 97.6 116.56 122.58 110.05 126.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "103.59 97.68 110.05 93.84 116.56 97.6 110.05 101.36 103.59 97.68"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "94.69 102.71 101.13 98.83 107.66 102.64 101.13 106.35 94.69 102.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "94.69 106.81 101.13 102.93 107.66 106.74 101.13 110.45 94.69 106.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "94.69 110.91 101.13 107.03 107.66 110.84 101.13 114.55 94.69 110.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "94.69 115.01 101.13 111.13 107.66 114.94 101.13 118.65 94.69 115.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "94.69 119.11 101.13 115.23 107.66 119.04 101.13 122.75 94.69 119.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "94.69 123.22 101.13 119.33 107.66 123.14 101.13 126.85 94.69 123.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "94.69 127.31 101.13 123.43 107.66 127.24 101.13 130.95 94.69 127.31"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "101.18 115.76 94.72 112.19 94.72 127.82 101.18 131.55 101.18 115.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "101.18 131.55 101.18 115.76 107.69 112.12 107.69 127.79 101.18 131.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "94.72 112.19 101.16 108.31 107.69 112.12 101.16 115.83 94.72 112.19"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "91.69 112.49 85.26 108.84 91.7 104.96 98.23 108.77 91.69 112.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "91.69 116.46 85.26 112.81 91.7 108.93 98.23 112.73 91.69 116.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "91.69 120.43 85.26 116.78 91.7 112.9 98.23 116.7 91.69 120.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "91.69 124.39 85.26 120.75 91.7 116.86 98.23 120.67 91.69 124.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "91.69 128.36 85.26 124.71 91.7 120.83 98.23 124.64 91.69 128.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "91.69 132.33 85.26 128.68 91.7 124.8 98.23 128.61 91.69 132.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.69 136.3 85.26 132.65 91.7 128.77 98.23 132.57 91.69 136.3"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "91.72 136.95 85.26 133.22 85.28 123.04 91.72 126.69 91.72 136.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "91.72 136.95 91.72 126.69 98.25 122.97 98.23 133.19 91.72 136.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.72 126.69 85.28 123.04 91.72 119.16 98.25 122.97 91.72 126.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M142.21,197.16s-.8,1.11-.4,2,1,.91,1.77,1.82c1.26,1.48,2.67,2.63,3.63,1.93s-1-3.51-2.34-5.34C143.19,195.32,142.21,197.16,142.21,197.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M136.6,173.17s10.42,5.34,10.41,6.5-2.68,15.66-2.17,17.35c.65,2.11,2.73,4.77,1.81,5.29s-1.75-.68-3-1.79c-1-.84-2-1-1.48-3.09a11.76,11.76,0,0,0,.2-5.25c-.79-6.67-.36-8.65-.18-10.36-4.75-1.07-9.86-8.65-9.86-8.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M142.21,197.16a3,3,0,0,0,.41,1.32c.57.9,1.56,2.43,2.57,2.81,1.33.5,1.55-.1,1.06-1.53-.13-.4.84,1.77.84,1.77v1.11a2.09,2.09,0,0,1-1.68-.2c-.78-.51-2-2.14-2.73-2.46C141.75,199.57,141.05,198.64,142.21,197.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M153.88,195.42c-1,.34-2.43-4.1-3.36-3.47s3.74,7.09,5.27,5.91c1.38-1.07-3-6.87-4.23-6.27S153.88,195.42,153.88,195.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M141.55,182.68a7.53,7.53,0,0,1,.64.85c2,3,4.91,5.12,6.72,7.27s1.25,1.82,2.39,3.27c.66.86,2.41,2.74,3.28,1.88.66-.64-1.4-3.25-3.64-6.52a56,56,0,0,1-4.05-7.43,11.2,11.2,0,0,0-2-2.67C143.88,178.3,140.39,181.35,141.55,182.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M127.82,173.69a7,7,0,0,0-.58,4.85c.81,3.5,7.81,4.69,11.21,4.46a3.93,3.93,0,0,1,3.45,2.42s1.3.36,2.63-2.82c.65-1.54,2.35-.13,2.78-2.87-.72-3.67-10.37-6.91-10.38-6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M148,156.57a3.93,3.93,0,0,0,.9-1.15c.29-.61.21-1.38.54-1.29s0,.8.26.88,1-1.74,1.26-1.61-.48,1-.29,1.24.71-1.46,1.15-1.39-.84,1.67-.64,1.84.8-1.43,1.05-1.13-.83,1.46-.66,1.46.52-.83.71-.72-.07.81-1.09,1.7c-.6.52-1.38.71-1.51,1.29S148,156.57,148,156.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M133.39,156.12c1.52-1.71,7,3.61,9.14,5.8,2.21-2.15,5.7-5.87,5.7-5.87l1.67,1.58s-5.26,6.25-7,7.56C140.78,165.47,134.21,157.2,133.39,156.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M125.92,159.76c.07-.95,1.32-1.81,3-2.08,1.09.43,2.85,2,4,1.6s1-2,.23-3.55c.8,0,1.58-.23,2.26.69a15,15,0,0,1,1.1,2.28c.43.83,1.53,1.66,1.53,3.18s-.34,1.77-.61,3.91a40.66,40.66,0,0,0,0,7.35c.18,1.09-8.35.73-9.55.55.22-3.14,1.19-4.24,0-8.19C126.84,162.3,126.14,162.73,125.92,159.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M140.71,176.62c-.57-.21-.79-.73-1.53-1a2.67,2.67,0,0,0-1.19-.26l.61-1.87c1.08.37,1.25.68,1.84.55s1.45-1,1.71-.75-.85,1.08-.49,1.15,2.49.53,2.44.79-1.54-.08-1.81,0,2.2.42,2.18.71c0,.44-2.22-.27-2.28-.1s1.91.5,1.85.79-2-.37-2.16-.21,1.57.47,1.44.7S141.06,176.74,140.71,176.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M127.22,158.69c2.1-.48,3.14,5.28,3.63,7.47s.51,2.79,1.18,3.24,7.43,4.06,7.43,4.06l-.94,2.21s-7.92-2.94-9.38-4.78S124.38,159.33,127.22,158.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M129.48,153.36c.28.38-1.48,5.83-.78,6.09s2.5,1.08,3.24.92a2.85,2.85,0,0,0,1.44-.63c1.3-1.18,0-3.34,0-3.34a8.77,8.77,0,0,1-1.07-3.76C132.27,152.13,130.58,151.67,129.48,153.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M130.57,146.71c2.47.28,3.88,1.73,3.5,3.12-.65,2.43.59,3.11.08,3.38s-.37.08-.52.78c-.21,1-.44,2.43-2.15,1.74-2-.78-4-1.8-4.59-3.95S127.92,146.42,130.57,146.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M132.41,147a5.26,5.26,0,0,0-2.51-.38h0c-6.23-.08-5.28,6.39-5,8.43.32,2.7,1.19,4.84,1.19,7.82a33.87,33.87,0,0,1-.33,4.22,2.42,2.42,0,0,0,1.88,2.62l1,.24a.83.83,0,0,0,1-.74c.32-3.28,2.4-12.1-1-16.44-.11-.14-.41-.5-.54-.64-.25-.32-.41-.71-.08-1.07a.59.59,0,0,1,.82,0c.38.35.83.21,1.13-.22a.62.62,0,0,0,.08-.12.85.85,0,0,1,1-.38c1.08.4,2.83.5,3.14-.25A2.79,2.79,0,0,0,132.41,147Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "152.56 151 152.62 173.38 135.38 183.33 135.31 160.96 152.56 151"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M143.47,161.86c3.91-2.26,7.09-.45,7.11,4l-1.17.68L143.5,170l0-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M143.48,163.78l0,6.22,5.91-3.41A12,12,0,0,1,144,176c-3,1.73-5.44.34-5.45-3.11A12,12,0,0,1,143.48,163.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "151.6 153.73 151.61 155.33 136.98 163.78 136.97 162.18 151.6 153.73"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M201,323.1c4.1,2.37,4.12,6.21,0,8.58L148,362.55a16.31,16.31,0,0,1-14.81,0L79.68,331.68c-4.11-2.37-4.13-6.21-.05-8.58l53.12-30.87a16.33,16.33,0,0,1,14.82,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M204.13,293.42l0,5c0,1.55-1,3.09-3,4.27v-5C203.11,296.5,204.12,295,204.13,293.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M204.13,293.42l0,5v.1l0-5v-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M204.13,293.51l0,5a3.07,3.07,0,0,1-.07.6l0-5a4.09,4.09,0,0,0,.07-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M204.06,294.11l0,5a3.28,3.28,0,0,1-.17.59l0-5a4.36,4.36,0,0,0,.17-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M203.89,294.7l0,5a3.52,3.52,0,0,1-.28.59l0-5a5.38,5.38,0,0,0,.28-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M203.61,295.3l0,5a4.31,4.31,0,0,1-.42.63l0-5a4.83,4.83,0,0,0,.42-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M203.19,295.92l0,5a6,6,0,0,1-.65.7l0-5a6.06,6.06,0,0,0,.65-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M202.54,296.62l0,5a7.39,7.39,0,0,1-1.33,1l0-5a8.36,8.36,0,0,0,1.33-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M201.21,297.61l0,5-.12.08v-5l.13-.07Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M76.57,298.36v-5c0,1.56,1,3.13,3.1,4.32l0,5C77.6,301.48,76.56,299.92,76.57,298.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M79.68,297.68l0,5c-2.06-1.2-3.1-2.76-3.09-4.32v-5c0,1.56,1,3.13,3.1,4.32Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "201.08 297.68 201.06 302.68 147.95 333.55 147.96 328.55 201.08 297.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "133.15 328.55 133.13 333.55 79.66 302.68 79.68 297.68 133.15 328.55"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M148,328.55v5a16.33,16.33,0,0,1-14.82,0l0-5A16.31,16.31,0,0,0,148,328.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M148,328.55v5a12.31,12.31,0,0,1-2.3,1l0-5a11.86,11.86,0,0,0,2.29-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M145.67,329.56l0,5a15.48,15.48,0,0,1-2,.49v-5a14.11,14.11,0,0,0,2-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M143.68,330.05v5c-.44.08-.89.14-1.34.19l0-5c.45-.05.89-.11,1.33-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M142.35,330.24l0,5c-.38,0-.77.06-1.16.07v-5c.39,0,.78,0,1.17-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M141.18,330.32v5c-.36,0-.71,0-1.07,0v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M140.11,330.32v5c-.35,0-.69,0-1-.06v-5l1,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M139.08,330.27v5c-.35,0-.69-.06-1-.11v-5q.51.08,1,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M138.06,330.15v5c-.35,0-.7-.11-1-.18v-5c.34.07.69.13,1,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M137,330v5c-.37-.08-.74-.17-1.09-.27v-5c.36.11.72.19,1.09.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M135.93,329.7v5a12.81,12.81,0,0,1-1.28-.43l0-5a10.53,10.53,0,0,0,1.27.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M134.66,329.27l0,5a11.68,11.68,0,0,1-1.51-.72l0-5a11.68,11.68,0,0,0,1.51.72Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M201,289.1c4.1,2.37,4.12,6.21,0,8.58L148,328.55a16.31,16.31,0,0,1-14.81,0L79.68,297.68c-4.11-2.37-4.13-6.21-.05-8.58l53.12-30.87a16.33,16.33,0,0,1,14.82,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M112.5,278.18c-15.68,9.05-15.76,23.73-.18,32.78s40.91,9.05,56.59,0,15.76-23.73.19-32.78S128.18,269.13,112.5,278.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M169.1,278.18c-15.58-9.06-40.92-9.05-56.6,0-7.12,4.11-11,9.38-11.69,14.76-.83-6.52,3.06-13.2,11.69-18.18,15.68-9.05,41-9.05,56.6,0,8.5,4.94,12.32,11.56,11.51,18C179.93,287.46,176.1,282.25,169.1,278.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M110.78,292.14v1.75c0,4.41,2.91,8.81,8.7,12.18,11.65,6.77,30.59,6.77,42.31,0,5.9-3.41,8.85-7.88,8.84-12.34V292c0,4.46-2.93,8.93-8.83,12.34-11.73,6.77-30.67,6.76-42.32,0C113.69,301,110.79,296.55,110.78,292.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M110.78,292.14v1.75a2.44,2.44,0,0,0,0,.27v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M110.78,292.41v1.75a10,10,0,0,0,.19,1.71v-1.75a10,10,0,0,1-.2-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M111,294.12v1.75a11.54,11.54,0,0,0,.48,1.69v-1.75a10.42,10.42,0,0,1-.48-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M111.46,295.81v1.75a13.75,13.75,0,0,0,.8,1.7v-1.75a11.35,11.35,0,0,1-.8-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M112.26,297.51v1.75a14.08,14.08,0,0,0,1.21,1.79V299.3a14.72,14.72,0,0,1-1.2-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M113.46,299.3v1.75a16.24,16.24,0,0,0,1.85,2v-1.75a17.17,17.17,0,0,1-1.86-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M115.32,301.29V303a23.45,23.45,0,0,0,3.79,2.81V304.1a23.17,23.17,0,0,1-3.79-2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M119.11,304.1v1.75l.37.22A33.83,33.83,0,0,0,126,309V307.2a33.86,33.86,0,0,1-6.56-2.89l-.36-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M126,307.2V309a42.57,42.57,0,0,0,5.66,1.41v-1.75A43.1,43.1,0,0,1,126,307.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M131.7,308.61v1.75c1.26.23,2.53.41,3.82.53v-1.75c-1.29-.13-2.57-.3-3.82-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M135.52,309.14v1.75c1.1.11,2.21.19,3.32.22v-1.75c-1.11,0-2.21-.11-3.31-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M138.83,309.36v1.75c1,0,2,0,3.06,0v-1.75c-1,0-2.05,0-3.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M141.9,309.38v1.75c1,0,2-.08,2.95-.16v-1.75c-1,.08-2,.13-2.95.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M144.85,309.22V311c1-.08,2-.19,2.91-.32v-1.76c-1,.14-1.93.25-2.9.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M147.75,308.89v1.76c1-.15,2-.32,3-.52v-1.75q-1.47.3-3,.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M150.72,308.38v1.75c1.06-.22,2.11-.47,3.13-.76v-1.76c-1,.29-2.06.55-3.12.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M153.84,307.61v1.76c1.24-.36,2.46-.77,3.63-1.23v-1.75a37.7,37.7,0,0,1-3.63,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M157.47,306.39v1.75a32.35,32.35,0,0,0,4.31-2.07c5.9-3.41,8.85-7.88,8.84-12.34V292c0,4.46-2.93,8.93-8.83,12.34a32.48,32.48,0,0,1-4.32,2.07Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M119.61,279.8c-11.73,6.77-11.78,17.75-.14,24.51s30.59,6.78,42.32,0,11.78-17.75.14-24.52S131.33,273,119.61,279.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M122.64,280.87c-10,5.79-10.09,15.19-.11,21s26.19,5.8,36.23,0,10.09-15.19.11-21S132.68,275.07,122.64,280.87Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M112.61,214c-15.61,9-15.69,23.63-.18,32.64s40.74,9,56.36,0,15.69-23.63.18-32.65S128.22,205,112.61,214Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M114.28,225.18c-14.68,8.48-14.75,22.22-.17,30.7s38.32,8.48,53,0,14.77-22.22.18-30.7S129,216.7,114.28,225.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M116,236.32c-13.75,7.94-13.82,20.81-.15,28.75s35.89,7.95,49.64,0,13.83-20.82.16-28.76S129.71,228.38,116,236.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M117.62,247.45c-12.82,7.41-12.88,19.41-.14,26.82s33.46,7.41,46.29,0,12.89-19.41.15-26.82S130.45,240.05,117.62,247.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M119.3,258.59c-11.9,6.87-12,18-.14,24.87s31,6.87,42.94,0,12-18,.14-24.88S131.19,251.72,119.3,258.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M121,269.73c-11,6.33-11,16.6-.13,22.93s28.62,6.33,39.59,0,11-16.6.13-22.93S131.94,263.4,121,269.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M122.64,280.87c-10,5.79-10.09,15.19-.11,21s26.19,5.8,36.23,0,10.09-15.19.11-21S132.68,275.07,122.64,280.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M113.88,286.23l2,1.19a1.33,1.33,0,0,1-.55-1.22l-2-1.18A1.3,1.3,0,0,0,113.88,286.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "115.36 286.2 113.33 285.02 113.33 285.03 115.36 286.21 115.36 286.2 115.36 286.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M115.36,286.21l-2-1.18a2.06,2.06,0,0,0,0,.45l2,1.18a2.06,2.06,0,0,1,0-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M115.41,286.66l-2-1.18a1.1,1.1,0,0,0,.5.75l2,1.19a1.15,1.15,0,0,1-.5-.76Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M144.75,209.9l-2-1.18a1.33,1.33,0,0,0-1.34.13l2,1.18A1.33,1.33,0,0,1,144.75,209.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M144.75,209.9l-2-1.18a1,1,0,0,0-.58-.13l2,1.18a1,1,0,0,1,.57.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M144.18,209.77l-2-1.18a1.46,1.46,0,0,0-.39.09l2,1.18a1.53,1.53,0,0,1,.4-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M143.78,209.86l-2-1.18a2.39,2.39,0,0,0-.37.17l2,1.18a2.39,2.39,0,0,1,.37-.17Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "115.2 228.49 113.17 227.31 113.33 285.02 115.36 286.2 115.2 228.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "143.41 210.03 141.38 208.85 115.05 224.05 117.08 225.23 143.41 210.03"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M117.08,225.23l-2-1.18a4.12,4.12,0,0,0-1.88,3.26l2,1.18A4.15,4.15,0,0,1,117.08,225.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M117.08,225.23l-2-1.18h0l2,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M117.06,225.24l-2-1.18a3.91,3.91,0,0,0-.41.3l2,1.18a3.91,3.91,0,0,1,.41-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M116.65,225.54l-2-1.18a3.66,3.66,0,0,0-.4.39l2,1.18a3.66,3.66,0,0,1,.4-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M116.25,225.93l-2-1.18a4.69,4.69,0,0,0-.73,1.15l2,1.18a4.69,4.69,0,0,1,.73-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M115.52,227.08l-2-1.18c-.06.15-.12.31-.17.46l2,1.18c.05-.15.11-.31.17-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M115.35,227.54l-2-1.18a4.54,4.54,0,0,0-.12.5l2,1.18a4.54,4.54,0,0,1,.12-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M115.23,228l-2-1.18a3.4,3.4,0,0,0,0,.45l2,1.18a3.4,3.4,0,0,1,0-.45Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M117.08,225.23a4.15,4.15,0,0,0-1.88,3.26l.16,57.71c0,1.2.85,1.69,1.9,1.08l26.33-15.2a4.16,4.16,0,0,0,1.88-3.26l-.16-57.71c0-1.2-.86-1.68-1.9-1.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "115.2 230.63 115.36 284.41 145.44 267.04 145.29 213.26 115.2 230.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "115.2 230.63 114.07 229.98 114.07 283.69 115.36 284.41 115.2 230.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M128.79,220.11a1.18,1.18,0,0,0-.53.92c0,.34.24.47.54.3l6.21-3.59a1.18,1.18,0,0,0,.53-.91c0-.34-.24-.47-.53-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M126.9,221.05a1.64,1.64,0,0,0-.74,1.27c0,.47.34.66.74.43a1.64,1.64,0,0,0,.74-1.28C127.64,221,127.31,220.82,126.9,221.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "145.29 213.26 145.31 216.54 115.21 233.92 115.2 230.63 145.29 213.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M142.43,216.16v1.53l.27-.16v-1.19a.42.42,0,0,0,.33,0l0-.29a.43.43,0,0,1-.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M141.27,216.83l.34-.19.49.54.08.09v.21l-.65.37v.36l-.25.15V218l-.22.12v-.23l.22-.12Zm.26.29v.5l.41-.24,0,0-.28-.3-.11-.15h0c0,.07,0,.14,0,.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M140.69,218.34a.32.32,0,0,0-.17.29c0,.12.06.15.17.09a.36.36,0,0,0,.18-.29Q140.86,218.25,140.69,218.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M140.69,217.89a.32.32,0,0,0,.17-.29c0-.11-.06-.15-.17-.08a.33.33,0,0,0-.18.29C140.51,217.92,140.58,218,140.69,217.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M139.8,217.66a.92.92,0,0,0-.48.76c0,.3.19.42.59.48l-.24.13-.37.21v.26l1-.56v-.21c-.48-.09-.66-.22-.66-.45a.45.45,0,0,1,.21-.37c.15-.08.24,0,.25.2l.24-.24C140.28,217.57,140.08,217.5,139.8,217.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M138.11,218.66v.24a1,1,0,0,1,.46,1l.27-.16a1.08,1.08,0,0,0-.45-1l.78-.45v-.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "119.34 228.98 119.35 231.01 121.62 229.7 119.34 228.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M122.68,226.87a3,3,0,0,0-1.14,1.29l1.14.93,1.13-2.24S123.48,226.41,122.68,226.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "117.45 229.65 117.45 230 117.45 230.05 117.96 229.76 117.96 229.71 117.96 229.36 117.45 229.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "117.27 230.67 117.28 232.17 118.16 231.66 118.16 230.16 118.12 230.19 117.29 230.66 117.27 230.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M117.45,230.05l.51-.29v0l.24-.14v2.12l-1,.57v-2.12l.24-.13Zm-.17,2.12.88-.51v-1.5l0,0v-.48l-.83.48v.47h0v1.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "115.2 230.63 114.07 229.98 114.07 233.25 115.21 233.92 115.2 230.63"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M117.34,235.43a2.39,2.39,0,0,0-1.09,1.88l0,6.4c0,.69.49,1,1.09.62l30.89-17.84a2.37,2.37,0,0,0,1.08-1.87l0-6.4c0-.69-.49-1-1.09-.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M124.44,235.77a2.51,2.51,0,0,0,0-.27A1.93,1.93,0,0,1,124.44,235.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M123.32,237a.78.78,0,0,1-.35.61c-.2.12-.36,0-.36-.2a.79.79,0,0,1,.35-.61C123.16,236.7,123.32,236.79,123.32,237Zm-.58.48a.06.06,0,0,0,.1.06s0,0,0,0a.13.13,0,0,0,.08,0,.47.47,0,0,0,.23-.4c0-.14-.1-.2-.23-.13a.51.51,0,0,0-.23.4.2.2,0,0,0,0,.09.09.09,0,0,0,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M122.84,237.32a.19.19,0,0,0-.09.12.09.09,0,0,0,0,.05.06.06,0,0,0,.1.06s0,0,0,0a.18.18,0,0,0,.06-.14C122.94,237.31,122.9,237.28,122.84,237.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M123.45,236.94a1.1,1.1,0,0,1-.48.84c-.28.16-.49,0-.5-.28a1.06,1.06,0,0,1,.49-.84C123.23,236.5,123.45,236.63,123.45,236.94Zm-.48.68a.78.78,0,0,0,.35-.61c0-.22-.16-.31-.36-.2a.79.79,0,0,0-.35.61c0,.23.16.32.36.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M123,237.48l0,0h0a.18.18,0,0,0,.06-.14c0-.06,0-.09-.1-.05a.19.19,0,0,0-.09.12.2.2,0,0,1,0-.09h0v0h0v0a0,0,0,0,1,0,0,.14.14,0,0,1,0-.06s0,0,0-.05l0,0v0h0v0l0,0,0,0,0,0h.09a.11.11,0,0,1,.08,0h0a.1.1,0,0,1,0,.05h0a.07.07,0,0,1,0,.05v0a.17.17,0,0,1,0,.07v0A.52.52,0,0,1,123,237.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M122.87,236c-.09,0-.16.11-.17.17s.12.15.33.11a.85.85,0,0,0,.24-.09c.09-.06.16-.12.17-.18s-.12-.15-.33-.11A.87.87,0,0,0,122.87,236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M121.33,238.16a.78.78,0,0,1-.35.61c-.2.11-.36,0-.36-.2A.76.76,0,0,1,121,238C121.17,237.85,121.33,237.94,121.33,238.16Zm-.58.47c0,.07,0,.09.11.06l0,0a.16.16,0,0,0,.09,0,.49.49,0,0,0,.23-.4c0-.15-.11-.21-.23-.13a.5.5,0,0,0-.24.4.29.29,0,0,0,0,.09v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M120.85,238.46a.3.3,0,0,0-.09.13v0c0,.07,0,.09.11.06l0,0a.21.21,0,0,0,.07-.14C121,238.46,120.91,238.43,120.85,238.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M121,238.1a.5.5,0,0,0-.24.4.29.29,0,0,0,0,.09.3.3,0,0,1,.09-.13c.06,0,.11,0,.11.06a.21.21,0,0,1-.07.14.16.16,0,0,0,.09,0,.49.49,0,0,0,.23-.4C121.21,238.08,121.1,238,121,238.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M121.47,238.08a1.1,1.1,0,0,1-.49.85c-.27.15-.49,0-.49-.28a1.1,1.1,0,0,1,.49-.85C121.24,237.65,121.46,237.77,121.47,238.08Zm-.49.69a.78.78,0,0,0,.35-.61c0-.22-.16-.31-.35-.2a.76.76,0,0,0-.36.61c0,.22.16.31.36.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M121,237.08a1.81,1.81,0,0,0-.25.2c-.21.19-.35.41-.33.49s.08,0,.17,0a1.18,1.18,0,0,0,.25-.19c.2-.19.35-.41.32-.49S121.13,237,121,237.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M119.44,238.65l.08,0,0,0a2,2,0,0,0,.6-.84,2,2,0,0,1,.71-.9A5.55,5.55,0,0,0,122.6,235c.13.63.59.36.93.51s.13.3.91.22l0,0a.43.43,0,0,1,.16-.07c.24,0,.4.1.4.39a1.19,1.19,0,0,1-.55,1l-.06,0a6.15,6.15,0,0,1-2.46,3.86,1.53,1.53,0,0,1-2.43-1l-.1.06c-.3.18-.55,0-.56-.32a1.24,1.24,0,0,1,.4-.84A.61.61,0,0,1,119.44,238.65ZM122,240a1.53,1.53,0,0,0,.69-1.19l-1.38.79c0,.44.31.62.69.4Zm1.48-3.08c0-.31-.22-.44-.49-.28a1.06,1.06,0,0,0-.49.84c0,.31.22.44.5.28a1.1,1.1,0,0,0,.48-.84Zm-2.47,2a1.1,1.1,0,0,0,.49-.85c0-.31-.23-.43-.49-.28a1.1,1.1,0,0,0-.49.85c0,.31.22.43.49.28Zm-.52-1.16s.08,0,.17,0a1.18,1.18,0,0,0,.25-.19c.2-.19.35-.41.32-.49s-.07,0-.16,0a1.81,1.81,0,0,0-.25.2c-.21.19-.35.41-.33.49Zm2.65-1.88a.87.87,0,0,0-.24.1c-.09,0-.16.11-.17.17s.12.15.33.11a.85.85,0,0,0,.24-.09c.09-.06.16-.12.17-.18s-.12-.15-.33-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M122,240c-.38.22-.69,0-.69-.4l1.38-.79A1.53,1.53,0,0,1,122,240Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M121.77,234.55a5.6,5.6,0,0,0-2.25,4.06l0,0a2,2,0,0,0,.6-.84,2.1,2.1,0,0,1,.7-.9A5.51,5.51,0,0,0,122.6,235c.13.63.59.36.93.51s.13.3.91.22a1.93,1.93,0,0,0,0-.27c-.26-1.68-.84-1.63-2.29-1.11A2.11,2.11,0,0,0,121.77,234.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M122,234a5.63,5.63,0,0,0-2,2.24,6.14,6.14,0,0,0-.63,2.55.61.61,0,0,1,.16-.12l.08,0a5.6,5.6,0,0,1,2.25-4.06,2.11,2.11,0,0,1,.34-.16c1.45-.52,2-.57,2.29,1.11a2.51,2.51,0,0,1,0,.27l0,0a.43.43,0,0,1,.16-.07c-.06-.73-.39-2.52-1.92-2A4.38,4.38,0,0,0,122,234Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "127.68 230.95 127.68 232.03 148.36 220.09 148.36 219.01 127.68 230.95"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "127.66 235.87 127.67 236.94 148.35 225 148.34 223.93 127.66 235.87"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "135.53 229.04 135.53 230.12 148.36 222.72 148.36 221.64 135.53 229.04"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M117.34,271.74a2.35,2.35,0,0,0-1.09,1.87l0,6.4c0,.69.49,1,1.09.62l30.89-17.83a2.4,2.4,0,0,0,1.08-1.88l0-6.39c0-.7-.49-1-1.09-.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M122.64,271.73a.24.24,0,0,0-.14.14c0,.08.1.12.27.09l.2-.08a.31.31,0,0,0,.14-.14c0-.09-.1-.13-.27-.09A.4.4,0,0,0,122.64,271.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M124.12,272.45l-.16.13,0,0a5.6,5.6,0,0,1-1.25,2.52,15.52,15.52,0,0,0,.35,1.95,4.05,4.05,0,0,1,1.33-1.58A11.93,11.93,0,0,1,124.12,272.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M123.93,271.55l0-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M122.61,272.82a.18.18,0,0,0-.07.1.06.06,0,0,0,0,0,.05.05,0,0,0,.08.05l0,0a.2.2,0,0,0,.06-.12C122.7,272.81,122.66,272.79,122.61,272.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M122.71,272.52a.44.44,0,0,0-.19.33.14.14,0,0,0,0,.07.18.18,0,0,1,.07-.1s.09,0,.09,0a.2.2,0,0,1-.06.12l.08,0a.43.43,0,0,0,.18-.33C122.9,272.51,122.82,272.46,122.71,272.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M121,273.76a.18.18,0,0,0-.07.1.06.06,0,0,0,0,0,.05.05,0,0,0,.08.05l0,0a.2.2,0,0,0,.06-.12C121.07,273.75,121,273.73,121,273.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M121.49,273.45a.89.89,0,0,1-.4.69c-.23.13-.41,0-.41-.23a.89.89,0,0,1,.4-.69C121.3,273.09,121.48,273.19,121.49,273.45Zm-.41.56a.65.65,0,0,0,.3-.5c0-.18-.14-.26-.3-.16a.63.63,0,0,0-.29.5c0,.18.13.25.29.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M119.37,274.7c0,.24.14.36.32.32a.42.42,0,0,0,.14-.06l.07,0A1.33,1.33,0,0,0,121,276a1.56,1.56,0,0,0,.93-.23,3.29,3.29,0,0,0,.77-.65,5.6,5.6,0,0,0,1.25-2.52l0,0,.16-.13a1,1,0,0,0,.3-.67.31.31,0,0,0-.15-.3.33.33,0,0,0-.31,0l0,0c-.64.07-.48-.07-.75-.19s-.66.11-.76-.41a4.65,4.65,0,0,1-1.43,1.49,1.67,1.67,0,0,0-.59.74,1.59,1.59,0,0,1-.49.69h0l-.07,0a.83.83,0,0,0-.24.22A1,1,0,0,0,119.37,274.7Zm3.47-3.05c.17,0,.29,0,.27.09a.31.31,0,0,1-.14.14l-.2.08c-.17,0-.29,0-.27-.09a.24.24,0,0,1,.14-.14.4.4,0,0,1,.2-.08Zm-.12,1.55c-.23.13-.41,0-.41-.23a.88.88,0,0,1,.4-.69c.22-.13.4,0,.41.23a.89.89,0,0,1-.4.69ZM121.9,275c-.31.18-.57,0-.57-.33l1.14-.65a1.26,1.26,0,0,1-.57,1Zm-.81-.9c-.23.13-.41,0-.41-.23a.89.89,0,0,1,.4-.69c.22-.13.4,0,.41.23a.89.89,0,0,1-.4.69Zm-.43-1c0-.06.1-.23.27-.39a.87.87,0,0,1,.2-.16c.08-.05.13-.05.14,0s-.1.24-.27.4a1.27,1.27,0,0,1-.2.16c-.07,0-.13.05-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M121.9,275c-.31.18-.57,0-.57-.33l1.14-.65A1.26,1.26,0,0,1,121.9,275Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M123,272.57a.61.61,0,0,1-.28.5c-.16.09-.3,0-.3-.16a.66.66,0,0,1,.29-.51A.18.18,0,0,1,123,272.57Zm-.47.39a.05.05,0,0,0,.08.05l0,0,.08,0a.43.43,0,0,0,.18-.33c0-.12-.08-.17-.19-.11a.44.44,0,0,0-.19.33.14.14,0,0,0,0,.07.06.06,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M123.12,272.51a.89.89,0,0,1-.4.69c-.23.13-.41,0-.41-.23a.88.88,0,0,1,.4-.69C122.93,272.15,123.11,272.25,123.12,272.51Zm-.4.56a.61.61,0,0,0,.28-.5.18.18,0,0,0-.29-.17.66.66,0,0,0-.29.51c0,.18.14.25.3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M121.38,273.51a.65.65,0,0,1-.3.5c-.16.09-.29,0-.29-.16a.63.63,0,0,1,.29-.5C121.24,273.25,121.37,273.33,121.38,273.51Zm-.48.39a.05.05,0,0,0,.08.05l0,0,.07,0a.41.41,0,0,0,.19-.33c0-.12-.08-.17-.19-.11a.44.44,0,0,0-.19.33.14.14,0,0,0,0,.07.06.06,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M121.08,273.46a.44.44,0,0,0-.19.33.14.14,0,0,0,0,.07.18.18,0,0,1,.07-.1s.09,0,.09,0a.2.2,0,0,1-.06.12l.07,0a.41.41,0,0,0,.19-.33C121.27,273.45,121.19,273.4,121.08,273.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M121.13,272.63a.87.87,0,0,0-.2.16c-.17.16-.29.33-.27.39s.07,0,.14,0a1.27,1.27,0,0,0,.2-.16c.17-.16.29-.34.27-.4S121.21,272.58,121.13,272.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M121.73,270.55a4.58,4.58,0,0,0-1.84,3.33h0a1.59,1.59,0,0,0,.49-.69,1.72,1.72,0,0,1,.58-.74,4.61,4.61,0,0,0,1.44-1.49c.1.52.48.3.76.41s.11.26.75.19l0-.22c-.22-1.38-.7-1.34-1.89-.91A1.75,1.75,0,0,0,121.73,270.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M121.87,269.83a5.09,5.09,0,0,0-1.9,2.11,4.62,4.62,0,0,0-.39,2.19.83.83,0,0,1,.24-.22l.07,0a4.58,4.58,0,0,1,1.84-3.33,1.75,1.75,0,0,1,.28-.13c1.19-.43,1.67-.47,1.89.91l0,.22,0,0a.33.33,0,0,1,.31,0c0-.59,0-2.14-1.14-2.05A3,3,0,0,0,121.87,269.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M119.69,275a16.14,16.14,0,0,1-.31,3.49l.11-.08a2.66,2.66,0,0,1,1.25-.24A16.2,16.2,0,0,0,121,276a1.33,1.33,0,0,1-1.07-1.09l-.07,0A.42.42,0,0,1,119.69,275Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "127.67 267.25 127.67 268.33 148.35 256.39 148.35 255.31 127.67 267.25"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "127.66 272.17 127.66 273.24 148.34 261.3 148.34 260.23 127.66 272.17"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "135.52 265.34 135.53 266.42 148.35 259.01 148.35 257.94 135.52 265.34"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M117.34,260.06a2.39,2.39,0,0,0-1.09,1.88l0,6.4c0,.68.49,1,1.09.62l30.89-17.84a2.37,2.37,0,0,0,1.08-1.87l0-6.4c0-.69-.49-1-1.09-.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M122.66,260.64a.38.38,0,0,0-.18.18c0,.11.13.16.34.12a.88.88,0,0,0,.26-.1.39.39,0,0,0,.18-.18c0-.11-.13-.16-.35-.11A.92.92,0,0,0,122.66,260.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M124.3,260.41a2.51,2.51,0,0,0,0-.27C124.27,260.22,124.29,260.32,124.3,260.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M122.63,262a.27.27,0,0,0-.1.13s0,0,0,0,0,.09.11.06l0,0a.23.23,0,0,0,.07-.15C122.74,262,122.69,262,122.63,262Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M123.27,261.63a1.15,1.15,0,0,1-.51.89c-.28.16-.51,0-.51-.3a1.12,1.12,0,0,1,.51-.88C123,261.18,123.27,261.31,123.27,261.63Zm-.51.72a.81.81,0,0,0,.37-.63c0-.24-.17-.33-.37-.22a.81.81,0,0,0-.37.64c0,.24.17.33.37.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.76,261.65a.51.51,0,0,0-.24.42.28.28,0,0,0,0,.09.27.27,0,0,1,.1-.13c.06,0,.11,0,.11.06a.23.23,0,0,1-.07.15l.09,0a.56.56,0,0,0,.24-.42C123,261.64,122.89,261.57,122.76,261.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M120.56,263.23a.19.19,0,0,0-.1.13.43.43,0,0,0,0,.05c0,.06,0,.09.11.06l0,0a.22.22,0,0,0,.06-.15C120.66,263.22,120.61,263.19,120.56,263.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M121.06,262.91a.82.82,0,0,1-.37.64c-.21.12-.37,0-.37-.21a.81.81,0,0,1,.36-.64C120.89,262.58,121.05,262.68,121.06,262.91Zm-.61.5c0,.06,0,.09.11.06l0,0,.09,0a.52.52,0,0,0,.24-.41c0-.16-.11-.22-.25-.14a.54.54,0,0,0-.24.41.3.3,0,0,0,0,.1.43.43,0,0,0,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.68,262.85a.54.54,0,0,0-.24.41.3.3,0,0,0,0,.1.19.19,0,0,1,.1-.13s.1,0,.1.06a.22.22,0,0,1-.06.15l.09,0a.52.52,0,0,0,.24-.41C120.93,262.83,120.82,262.77,120.68,262.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M121.51,259.15a5.84,5.84,0,0,0-2.35,4.23h0a1.94,1.94,0,0,0,.61-.87,2.07,2.07,0,0,1,.68-.91l.07,0a2.55,2.55,0,0,0,.33-.17,5,5,0,0,0,1.55-1.41c.62.33.56.06.92.21s.14.32,1,.23c0-.09,0-.19,0-.27-.27-1.76-.88-1.71-2.4-1.16A1.62,1.62,0,0,0,121.51,259.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M119.08,263.42l.08,0h0a1.94,1.94,0,0,0,.61-.87,2.07,2.07,0,0,1,.68-.91l.07,0a2.55,2.55,0,0,0,.33-.17,5,5,0,0,0,1.55-1.41c.62.33.56.06.92.21s.14.32,1,.23l0,0,.17-.07c.24-.05.42.1.42.41a1.27,1.27,0,0,1-.58,1l-.07,0a6.4,6.4,0,0,1-2.56,4,1.6,1.6,0,0,1-2.54-1.09l-.09.07c-.33.19-.59,0-.59-.33a1.28,1.28,0,0,1,.41-.88A1,1,0,0,1,119.08,263.42Zm2.64,1.43a1.59,1.59,0,0,0,.72-1.24l-1.44.83c0,.46.32.64.72.41Zm1.55-3.22c0-.32-.23-.45-.51-.29a1.12,1.12,0,0,0-.51.88c0,.33.23.46.51.3a1.15,1.15,0,0,0,.51-.89Zm-2.58,2.08a1.13,1.13,0,0,0,.51-.88c0-.32-.23-.45-.52-.29a1.09,1.09,0,0,0-.5.88c0,.32.23.45.51.29Zm-.54-1.21s.08,0,.17,0a1.5,1.5,0,0,0,.26-.21c.22-.2.37-.42.34-.5s-.08,0-.17,0a1.07,1.07,0,0,0-.26.2c-.22.2-.37.43-.34.51Zm2.76-1.95a.92.92,0,0,0-.25.09.38.38,0,0,0-.18.18c0,.11.13.16.34.12a.88.88,0,0,0,.26-.1.39.39,0,0,0,.18-.18c0-.11-.13-.16-.35-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M121.72,264.85c-.4.23-.72,0-.72-.41l1.44-.83A1.59,1.59,0,0,1,121.72,264.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M120.75,261.79a1.07,1.07,0,0,0-.26.2c-.22.2-.37.43-.34.51s.08,0,.17,0a1.5,1.5,0,0,0,.26-.21c.22-.2.37-.42.34-.5S120.84,261.74,120.75,261.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M123.13,261.72a.81.81,0,0,1-.37.63c-.2.12-.37,0-.37-.21a.81.81,0,0,1,.37-.64C123,261.39,123.13,261.48,123.13,261.72Zm-.61.49c0,.07,0,.09.11.06l0,0,.09,0a.56.56,0,0,0,.24-.42c0-.15-.11-.22-.24-.14a.51.51,0,0,0-.24.42.28.28,0,0,0,0,.09s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M121.2,262.83a1.13,1.13,0,0,1-.51.88c-.28.16-.51,0-.51-.29a1.09,1.09,0,0,1,.5-.88C121,262.38,121.19,262.51,121.2,262.83Zm-.51.72a.82.82,0,0,0,.37-.64c0-.23-.17-.33-.38-.21a.81.81,0,0,0-.36.64c0,.23.16.33.37.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M121.71,258.55a5.9,5.9,0,0,0-2.14,2.34,6.29,6.29,0,0,0-.66,2.66,1,1,0,0,1,.17-.13l.08,0a5.84,5.84,0,0,1,2.35-4.23,1.62,1.62,0,0,1,.35-.17c1.52-.55,2.13-.6,2.4,1.16a2.51,2.51,0,0,1,0,.27l0,0,.17-.07c-.07-.76-.41-2.63-2-2.11A4,4,0,0,0,121.71,258.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "127.66 260.74 127.67 261.82 148.35 249.88 148.34 248.8 127.66 260.74"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "135.53 253.79 135.53 254.87 148.36 247.46 148.36 246.38 135.53 253.79"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "135.53 251.13 135.53 252.21 148.36 244.8 148.36 243.72 135.53 251.13"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M122.55,244.58a2.37,2.37,0,0,0-1.08,1.88v6.4c0,.69.49,1,1.09.62l30.89-17.83a2.37,2.37,0,0,0,1.08-1.88v-6.4c0-.69-.49-1-1.09-.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.8,247.22a.48.48,0,0,0-.21.37.19.19,0,0,0,0,.08.17.17,0,0,1,.09-.11s.09,0,.09.05a.25.25,0,0,1-.06.13l.08,0a.46.46,0,0,0,.21-.36C127,247.21,126.91,247.16,126.8,247.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M127.25,247.21a1,1,0,0,1-.45.77c-.25.14-.45,0-.45-.25a1,1,0,0,1,.45-.78C127,246.81,127.24,246.92,127.25,247.21Zm-.45.63a.7.7,0,0,0,.32-.56c0-.2-.14-.29-.32-.18a.71.71,0,0,0-.33.56c0,.2.15.28.33.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M127.12,247.28a.7.7,0,0,1-.32.56c-.18.1-.33,0-.33-.18a.71.71,0,0,1,.33-.56C127,247,127.12,247.08,127.12,247.28Zm-.53.43a.06.06,0,0,0,.1.06l0,0,.08,0a.46.46,0,0,0,.21-.36c0-.14-.1-.19-.21-.13a.48.48,0,0,0-.21.37.19.19,0,0,0,0,.08s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M123.64,248.74h0a1.7,1.7,0,0,0,.55-.77,1.85,1.85,0,0,1,.65-.83,5.16,5.16,0,0,0,1.6-1.66c.11.58.54.33.85.47s.12.28.83.2l0,0c.28-.16.51,0,.51.29a1.12,1.12,0,0,1-.51.89l-.05,0a5.57,5.57,0,0,1-2.25,3.53,1.4,1.4,0,0,1-2.23-1l-.08.06a.32.32,0,0,1-.52-.29,1.11,1.11,0,0,1,.51-.88Zm2.25,1.29a1.39,1.39,0,0,0,.63-1.09l-1.27.73c0,.4.29.56.64.36Zm1.36-2.82c0-.29-.21-.4-.45-.26a1,1,0,0,0-.45.78c0,.28.2.39.45.25a1,1,0,0,0,.45-.77ZM125,249a1,1,0,0,0,.45-.77c0-.29-.2-.4-.45-.26a1,1,0,0,0-.45.78c0,.28.2.39.45.25Zm-.47-1.06s.07,0,.15,0a1.12,1.12,0,0,0,.23-.18c.19-.18.32-.37.3-.44s-.07,0-.16,0a.93.93,0,0,0-.22.17c-.19.18-.32.38-.3.45Zm2.43-1.72a.79.79,0,0,0-.23.09.32.32,0,0,0-.15.16c0,.09.11.14.3.1a.73.73,0,0,0,.22-.09.31.31,0,0,0,.16-.16c0-.09-.12-.14-.3-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M126.69,247.56a.17.17,0,0,0-.09.11s0,0,0,0a.06.06,0,0,0,.1.06l0,0a.25.25,0,0,0,.06-.13C126.78,247.55,126.74,247.53,126.69,247.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M125.25,249.67c0,.4.29.56.64.36a1.39,1.39,0,0,0,.63-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M124.87,248.61a.2.2,0,0,0-.09.11v0c0,.06,0,.09.09.06l0,0a.19.19,0,0,0,.06-.13C125,248.6,124.92,248.58,124.87,248.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,248.27a.48.48,0,0,0-.21.37.19.19,0,0,0,0,.08.2.2,0,0,1,.09-.11s.09,0,.09,0a.19.19,0,0,1-.06.13.13.13,0,0,0,.08,0,.46.46,0,0,0,.21-.37C125.19,248.26,125.1,248.21,125,248.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M125.43,248.26a1,1,0,0,1-.45.77c-.25.14-.45,0-.45-.25A1,1,0,0,1,125,248C125.23,247.86,125.43,248,125.43,248.26Zm-.45.63a.7.7,0,0,0,.32-.56c0-.2-.14-.29-.32-.19a.73.73,0,0,0-.32.56c0,.21.14.29.32.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M124.82,245.82a3.34,3.34,0,0,0-1.18,2.92h0a1.7,1.7,0,0,0,.55-.77,1.82,1.82,0,0,1,.64-.82,5.21,5.21,0,0,0,1.61-1.67c.11.58.54.33.85.47s.12.28.83.2l0-.25c-.17-1-.47-1.36-1.08-1.3-.06.1-.13.21-.21.32s-.6.4-1.08.68a2.63,2.63,0,0,1-.4.21A.56.56,0,0,1,124.82,245.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M128.15,246.14l0-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M125,247.35a.93.93,0,0,0-.22.17c-.19.18-.32.38-.3.45s.07,0,.15,0a1.12,1.12,0,0,0,.23-.18c.19-.18.32-.37.3-.44S125.12,247.3,125,247.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M125.3,248.33a.7.7,0,0,1-.32.56c-.18.1-.32,0-.32-.19a.73.73,0,0,1,.32-.56C125.16,248,125.3,248.13,125.3,248.33Zm-.52.43c0,.06,0,.09.09.06l0,0a.13.13,0,0,0,.08,0,.46.46,0,0,0,.21-.37c0-.13-.09-.18-.21-.12a.48.48,0,0,0-.21.37.19.19,0,0,0,0,.08v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M126.71,246.34a.32.32,0,0,0-.15.16c0,.09.11.14.3.1a.73.73,0,0,0,.22-.09.31.31,0,0,0,.16-.16c0-.09-.12-.14-.3-.1A.79.79,0,0,0,126.71,246.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M124.51,245.33c.08.5.3.84.7.67.15-.07.29-.2.45-.29.48-.28,1-.66,1.07-.68l.22-.32c.77-1.27.07-1.71-1-1.34A2,2,0,0,0,124.51,245.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "132.56 240.42 132.56 241.5 153.25 229.56 153.24 228.48 132.56 240.42"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "140.47 238.37 140.47 239.45 153.3 232.04 153.3 230.96 140.47 238.37"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "142.95 239.38 142.95 240.45 153.25 234.51 153.24 233.43 142.95 239.38"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M133.88,289c-3.48,2-3.5,5.26,0,7.27a13.79,13.79,0,0,0,12.54,0c3.48-2,3.49-5.26,0-7.27A13.85,13.85,0,0,0,133.88,289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M143.16,263.35c2.18-.08,2.83,3.15,2.42,6s-1.29,8.15-.83,9.85c.55,2.06.48,6.7,0,9.57-.49,3.07,1,4,.06,5-.77.85-5.84-1.19-5.84-1.19l.47-1.35s2.05.58,2.56.12c.87-.76-1.16-7-1.21-10.82a68.81,68.81,0,0,1,.48-10.9A42.4,42.4,0,0,1,143.16,263.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M144.94,292c-.32,0-.49.38-1.26.64a7,7,0,0,1-3.06-.12c-.7-.3-1.48-1-1-1.2l.12,0a5.08,5.08,0,0,0-2.29-.25c-.23.27.35,1.69,1.27,2,.68.24,1.37.19,3,.52,1.11.22,1.51.72,2.66.63.91-.08.89-.86.84-1.48S145.05,292,144.94,292Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M139,264c2.18-.08,2.83,3.15,2.43,6s-1.29,8.15-.84,9.85c.55,2.06.48,6.7,0,9.57-.49,3.07,1,4,.06,5-.77.85-5.84-1.19-5.84-1.19l0-1,.52-.39s2.05.57,2.56.12c.87-.77-1.15-7-1.21-10.82a67.48,67.48,0,0,1,.49-10.9A41.21,41.21,0,0,1,139,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M140.82,292.58c-.32,0-.49.39-1.26.64a9.14,9.14,0,0,1-3.05-.12c-1.46-.3-1.53-1.23-1-1.19l.12,0a4.32,4.32,0,0,0-2.21-.09c-.22.48.31,1.46,1.24,1.78a26.61,26.61,0,0,0,2.94.59c1.1.22,1.5.73,2.65.63.91-.07.89-.85.85-1.48S140.93,292.58,140.82,292.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M137.37,233.21a2.19,2.19,0,0,0-1.5,2c0,.59.12,1.21.06,1.64s-.14,1.08-.2,1.74.31,2.76,1.68,2.77c1.08,0,.36,2.29.36,2.29a3.69,3.69,0,0,0,2.3,1.15,4.46,4.46,0,0,0,2.42-1s-1.13-2.41-.83-3.84a35.69,35.69,0,0,0,0-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M139.06,239.5c.36-.68,2-.08,2.63.21l0,.23a3.42,3.42,0,0,0,0,1.11c-.22.75-.46,1.58-.49,1.65s-1.44,1.18-2.21,1.78a4.52,4.52,0,0,1-1.18-.87s.72-2.28-.36-2.29a1.11,1.11,0,0,1-.6-.17A5.93,5.93,0,0,0,139.06,239.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M144.31,258.27c.77,3,2.54,3.1,2.1,8-.37,4.26-1.92,7.26-1.42,11.28s.44,3.1.71,6.75c.11,1.59-.23,6.88-.7,7.32a2.71,2.71,0,0,1-2.92-.38c-.67-1.14-.08-3.8-1.18-7.64s0-4.65-.24-7.74-.76-15.42-.76-15.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M142.35,258.5c1.53,3.58,2.24,4.85.83,8.5-1.68,4.32-2.26,6.69-1.84,10a46.85,46.85,0,0,1,.24,6.11c0,2.84,0,7.74-.77,8.48-.4.4-2.5.36-2.89-.28-.49-.81-1.95-14.26-1.9-15.69.11-3.08-.05-6.13.35-10,.28-2.64-.3-5,0-6.47S142.35,258.5,142.35,258.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M132.81,238.52c-.53-.42-.58-3.14-1.76-3.63-1-.41-1.87-.91-2-.66-.17.41,1.54,1.09,1.48,1.5s-.74,1.33,0,2a3.49,3.49,0,0,1,1,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M142.4,248.25s-3.78-2.74-5.83-4.67a20.57,20.57,0,0,1-3.76-5.59l-1.87.76a26.57,26.57,0,0,0,3.16,6.38c1.82,2.33,6.65,5.8,6.65,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M137.73,243.64a5.89,5.89,0,0,0,2.73.16c1.27-.24.64-1.59,1.79-1.57.79,0,3.35,1.57,2.94,8.35-.16,2.69-.76,5.09-.44,7.92-.7,2-4.39,2.71-8.52,1.37.65-4.52-1.33-5.41-1.35-7.68,0-1.17-1-6.13-.17-6.57C136.29,244.77,137.34,243.46,137.73,243.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M126.2,245.6a2,2,0,0,1-.37-.93c0-.5.21-2.14-.24-2.21s-.18,1-.4,1c-.47,0-.48-2.69-.85-2.68s0,1.39-.14,1.39a.44.44,0,0,0-.42.3c0,.16-.15.08-.29.2s0,.26-.09.31a.35.35,0,0,0-.21.35,3.4,3.4,0,0,0,.82,1.83c.81.62.71,1.11.71,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M136.23,259.87c.55-3.86-.81-5.07-1.23-6.76l1.32-2.84a93.79,93.79,0,0,0,1.42,10A7.59,7.59,0,0,1,136.23,259.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M135.78,245.16c2,.48,1.45,4.2-.16,7.21-1.41,2.65-3,3.64-4.31,3.73-3.15.2-6.81-10.09-6.81-10.09l1.72-.85L131,251.7S133.39,244.58,135.78,245.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M135.87,233.89a3.41,3.41,0,0,1,3.15-1.53h.42a3.61,3.61,0,0,1,.7.09,3.68,3.68,0,0,1,3.05,3.73,69.8,69.8,0,0,0,.62,8.94c.56,3.73.69,3.38.78,5.89s-5.42,2.9-6.32,1.79-.6-6.16-.21-8.82c.25-1.7-1-4.69-.56-6.06h0a.3.3,0,0,1,.16-.23c.68-.37.86-1.35.3-1.5s-.7.62-1.47.34C135.25,236.09,135.5,234.58,135.87,233.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M135.87,233.89a3.41,3.41,0,0,1,3.15-1.53h.42a3.61,3.61,0,0,1,.7.09,3.68,3.68,0,0,1,3.05,3.73,69.8,69.8,0,0,0,.62,8.94c.56,3.73.69,3.38.78,5.89.06,1.75-2.6,2.47-4.52,2.37a42.29,42.29,0,0,1-.82-4.22c-.35-2.24.9-6.09-.31-8.25a6.77,6.77,0,0,1-.89-3.55c.34-.44.35-1.05-.08-1.17s-.7.62-1.47.34C135.25,236.09,135.5,234.58,135.87,233.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M113.66,255a.87.87,0,0,0,0,1.64,3.12,3.12,0,0,0,2.85,0,.87.87,0,0,0,0-1.64A3.12,3.12,0,0,0,113.66,255Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M113.84,257.26a.76.76,0,0,0,0,1.44,2.77,2.77,0,0,0,2.48,0,.76.76,0,0,0,0-1.44A2.71,2.71,0,0,0,113.84,257.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M114,259.52a.65.65,0,0,0,0,1.23,2.33,2.33,0,0,0,2.12,0,.65.65,0,0,0,0-1.23A2.33,2.33,0,0,0,114,259.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M114.21,261.78a.54.54,0,0,0,0,1,1.93,1.93,0,0,0,1.75,0,.54.54,0,0,0,0-1A1.93,1.93,0,0,0,114.21,261.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M114.39,264.05c-.39.22-.39.58,0,.8a1.52,1.52,0,0,0,1.39,0c.39-.22.39-.58,0-.8A1.49,1.49,0,0,0,114.39,264.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M114.57,266.31c-.29.16-.29.43,0,.59a1.1,1.1,0,0,0,1,0c.29-.16.29-.43,0-.59A1.1,1.1,0,0,0,114.57,266.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M114.75,268.57c-.19.11-.19.28,0,.39a.76.76,0,0,0,.66,0c.19-.11.19-.28,0-.39A.76.76,0,0,0,114.75,268.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M494.79,300c4.78,2.76,4.8,7.24,0,10L433,345.91c-4.75,2.76-12.48,2.76-17.26,0l-62.26-36c-4.78-2.76-4.81-7.23-.06-10l61.86-36c4.74-2.76,12.47-2.76,17.25,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M498.39,269l0,5.82c0,1.8-1.19,3.59-3.55,5l0-5.82C497.2,272.59,498.38,270.8,498.39,269Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M498.39,269l0,5.82v.11l0-5.82V269Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M498.39,269.11l0,5.82a4.29,4.29,0,0,1-.08.7l0-5.82a5.78,5.78,0,0,0,.08-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M498.31,269.81l0,5.82a4.07,4.07,0,0,1-.2.68l0-5.82a5.31,5.31,0,0,0,.2-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M498.11,270.49l0,5.82a4.88,4.88,0,0,1-.32.7v-5.82a4.94,4.94,0,0,0,.33-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M497.78,271.19V277a5.57,5.57,0,0,1-.5.73l0-5.82a5.48,5.48,0,0,0,.49-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M497.29,271.92l0,5.82a6.26,6.26,0,0,1-.75.81v-5.82a6.36,6.36,0,0,0,.76-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M496.53,272.73v5.82A9.6,9.6,0,0,1,495,279.7l0-5.82a9.08,9.08,0,0,0,1.54-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M495,273.88l0,5.82-.15.09,0-5.82.15-.09Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M349.85,274.75l0-5.82c0,1.82,1.19,3.64,3.6,5l0,5.82C351.05,278.39,349.84,276.57,349.85,274.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M353.47,274l0,5.82c-2.4-1.39-3.61-3.21-3.6-5l0-5.82c0,1.82,1.19,3.64,3.6,5Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "494.84 273.97 494.82 279.79 432.97 315.73 432.99 309.91 494.84 273.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "415.73 309.91 415.71 315.73 353.45 279.78 353.47 273.96 415.73 309.91"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M433,309.91l0,5.82c-4.75,2.76-12.47,2.76-17.25,0v-5.82C420.51,312.67,428.24,312.67,433,309.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M433,309.91l0,5.82a14.12,14.12,0,0,1-2.68,1.18l0-5.82a14.12,14.12,0,0,0,2.68-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M430.31,311.09l0,5.82a17.18,17.18,0,0,1-2.3.57v-5.82a17,17,0,0,0,2.31-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M428,311.66v5.82c-.52.09-1,.17-1.56.22l0-5.82c.52-.05,1-.13,1.55-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M426.45,311.88l0,5.82-1.35.09V312c.46,0,.91-.05,1.36-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M425.09,312v5.82c-.42,0-.84,0-1.25,0V312c.42,0,.84,0,1.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M423.84,312v5.81c-.4,0-.81,0-1.2-.06v-5.82c.4,0,.8.06,1.2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M422.64,311.91v5.82c-.4,0-.8-.08-1.19-.13l0-5.82c.39.05.78.1,1.18.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M421.46,311.78l0,5.82c-.41-.06-.81-.13-1.21-.21l0-5.82c.39.08.8.15,1.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M420.25,311.57l0,5.82c-.43-.09-.86-.2-1.27-.31v-5.82c.42.11.84.22,1.28.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M419,311.26v5.82c-.51-.15-1-.32-1.48-.5v-5.82c.48.18,1,.35,1.48.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M417.49,310.76v5.82a13.64,13.64,0,0,1-1.76-.85v-5.82a13.64,13.64,0,0,0,1.76.85Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M494.79,264c4.78,2.76,4.8,7.24,0,10L433,309.91c-4.75,2.76-12.48,2.76-17.26,0l-62.26-36c-4.78-2.76-4.81-7.23-.06-10l61.86-36c4.74-2.76,12.47-2.76,17.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M434.74,234.16l-56.95,33.89a2,2,0,0,1-3.15-1.89v-48a2.62,2.62,0,0,1,1.34-2.28l57.42-32.77c1-.53,3.2,0,3.21,1.84l-1.2,48.1A1.34,1.34,0,0,1,434.74,234.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M410.2,266,404,262.31a2.7,2.7,0,0,1-1.34-2.32v-6.13l10.68-6.17-.25,6.09a2.7,2.7,0,0,0,1.33,2.43l5.81,3.09a1,1,0,0,1,.11,1.55L411.59,266A1.34,1.34,0,0,1,410.2,266Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M435.94,234.87,377.84,268a1.33,1.33,0,0,1-2-1.15v-48a2.65,2.65,0,0,1,1.33-2.29l57.43-32.76a1.34,1.34,0,0,1,2,1.14v48.8A1.32,1.32,0,0,1,435.94,234.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M436.61,227.33,375.84,262V218.82a2.64,2.64,0,0,1,1.33-2.29l57.43-32.77a1.34,1.34,0,0,1,2,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M410.28,265.46l-6.09-3.59a2.63,2.63,0,0,1-1.31-2.27v-5.93l10.49-6.13-.25,6a2.63,2.63,0,0,0,1.3,2.38l5.81,3.41a.66.66,0,0,1,0,1.14l-8.57,5A1.34,1.34,0,0,1,410.28,265.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "402.88 253.73 413.36 247.76 413.29 249.42 402.88 255.36 402.88 253.73"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M436.11,186.7c1.88-1.08,3.4-.21,3.41,1.94l.11,37.94a7.47,7.47,0,0,1-3.39,5.86l-50.4,29.1c-1.88,1.08-3.4.21-3.4-1.94l-.11-38a7.44,7.44,0,0,1,3.38-5.85Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M438.75,190.21c1.86-1.09,3.36-.22,3.37,1.94l.1,35.33a7.46,7.46,0,0,1-3.35,5.85l-47.46,27.75c-1.86,1.08-3.36.21-3.37-1.94l-.1-35.33a7.48,7.48,0,0,1,3.35-5.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "472 217.99 472.17 278.18 472.17 278.19 472 218 472 217.99 472 217.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M472,218l.17,60.19v.07L472,218.07V218Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M472,218.07l.17,60.19s0,0,0,.06L472,218.13s0,0,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M472,218.13l.17,60.19,0,.06-.17-60.18,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M472.05,218.2l.17,60.18a.18.18,0,0,0,0,.07l-.17-60.19-.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M472.1,218.26l.17,60.19.07.08-.17-60.19-.07-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M472.17,218.34l.17,60.19a.85.85,0,0,0,.14.1l-.17-60.19a.85.85,0,0,1-.14-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M472.31,218.44l.17,60.19h0a1.22,1.22,0,0,0,.24.1l-.17-60.18-.24-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M472.56,218.56l.17,60.18a1.41,1.41,0,0,0,.22.06l-.17-60.19-.22-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M472.78,218.61,473,278.8l.14,0-.17-60.19-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M472.92,218.63l.17,60.19h.13L473,218.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M473,218.64l.18,60.19h.11l-.17-60.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M473.16,218.64l.17,60.19h.11l-.17-60.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M473.27,218.63l.17,60.19h.11l-.17-60.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M473.38,218.62l.17,60.19.11,0-.17-60.19-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M473.49,218.6l.17,60.19.12,0-.17-60.19-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M473.61,218.57l.17,60.19.13-.05-.17-60.18-.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M473.74,218.53l.17,60.18.16-.07a.57.57,0,0,0,.34-.47L474.24,218a.57.57,0,0,1-.34.47l-.16.08Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M472.33,217.53a.49.49,0,0,0,0,.92,1.76,1.76,0,0,0,1.58,0c.45-.26.45-.67,0-.92A1.78,1.78,0,0,0,472.33,217.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M460.81,225.52a14.14,14.14,0,0,1,6.42,11.12l0,7.4-12.88-7.44,0-7.4C454.36,225.11,457.25,223.46,460.81,225.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "454.82 236.64 469.4 227.81 472.29 241.08 467.21 244.04 454.82 236.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "453.9 236.62 454.36 236.35 467.21 243.77 466.75 244.03 453.9 236.62"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M466.73,251.6l.46-.27v0l-.46.27v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M466.73,251.62l.46-.27c0,.11,0,.21,0,.31l-.46.26c0-.1,0-.2,0-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M466.72,251.92l.46-.26c0,.1,0,.19,0,.29l-.45.27c0-.1,0-.2,0-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M466.71,252.22l.45-.27,0,.3-.46.27c0-.1,0-.2,0-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M466.67,252.52l.46-.27c0,.1,0,.2-.05.3l-.45.26a2.54,2.54,0,0,0,0-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M466.63,252.81l.45-.26a1.7,1.7,0,0,1-.06.31l-.45.26.06-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M466.57,253.12l.45-.26c0,.11,0,.21-.08.32l-.46.26a3,3,0,0,0,.09-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M466.48,253.44l.46-.26a3,3,0,0,1-.11.32l-.45.27c0-.11.07-.22.1-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M466.38,253.77l.45-.27q-.07.19-.15.36l-.45.27.15-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M466.23,254.13l.45-.27a3.62,3.62,0,0,1-.24.43l-.45.26.24-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M466,254.55l.45-.26a3.13,3.13,0,0,1-1.08,1.06l-.46.26a3.15,3.15,0,0,0,1.09-1.06Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "466.75 244.03 467.21 243.77 467.19 251.34 466.73 251.6 466.75 244.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M466.75,244l0,7.57c0,4-2.83,5.57-6.28,3.58l-.33-.19a13.76,13.76,0,0,1-6.24-10.81l0-7.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "467.23 236.64 484.35 226.69 484.33 234.09 467.21 244.04 467.23 236.64"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M456.23,225.07l17.12-9.95c1.17-.68,2.79-.59,4.58.45l-17.12,10C459,224.48,457.4,224.39,456.23,225.07Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M456.23,225.07l17.12-9.95a2.71,2.71,0,0,1,.52-.24l-17.12,10a2.45,2.45,0,0,0-.52.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M456.75,224.83l17.12-10a3.81,3.81,0,0,1,.45-.13L457.2,224.7a3.33,3.33,0,0,0-.45.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M457.2,224.7l17.12-9.95.37-.05-17.12,10-.37,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M457.57,224.65l17.12-10,.34,0-17.13,9.95-.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M457.9,224.63,475,214.68h.3l-17.12,9.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M458.21,224.64l17.12-9.95.29,0-17.13,9.95-.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M458.49,224.67l17.13-9.95.28.05-17.12,9.95-.29-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M458.78,224.72l17.12-9.95.26.06L459,224.78l-.26-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M459,224.78l17.12-9.95.27.07-17.12,9.95-.27-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M459.31,224.85l17.12-9.95.26.09-17.13,9.95-.25-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M459.56,224.94,476.69,215l.26.09L459.82,225l-.26-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M459.82,225,477,215.08l.25.11-17.12,9.95-.26-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M460.08,225.14l17.12-9.95.26.13-17.12,10-.26-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M460.34,225.27l17.12-10,.27.13-17.13,10-.26-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M460.6,225.4l17.13-10,.2.12-17.12,10-.21-.12Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M460.81,225.52l17.12-10a14.14,14.14,0,0,1,6.42,11.12l-17.12,9.95A14.14,14.14,0,0,0,460.81,225.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M460.81,225.52l17.12-10,.07,0-17.13,10-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M460.87,225.55l17.13-10,.27.17-17.12,9.95-.28-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M461.15,225.72l17.12-9.95.27.18-17.12,10-.27-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M461.42,225.9l17.12-10,.28.2L461.7,226.1l-.28-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M461.7,226.1l17.12-9.95.28.22L462,226.32l-.28-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M462,226.32l17.12-9.95.29.23-17.12,10-.29-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M462.27,226.55l17.12-10,.29.25-17.13,10-.28-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M462.55,226.8l17.13-10,.28.26-17.12,9.95-.29-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M462.84,227.06,480,217.11l.27.27-17.12,10-.27-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M463.11,227.33l17.12-10,.27.28-17.13,10a3.45,3.45,0,0,0-.26-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M463.37,227.61l17.13-10,.25.28-17.13,9.95a3.33,3.33,0,0,0-.25-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M463.62,227.89l17.13-9.95.24.29-17.12,10a3.47,3.47,0,0,0-.25-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M463.87,228.18l17.12-10,.25.3-17.12,9.95-.25-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M464.12,228.48l17.12-9.95c.1.13.2.25.29.38l-17.12,10-.29-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M464.41,228.86l17.12-10c.14.19.28.38.41.58l-17.12,9.95-.41-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M464.82,229.44l17.12-9.95.48.76-17.13,9.95c-.15-.26-.31-.51-.47-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M465.29,230.2l17.13-9.95c.11.19.21.38.31.57l-17.12,10c-.1-.19-.21-.38-.32-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M465.61,230.77l17.12-10c.07.13.14.26.2.39l-17.12,9.95c-.06-.13-.13-.26-.2-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M465.81,231.16l17.12-9.95c.06.11.11.22.17.34L466,231.5a3.54,3.54,0,0,0-.16-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M466,231.5l17.13-9.95c0,.1.09.2.14.31l-17.12,9.95-.15-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M466.12,231.81l17.12-9.95.13.3-17.12,10-.13-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M466.25,232.11l17.12-10c0,.11.09.21.13.32l-17.13,10-.12-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M466.37,232.43l17.13-10c0,.1.08.21.11.31l-17.12,10-.12-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M466.49,232.74l17.12-10,.12.33-17.12,9.95-.12-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M466.61,233.07l17.12-9.95.11.33-17.13,10c0-.11-.07-.22-.1-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M466.71,233.4l17.13-10a3.37,3.37,0,0,0,.1.34l-17.13,10c0-.11-.06-.22-.1-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M466.81,233.74l17.13-10,.09.35-17.13,10-.09-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M466.9,234.09l17.13-10c0,.11.05.22.07.33L467,234.42c0-.11-.05-.22-.08-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M467,234.42l17.12-9.95c0,.12,0,.23.07.34l-17.12,9.95c0-.11,0-.22-.07-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M467.05,234.76l17.12-9.95.06.32-17.12,10-.06-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M467.11,235.08l17.12-10c0,.11,0,.22,0,.33l-17.12,9.95c0-.11,0-.22,0-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M467.15,235.41l17.12-9.95c0,.1,0,.21,0,.31l-17.12,9.95c0-.1,0-.21,0-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M467.19,235.72l17.12-9.95c0,.11,0,.21,0,.32L467.21,236c0-.11,0-.21,0-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M467.21,236l17.12-9.95a3,3,0,0,1,0,.31l-17.12,9.95c0-.1,0-.21,0-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M467.23,236.35l17.12-9.95v.29l-17.12,9.95v-.29Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M413.32,209.31a1.69,1.69,0,0,0-.77,1.32l0,4.51c0,.48.34.68.76.43L435.07,203a1.67,1.67,0,0,0,.76-1.32v-4.5c0-.48-.34-.68-.77-.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M418.32,209.55l0-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M417.53,210.43a.54.54,0,0,1-.25.43c-.14.08-.25,0-.25-.15a.56.56,0,0,1,.25-.43A.16.16,0,0,1,417.53,210.43Zm-.41.33c0,.05,0,.06.07,0l0,0,.06,0a.36.36,0,0,0,.16-.28c0-.11-.07-.15-.16-.1a.38.38,0,0,0-.17.28.14.14,0,0,0,0,.07,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M417.19,210.64a.15.15,0,0,0-.06.09,0,0,0,0,0,0,0c0,.05,0,.06.07,0l0,0a.21.21,0,0,0,0-.1S417.23,210.62,417.19,210.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M417.62,210.37a.76.76,0,0,1-.34.6c-.19.11-.35,0-.35-.2a.76.76,0,0,1,.35-.59C417.47,210.07,417.62,210.15,417.62,210.37Zm-.34.49a.54.54,0,0,0,.25-.43.16.16,0,0,0-.25-.15.56.56,0,0,0-.25.43c0,.16.11.23.25.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M417.28,210.76h-.06a.21.21,0,0,0,0-.1s0-.06-.07,0a.15.15,0,0,0-.06.09.14.14,0,0,1,0-.07h0v0h0v0s0,0,0,0v0l0,0h0v0h0l0,0,0,0h.06a.07.07,0,0,1,.06,0h0l0,0h0a.06.06,0,0,1,0,0v0h0a.11.11,0,0,1,0,0v0A.38.38,0,0,1,417.28,210.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M417.21,209.7a.29.29,0,0,0-.12.13c0,.07.09.1.23.07a.49.49,0,0,0,.17-.06q.11-.06.12-.12c0-.08-.08-.11-.23-.08A.85.85,0,0,0,417.21,209.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M416.13,211.23a.53.53,0,0,1-.25.43c-.14.08-.25,0-.25-.14a.54.54,0,0,1,.25-.43C416,211,416.13,211.08,416.13,211.23Zm-.41.34s0,.06.07,0l0,0,.06,0a.37.37,0,0,0,.16-.29c0-.1-.07-.14-.16-.09a.36.36,0,0,0-.16.28.15.15,0,0,0,0,.07,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M415.79,211.45s-.05.05-.06.09a0,0,0,0,0,0,0s0,.06.07,0l0,0a.14.14,0,0,0,0-.1C415.86,211.44,415.83,211.42,415.79,211.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M415.88,211.19a.36.36,0,0,0-.16.28.15.15,0,0,0,0,.07s0-.08.06-.09.07,0,.07,0a.14.14,0,0,1,0,.1l.06,0a.37.37,0,0,0,.16-.29C416,211.18,416,211.14,415.88,211.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M416.22,211.18a.75.75,0,0,1-.34.59c-.19.11-.34,0-.34-.19a.76.76,0,0,1,.34-.6C416.07,210.87,416.22,211,416.22,211.18Zm-.34.48a.53.53,0,0,0,.25-.43c0-.15-.11-.22-.25-.14a.54.54,0,0,0-.25.43c0,.16.11.22.25.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M415.92,210.48a.86.86,0,0,0-.17.13c-.15.14-.25.29-.23.35s.05,0,.12,0a.66.66,0,0,0,.17-.14c.14-.13.25-.29.23-.34S416,210.44,415.92,210.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M414.8,211.58l.05,0h0a1.44,1.44,0,0,0,.43-.59,1.39,1.39,0,0,1,.5-.64A3.91,3.91,0,0,0,417,209c.09.44.42.25.66.35s.09.22.64.16l0,0,.11-.05c.16,0,.28.07.28.27a.85.85,0,0,1-.39.68l0,0a4.34,4.34,0,0,1-1.73,2.72,1.07,1.07,0,0,1-1.71-.73l-.07,0c-.22.13-.39,0-.39-.22a.88.88,0,0,1,.27-.6Zm1.78,1a1.05,1.05,0,0,0,.48-.84l-1,.56c0,.31.22.44.49.28Zm1-2.17c0-.22-.15-.3-.34-.19a.76.76,0,0,0-.35.59c0,.22.16.31.35.2a.76.76,0,0,0,.34-.6Zm-1.74,1.4a.75.75,0,0,0,.34-.59c0-.22-.15-.31-.34-.2a.76.76,0,0,0-.34.6c0,.21.15.3.34.19Zm-.36-.81s.05,0,.12,0a.66.66,0,0,0,.17-.14c.14-.13.25-.29.23-.34s-.06,0-.12,0a.86.86,0,0,0-.17.13c-.15.14-.25.29-.23.35Zm1.86-1.32a.85.85,0,0,0-.17.06.29.29,0,0,0-.12.13c0,.07.09.1.23.07a.49.49,0,0,0,.17-.06q.11-.06.12-.12c0-.08-.08-.11-.23-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M416.58,212.54c-.27.16-.49,0-.49-.28l1-.56A1.05,1.05,0,0,1,416.58,212.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M416.44,208.69a4,4,0,0,0-1.59,2.86h0a1.44,1.44,0,0,0,.43-.59,1.35,1.35,0,0,1,.49-.63A4,4,0,0,0,417,209c.09.44.42.25.66.35s.09.22.64.16l0-.19c-.18-1.18-.6-1.15-1.62-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M416.57,208.29a4,4,0,0,0-1.44,1.58,4.33,4.33,0,0,0-.45,1.79l.12-.08.05,0a4,4,0,0,1,1.59-2.86l.23-.11c1-.37,1.44-.4,1.62.78l0,.19,0,0,.11-.05c0-.51-.27-1.77-1.35-1.43A3.37,3.37,0,0,0,416.57,208.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "420.59 206.16 420.6 206.92 435.15 198.51 435.15 197.76 420.59 206.16"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "420.58 209.62 420.59 210.38 435.14 201.97 435.14 201.22 420.58 209.62"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "426.12 204.82 426.12 205.58 435.15 200.36 435.15 199.61 426.12 204.82"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M413.32,234.86a1.69,1.69,0,0,0-.77,1.32l0,4.51c0,.48.34.68.76.43l21.74-12.55a1.67,1.67,0,0,0,.76-1.32v-4.5c0-.48-.34-.68-.77-.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M417.05,234.86c-.06,0-.09.06-.1.1s.07.08.19.06l.14-.05c.05,0,.09-.07.1-.11s-.07-.08-.19-.06A.35.35,0,0,0,417.05,234.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M418.09,235.37l-.11.08,0,0a3.94,3.94,0,0,1-.88,1.77,9.77,9.77,0,0,0,.25,1.37,2.82,2.82,0,0,1,.93-1.1A8.11,8.11,0,0,1,418.09,235.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M418,234.73l0-.15S418,234.67,418,234.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M417,235.62a.22.22,0,0,0,0,.08v0s0,.05.06,0l0,0a.15.15,0,0,0,0-.08S417.06,235.6,417,235.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M417.1,235.41a.32.32,0,0,0-.13.24.11.11,0,0,0,0,0,.22.22,0,0,1,0-.08s.06,0,.06,0a.15.15,0,0,1,0,.08l.05,0a.27.27,0,0,0,.14-.23C417.24,235.41,417.18,235.37,417.1,235.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M415.88,236.29a.13.13,0,0,0-.05.07v0s0,.05.05,0l0,0a.11.11,0,0,0,0-.08S415.92,236.27,415.88,236.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M416.24,236.07a.62.62,0,0,1-.28.48c-.16.09-.29,0-.29-.16a.62.62,0,0,1,.28-.48C416.11,235.82,416.24,235.89,416.24,236.07Zm-.28.39a.44.44,0,0,0,.2-.35c0-.13-.09-.18-.21-.11a.44.44,0,0,0-.2.35c0,.13.09.18.21.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M414.75,237c0,.17.09.25.23.22a.18.18,0,0,0,.09,0l.05,0a.91.91,0,0,0,.75.76,1.07,1.07,0,0,0,.66-.16,2.28,2.28,0,0,0,.54-.46,3.94,3.94,0,0,0,.88-1.77l0,0,.11-.08a.7.7,0,0,0,.21-.47.23.23,0,0,0-.1-.22.26.26,0,0,0-.22,0l0,0c-.45.05-.34,0-.53-.13s-.46.07-.54-.29a3.33,3.33,0,0,1-1,1.05,1.11,1.11,0,0,0-.41.52,1.13,1.13,0,0,1-.35.48h0l0,0a.65.65,0,0,0-.17.16A.71.71,0,0,0,414.75,237Zm2.44-2.15c.12,0,.2,0,.19.06s-.05.07-.1.11l-.14.05c-.12,0-.2,0-.19-.06s0-.07.1-.1a.35.35,0,0,1,.14-.06Zm-.09,1.09c-.15.09-.28,0-.28-.16a.61.61,0,0,1,.28-.49c.16-.09.28,0,.28.16a.61.61,0,0,1-.28.49Zm-.57,1.3c-.22.12-.4,0-.4-.23l.8-.46a.89.89,0,0,1-.4.69Zm-.57-.64c-.16.09-.29,0-.29-.16a.62.62,0,0,1,.28-.48c.16-.09.29,0,.29.16a.62.62,0,0,1-.28.48Zm-.3-.67s.07-.17.19-.28a.6.6,0,0,1,.14-.11c.05,0,.09,0,.1,0s-.07.17-.19.28a.48.48,0,0,1-.15.11c-.05,0-.08,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M416.53,237.19c-.22.12-.4,0-.4-.23l.8-.46A.89.89,0,0,1,416.53,237.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M417.31,235.45a.43.43,0,0,1-.21.35c-.11.07-.2,0-.2-.11a.47.47,0,0,1,.2-.36C417.21,235.27,417.31,235.32,417.31,235.45Zm-.34.27s0,.05.06,0l0,0,.05,0a.27.27,0,0,0,.14-.23c0-.08-.06-.12-.14-.08a.32.32,0,0,0-.13.24.11.11,0,0,0,0,0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M417.38,235.4a.61.61,0,0,1-.28.49c-.15.09-.28,0-.28-.16a.61.61,0,0,1,.28-.49C417.26,235.15,417.38,235.23,417.38,235.4Zm-.28.4a.43.43,0,0,0,.21-.35c0-.13-.1-.18-.21-.12a.47.47,0,0,0-.2.36c0,.13.09.18.2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M416.16,236.11a.44.44,0,0,1-.2.35c-.12.07-.21,0-.21-.11a.44.44,0,0,1,.2-.35C416.07,235.93,416.16,236,416.16,236.11Zm-.33.28s0,.05.05,0l0,0,0,0a.29.29,0,0,0,.13-.23c0-.08-.06-.12-.14-.07a.29.29,0,0,0-.13.23.09.09,0,0,0,0,.05v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M416,236.08a.29.29,0,0,0-.13.23.09.09,0,0,0,0,.05.13.13,0,0,1,.05-.07s.06,0,.06,0a.11.11,0,0,1,0,.08l0,0a.29.29,0,0,0,.13-.23C416.09,236.07,416,236,416,236.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M416,235.49a.6.6,0,0,0-.14.11c-.12.11-.21.24-.19.28s0,0,.09,0a.48.48,0,0,0,.15-.11c.12-.11.2-.24.19-.28S416,235.46,416,235.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M416.41,234a3.24,3.24,0,0,0-1.3,2.34h0a1.13,1.13,0,0,0,.35-.48,1.16,1.16,0,0,1,.4-.52,3.29,3.29,0,0,0,1-1.05c.08.36.34.21.54.29s.08.18.53.13q0-.09,0-.15c-.15-1-.48-1-1.32-.64A.72.72,0,0,0,416.41,234Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M416.51,233.53a3.53,3.53,0,0,0-1.34,1.48,3.2,3.2,0,0,0-.27,1.54.52.52,0,0,1,.17-.16l0,0a3.24,3.24,0,0,1,1.3-2.34.72.72,0,0,1,.2-.09c.84-.31,1.17-.34,1.32.64l0,.15,0,0a.26.26,0,0,1,.22,0c0-.41,0-1.5-.81-1.44A2,2,0,0,0,416.51,233.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M415,237.17a12.12,12.12,0,0,1-.23,2.46l.08-.06a1.78,1.78,0,0,1,.88-.16,10.94,10.94,0,0,0,.16-1.55.91.91,0,0,1-.75-.76l-.05,0A.18.18,0,0,1,415,237.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "420.59 231.71 420.59 232.47 435.15 224.06 435.14 223.31 420.59 231.71"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "420.58 235.17 420.58 235.92 435.14 227.52 435.13 226.76 420.58 235.17"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "426.12 230.37 426.12 231.12 435.15 225.91 435.14 225.15 426.12 230.37"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M413.32,226.65a1.66,1.66,0,0,0-.77,1.32l0,4.5c0,.49.34.68.76.44l21.74-12.55a1.71,1.71,0,0,0,.76-1.32v-4.51c0-.48-.34-.68-.77-.43Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M417.06,227.06c-.06,0-.11.08-.12.12s.09.12.24.08a.55.55,0,0,0,.18-.06.24.24,0,0,0,.12-.13c0-.08-.09-.12-.24-.08A.56.56,0,0,0,417.06,227.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M418.22,226.89l0-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M417,228a.31.31,0,0,0-.07.09v0c0,.05,0,.07.07,0l0,0a.16.16,0,0,0,.05-.11S417.08,228,417,228Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M417.49,227.75a.78.78,0,0,1-.36.62c-.2.12-.36,0-.36-.2a.78.78,0,0,1,.36-.62C417.33,227.43,417.49,227.53,417.49,227.75Zm-.36.51a.55.55,0,0,0,.26-.45c0-.16-.11-.23-.26-.15a.61.61,0,0,0-.26.45c0,.17.12.23.26.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.13,227.77a.37.37,0,0,0-.17.29s0,.05,0,.06A.31.31,0,0,1,417,228s.08,0,.08,0a.16.16,0,0,1-.05.11l.06,0a.38.38,0,0,0,.17-.3C417.3,227.76,417.23,227.71,417.13,227.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M415.58,228.87a.17.17,0,0,0-.06.1,0,0,0,0,0,0,0c0,.05,0,.07.07,0l0,0a.16.16,0,0,0,.05-.1A.05.05,0,0,0,415.58,228.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M415.93,228.65a.55.55,0,0,1-.26.45c-.14.09-.25,0-.26-.15a.61.61,0,0,1,.26-.45C415.82,228.42,415.93,228.49,415.93,228.65Zm-.42.35c0,.05,0,.07.07,0l0,0,.06,0a.38.38,0,0,0,.17-.3c0-.1-.07-.15-.17-.09a.37.37,0,0,0-.17.29.14.14,0,0,0,0,.07,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.67,228.61a.37.37,0,0,0-.17.29.14.14,0,0,0,0,.07.17.17,0,0,1,.06-.1.05.05,0,0,1,.08,0,.16.16,0,0,1-.05.1l.06,0a.38.38,0,0,0,.17-.3C415.84,228.6,415.77,228.55,415.67,228.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M416.25,226a4.15,4.15,0,0,0-1.65,3l0,0a1.37,1.37,0,0,0,.43-.61,1.51,1.51,0,0,1,.48-.64l.05,0a1,1,0,0,0,.23-.12,3.42,3.42,0,0,0,1.09-1c.44.23.4,0,.65.15s.1.23.67.16l0-.19c-.19-1.23-.62-1.2-1.69-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M414.55,229l.05,0,0,0a1.37,1.37,0,0,0,.43-.61,1.51,1.51,0,0,1,.48-.64l.05,0a1,1,0,0,0,.23-.12,3.42,3.42,0,0,0,1.09-1c.44.23.4,0,.65.15s.1.23.67.16l0,0,.12-.05c.17,0,.29.07.29.29a.91.91,0,0,1-.41.71l0,0a4.5,4.5,0,0,1-1.8,2.83,1.13,1.13,0,0,1-1.79-.76l-.07,0c-.23.13-.41,0-.41-.23a.92.92,0,0,1,.29-.62A.47.47,0,0,1,414.55,229Zm1.85,1a1.13,1.13,0,0,0,.51-.88l-1,.59c0,.32.23.45.51.29Zm1.09-2.27c0-.22-.16-.32-.36-.2a.78.78,0,0,0-.36.62c0,.23.16.32.36.2a.78.78,0,0,0,.36-.62Zm-1.82,1.47a.81.81,0,0,0,.36-.62c0-.23-.16-.32-.36-.21a.76.76,0,0,0-.35.62c0,.23.16.32.35.21Zm-.37-.86s.05,0,.12,0a.75.75,0,0,0,.18-.15c.15-.14.26-.3.24-.35s-.06,0-.12,0a.73.73,0,0,0-.18.14c-.16.15-.26.31-.24.36Zm1.94-1.37a.56.56,0,0,0-.18.07c-.06,0-.11.08-.12.12s.09.12.24.08a.55.55,0,0,0,.18-.06.24.24,0,0,0,.12-.13c0-.08-.09-.12-.24-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M416.4,230c-.28.16-.51,0-.51-.29l1-.59A1.13,1.13,0,0,1,416.4,230Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M415.72,227.86a.73.73,0,0,0-.18.14c-.16.15-.26.31-.24.36s.05,0,.12,0a.75.75,0,0,0,.18-.15c.15-.14.26-.3.24-.35S415.78,227.83,415.72,227.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M417.39,227.81a.55.55,0,0,1-.26.45c-.14.08-.26,0-.26-.15a.61.61,0,0,1,.26-.45C417.28,227.58,417.39,227.65,417.39,227.81Zm-.42.35c0,.05,0,.07.07,0l0,0,.06,0a.38.38,0,0,0,.17-.3c0-.1-.07-.15-.17-.09a.37.37,0,0,0-.17.29s0,.05,0,.06v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M416,228.6a.81.81,0,0,1-.36.62c-.19.11-.35,0-.35-.21a.76.76,0,0,1,.35-.62C415.87,228.28,416,228.37,416,228.6Zm-.36.5a.55.55,0,0,0,.26-.45c0-.16-.11-.23-.26-.15a.61.61,0,0,0-.26.45c0,.17.12.24.26.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M416.39,225.59a4.11,4.11,0,0,0-1.5,1.64,4.37,4.37,0,0,0-.46,1.87.47.47,0,0,1,.12-.09l.05,0a4.15,4.15,0,0,1,1.65-3l.25-.11c1.07-.39,1.5-.42,1.69.81l0,.19,0,0,.12-.05c-.05-.53-.29-1.85-1.42-1.48A2.81,2.81,0,0,0,416.39,225.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "420.58 227.13 420.59 227.88 435.14 219.48 435.14 218.72 420.58 227.13"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "426.12 222.23 426.12 222.99 435.15 217.78 435.15 217.02 426.12 222.23"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "426.12 220.36 426.12 221.12 435.15 215.91 435.15 215.15 426.12 220.36"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M417,215.75a1.69,1.69,0,0,0-.77,1.33l0,4.5c0,.48.34.68.76.43l21.74-12.54a1.71,1.71,0,0,0,.76-1.32v-4.51c0-.48-.35-.68-.77-.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420,217.61a.32.32,0,0,0-.15.26.13.13,0,0,0,0,.06.1.1,0,0,1,.06-.08s.06,0,.06,0a.14.14,0,0,1,0,.1l.06,0a.35.35,0,0,0,.15-.26C420.12,217.6,420.06,217.56,420,217.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M420.29,217.6a.71.71,0,0,1-.31.55c-.18.1-.32,0-.32-.18a.71.71,0,0,1,.31-.55C420.15,217.32,420.29,217.4,420.29,217.6Zm-.31.45a.53.53,0,0,0,.22-.4c0-.14-.1-.2-.23-.13a.51.51,0,0,0-.22.4c0,.14.1.2.23.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M420.2,217.65a.53.53,0,0,1-.22.4c-.13.07-.23,0-.23-.13a.51.51,0,0,1,.22-.4C420.1,217.45,420.2,217.51,420.2,217.65Zm-.37.31s0,.06.07,0l0,0,.06,0a.35.35,0,0,0,.15-.26c0-.1-.07-.14-.15-.09a.32.32,0,0,0-.15.26.13.13,0,0,0,0,.06,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M417.76,218.68h0a1.25,1.25,0,0,0,.38-.54,1.33,1.33,0,0,1,.46-.58,3.63,3.63,0,0,0,1.12-1.17c.08.41.38.23.6.33s.09.19.59.14l0,0c.2-.12.37,0,.37.2a.81.81,0,0,1-.36.63h0a4,4,0,0,1-1.58,2.49,1,1,0,0,1-1.57-.67l-.06,0c-.2.12-.36,0-.36-.2a.81.81,0,0,1,.36-.63Zm1.58.91a1,1,0,0,0,.44-.77l-.89.51c0,.29.2.4.45.26Zm1-2c0-.2-.14-.28-.32-.18a.71.71,0,0,0-.31.55c0,.2.14.28.32.18a.71.71,0,0,0,.31-.55Zm-1.59,1.28a.69.69,0,0,0,.31-.54c0-.2-.14-.28-.31-.18a.68.68,0,0,0-.32.54c0,.2.14.28.32.18Zm-.33-.74s.05,0,.1,0a.74.74,0,0,0,.16-.12c.13-.13.23-.27.21-.31s0,0-.11,0l-.16.12c-.13.13-.22.27-.2.32Zm1.7-1.21a.52.52,0,0,0-.16.06c-.05,0-.1.08-.1.11s.07.1.21.07a.39.39,0,0,0,.15-.06.19.19,0,0,0,.11-.11c0-.07-.07-.1-.21-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M419.9,217.85a.1.1,0,0,0-.06.08,0,0,0,0,0,0,0s0,.06.07,0l0,0a.14.14,0,0,0,0-.1S419.93,217.83,419.9,217.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M418.89,219.33c0,.29.2.4.45.26a1,1,0,0,0,.44-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M418.62,218.58a.15.15,0,0,0-.06.09s0,0,0,0,0,.05.07,0l0,0a.11.11,0,0,0,0-.09S418.65,218.56,418.62,218.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.7,218.35a.31.31,0,0,0-.15.26.13.13,0,0,0,0,.06.15.15,0,0,1,.06-.09s.06,0,.06,0a.11.11,0,0,1,0,.09.07.07,0,0,0,.06,0,.32.32,0,0,0,.15-.25C418.85,218.34,418.78,218.3,418.7,218.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M419,218.34a.69.69,0,0,1-.31.54c-.18.1-.32,0-.32-.18a.68.68,0,0,1,.32-.54C418.87,218.06,419,218.14,419,218.34Zm-.31.44a.49.49,0,0,0,.22-.39c0-.14-.1-.2-.22-.13a.49.49,0,0,0-.23.39c0,.15.1.21.23.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M418.58,216.63a2.33,2.33,0,0,0-.82,2.05h0a1.25,1.25,0,0,0,.38-.54,1.38,1.38,0,0,1,.45-.58,3.59,3.59,0,0,0,1.13-1.17c.08.41.38.23.6.33s.09.19.59.14l0-.18c-.11-.74-.33-.95-.75-.91a1.43,1.43,0,0,1-.15.22s-.42.29-.76.48a2,2,0,0,1-.28.15A.4.4,0,0,1,418.58,216.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M420.93,216.85l0-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M418.73,217.7l-.16.12c-.13.13-.22.27-.2.32s.05,0,.1,0a.74.74,0,0,0,.16-.12c.13-.13.23-.27.21-.31S418.79,217.67,418.73,217.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M418.92,218.39a.49.49,0,0,1-.22.39c-.13.08-.23,0-.23-.13a.49.49,0,0,1,.23-.39C418.82,218.19,418.92,218.25,418.92,218.39Zm-.37.31s0,.05.07,0l0,0a.07.07,0,0,0,.06,0,.32.32,0,0,0,.15-.25c0-.1-.07-.14-.15-.09a.31.31,0,0,0-.15.26.13.13,0,0,0,0,.06s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M419.91,217c-.05,0-.1.08-.1.11s.07.1.21.07a.39.39,0,0,0,.15-.06.19.19,0,0,0,.11-.11c0-.07-.07-.1-.21-.07A.52.52,0,0,0,419.91,217Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M418.36,216.28c.06.36.22.59.5.47.1-.05.2-.14.31-.2.34-.2.74-.47.76-.48a1.5,1.5,0,0,0,.15-.23c.55-.89.05-1.2-.69-.94A1.44,1.44,0,0,0,418.36,216.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "424.03 212.83 424.03 213.58 438.59 205.18 438.59 204.42 424.03 212.83"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "429.6 211.38 429.6 212.14 438.63 206.93 438.62 206.17 429.6 211.38"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "431.34 212.09 431.34 212.85 438.59 208.66 438.59 207.91 431.34 212.09"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "422.49 230.78 422.49 232.31 437.69 239.62 422.49 230.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "422.1 231.48 416.44 235.11 437.69 239.62 422.1 231.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "422.49 230.78 437.69 239.62 428.31 227.42 422.49 230.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M420.75,231l-.07,0a24.87,24.87,0,0,1-4.81-3.79c-2.44.24-5.26-1.69-5.38-1.78a.28.28,0,0,1-.07-.39.28.28,0,0,1,.38-.07,10,10,0,0,0,4.66,1.71h0a3.78,3.78,0,0,1-.55-3.54,2.15,2.15,0,0,1,1.73-1.6,2.12,2.12,0,0,1,2,.94,2.82,2.82,0,0,1-.17,3.05,3.25,3.25,0,0,1-2,1.57A27.2,27.2,0,0,0,421,230.5l.07.05a.29.29,0,0,1,.08.39.28.28,0,0,1-.23.12A.33.33,0,0,1,420.75,231Zm-4-9a1.62,1.62,0,0,0-1.29,1.22,3.4,3.4,0,0,0,.67,3.32l.13,0a2.73,2.73,0,0,0,1.81-1.35,2.32,2.32,0,0,0,.18-2.47,1.58,1.58,0,0,0-1.3-.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "399.97 296.08 398.55 295.26 394.53 244.25 395.95 245.07 399.97 296.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "395.95 245.07 394.53 244.25 396.77 242.74 398.19 243.56 395.95 245.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "398.19 243.56 402.22 294.58 399.97 296.08 395.95 245.07 398.19 243.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "412.99 288.55 411.56 287.72 407.54 236.71 408.96 237.54 412.99 288.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "408.96 237.54 407.54 236.71 409.78 235.21 411.21 236.03 408.96 237.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "411.21 236.03 415.23 287.04 412.99 288.55 408.96 237.54 411.21 236.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "398.81 251.42 409.53 244.69 409.68 246.61 398.96 253.32 398.81 251.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "409.53 244.69 408.11 243.91 398.68 249.74 398.81 251.42 409.53 244.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "399.65 262.06 410.37 255.33 410.52 257.25 399.8 263.96 399.65 262.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "410.37 255.33 408.95 254.54 399.52 260.38 399.65 262.06 410.37 255.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "400.47 272.47 411.18 265.74 411.33 267.66 400.62 274.37 400.47 272.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "411.18 265.74 409.76 264.95 400.33 270.79 400.47 272.47 411.18 265.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "401.26 282.5 411.97 275.77 412.13 277.69 401.41 284.4 401.26 282.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "411.97 275.77 410.56 274.98 401.13 280.82 401.26 282.5 411.97 275.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "389.59 234.54 371.22 245.14 371.27 260.17 389.63 249.57 389.59 234.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "379.32 248.56 379.3 242.7 387.96 237.7 387.99 247.65 379.33 252.65 379.32 248.56 379.32 248.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "372.17 250.4 372.17 249.68 378.06 246.28 378.06 247 372.17 250.4 372.17 250.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "372.16 247.53 372.16 246.81 378.05 243.41 378.06 244.13 372.16 247.53 372.16 247.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "372.17 249.04 372.17 248.32 378.06 244.92 378.06 245.64 372.17 249.04 372.17 249.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "374.32 250.52 374.32 249.8 378.06 247.64 378.07 248.36 374.32 250.52 374.32 250.52"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M390.37,219.74a13.74,13.74,0,0,0-6.23,10.79c0,4,2.82,5.56,6.27,3.57a13.69,13.69,0,0,0,6.22-10.78C396.62,219.35,393.82,217.75,390.37,219.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M397.57,225.19a10.92,10.92,0,0,1-5,8.59c-2.74,1.59-5,.31-5-2.84a10.92,10.92,0,0,1,5-8.59C395.33,220.76,397.56,222,397.57,225.19Zm-7.92,6.68,4.89-2.83,1.46-.36-.68-.69v-4.07l-5.68,3.28,0,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M393.85,226.55a1.06,1.06,0,0,0-.49.83c0,.31.22.43.49.28a1.05,1.05,0,0,0,.48-.83C394.33,226.52,394.11,226.39,393.85,226.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M391.11,228.13a1.06,1.06,0,0,0-.49.83c0,.31.22.44.49.28a1.05,1.05,0,0,0,.48-.83C391.59,228.1,391.37,228,391.11,228.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M392.48,227.34a1.06,1.06,0,0,0-.49.83c0,.31.22.44.49.28a1.05,1.05,0,0,0,.48-.83C393,227.31,392.74,227.18,392.48,227.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M395.32,228l.68.69-1.46.36-4.89,2.83,0-4.67,5.68-3.28Zm-2.84.46a1.05,1.05,0,0,0,.48-.83c0-.31-.22-.44-.48-.28a1.06,1.06,0,0,0-.49.83c0,.31.22.44.49.28Zm-1.37.79a1.05,1.05,0,0,0,.48-.83c0-.31-.22-.44-.48-.28a1.06,1.06,0,0,0-.49.83c0,.31.22.44.49.28Zm2.74-1.58a1.05,1.05,0,0,0,.48-.83c0-.31-.22-.44-.48-.28a1.06,1.06,0,0,0-.49.83c0,.31.22.43.49.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M398.86,224.45a13.79,13.79,0,0,1-6.24,10.81c-3.46,2-6.27.39-6.28-3.58a13.76,13.76,0,0,1,6.24-10.81C396,218.87,398.84,220.48,398.86,224.45Zm-6.25,9.33a10.92,10.92,0,0,0,5-8.59c0-3.15-2.24-4.43-5-2.84a10.92,10.92,0,0,0-5,8.59c0,3.15,2.25,4.43,5,2.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M407.53,245.57c1.68-.16,2.32,2.3,2.14,4.5s-.63,6.34-.2,7.63a23.37,23.37,0,0,1,.45,7.37c-.24,2.38.94,3.06.27,3.88s-4.55-.65-4.55-.65l.3-1.06s1.61.35,2,0c.64-.62-1.2-5.32-1.42-8.28a52.48,52.48,0,0,1-.12-8.42A32,32,0,0,1,407.53,245.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M410.19,267.55c-.24,0-.36.32-.94.55a5.18,5.18,0,0,1-2.36,0c-.55-.19-1.19-.69-.81-.88l.09,0a4.06,4.06,0,0,0-1.78-.09c-.16.22.35,1.29,1.07,1.5.54.15,1.07.08,2.34.26.86.12,1.18.49,2.07.37.7-.1.65-.7.58-1.18S410.28,267.54,410.19,267.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M404.39,246.22c1.67-.16,2.32,2.3,2.13,4.5s-.63,6.34-.2,7.63a23.37,23.37,0,0,1,.45,7.37c-.23,2.39.94,3.06.28,3.89s-4.55-.66-4.55-.66l-.09-.74.39-.32s1.6.35,2,0c.63-.63-1.21-5.32-1.42-8.29a51.34,51.34,0,0,1-.12-8.42A32,32,0,0,1,404.39,246.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M407,268.2c-.24,0-.35.32-.94.55a7.34,7.34,0,0,1-2.36.05c-1.13-.17-1.23-.88-.81-.88h.1a3.36,3.36,0,0,0-1.71,0c-.15.37.31,1.1,1,1.31.53.15,1,.14,2.29.32.86.12,1.19.49,2.07.37.7-.1.65-.7.59-1.18S407.13,268.2,407,268.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M401.71,222.6a1.7,1.7,0,0,0-1.07,1.58c0,.46.15.93.13,1.26s-.07.84-.08,1.35.36,2.12,1.42,2.06c.83,0,.38,1.75.38,1.75a2.83,2.83,0,0,0,1.82.78,3.38,3.38,0,0,0,1.82-.86,6.46,6.46,0,0,1-.81-2.93,27.36,27.36,0,0,0-.28-4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M403.3,227.37c.25-.53,1.5-.14,2,0,0,.06,0,.12,0,.17a2.82,2.82,0,0,0,0,.86c-.13.59-.28,1.24-.3,1.29s-1.05,1-1.62,1.47a3.5,3.5,0,0,1-.95-.61s.45-1.79-.38-1.75a.9.9,0,0,1-.47-.1A4.75,4.75,0,0,0,403.3,227.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.19,241.6c.73,2.29,2.09,2.27,2,6.09-.1,3.31-1.15,5.69-.59,8.76s.48,2.37.85,5.17c.16,1.22.13,5.32-.2,5.67a2.07,2.07,0,0,1-2.27-.16c-.57-.84-.23-2.92-1.26-5.83s-.2-3.59-.53-6-1.28-11.84-1.28-11.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M406.69,241.87c1.34,2.69,1.94,3.64,1,6.51-1.1,3.4-1.44,5.26-1,7.81a34.92,34.92,0,0,1,.46,4.7c.13,2.19.33,6-.21,6.57-.29.33-1.91.39-2.24-.09s-2.14-10.89-2.17-12c-.05-2.38-.31-4.72-.18-7.72.1-2-.46-3.86-.29-5S406.69,241.87,406.69,241.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M398.44,226.9c-.43-.3-.59-2.39-1.52-2.72s-1.49-.62-1.55-.42,1.24.77,1.21,1.09-.51,1.06.11,1.56a2.72,2.72,0,0,1,.84,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M406.26,234s-3-1.94-4.7-3.33a15.89,15.89,0,0,1-3.14-4.14l-1.41.67a20.26,20.26,0,0,0,2.72,4.77,33.73,33.73,0,0,0,5.38,4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M402.46,230.62a4.4,4.4,0,0,0,2.11,0c1-.24.42-1.25,1.31-1.29.61,0,2.65,1.06,2.64,6.31,0,2.08-.36,4,0,6.12-.45,1.54-3.26,2.29-6.51,1.44.3-3.51-1.27-4.11-1.38-5.86-.06-.9-1-4.68-.43-5.06C401.4,231.56,402.15,230.51,402.46,230.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M393.66,232.65a1.49,1.49,0,0,1-.32-.69c-.06-.39.06-1.67-.29-1.7s-.09.77-.27.78c-.35,0-.48-2.06-.77-2s.09,1.08-.05,1.08a.34.34,0,0,0-.31.26c0,.12-.1.07-.21.17s0,.19-.05.23a.27.27,0,0,0-.15.28,2.61,2.61,0,0,0,.71,1.38c.65.44.6.82.6.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M401,231.88c1.54.28,1.3,3.17.2,5.57-1,2.1-2.15,2.94-3.16,3.06-2.42.3-5.7-7.47-5.7-7.47l1.29-.73,4,4.83S399.16,231.55,401,231.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M403.27,228.47a5.19,5.19,0,0,1-.85-2.69c.24-.36.23-.83-.11-.9s-.51.51-1.12.33c-1-.29-.86-1.47-.61-2a2.66,2.66,0,0,1,2.36-1.33h.33a3,3,0,0,1,.54,0,2.85,2.85,0,0,1,2.52,2.74c.3,2.37-1.47,3.28-.87,4.85s.68,1.09.8,1.94-.67,1.4-.33,1.81.68,1.4.4,1.83-.52,1-.28,1.34.8.8.44,1.39-.82.69-.68,1.32.71.72.2,2.09a1.45,1.45,0,0,1-.63-2c.38-1-.74-1.3-.48-2.09s.57-.68.35-1.31-.67-.59-.46-1.62c.16-.74.4-.76.34-1.24s-1.09-.87-.93-2.05A3.9,3.9,0,0,0,403.27,228.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "451.62 220.09 451.62 221.17 442.32 226.54 442.32 225.46 451.62 220.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "453.91 212.61 453.91 213.68 442.32 220.38 442.32 219.3 453.91 212.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "453.91 215.54 453.91 216.62 442.32 223.31 442.32 222.24 453.91 215.54"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M459.44,207.64c.8-.46,1.44-.15,1.44.68l0,7,2.54,3.23-5.21.94-17.66,10.2c-.8.46-1.44.15-1.44-.69l0-8.08a3,3,0,0,1,1.43-2.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M460.33,203.3c1.7-1,3.08-.19,3.08,1.76a6.73,6.73,0,0,1-3.06,5.3c-1.7,1-3.08.19-3.08-1.76A6.72,6.72,0,0,1,460.33,203.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M446.27,271.82c-2.47,1.42-2.48,3.73,0,5.16a9.85,9.85,0,0,0,8.91,0c2.47-1.43,2.48-3.74,0-5.16A9.79,9.79,0,0,0,446.27,271.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M449.86,274.72c-.19.79-.27,2.39.71,2.37,1.77,0,1.26-1,2.41-1.18,2.54-.48,3-2.28,2.43-2.77s-1.32,0-2,.28c-.41.18-2.06.79-2.06.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M449.82,274.49c-.18.79-.27,2.38.71,2.37,1.77,0,1.27-1,2.41-1.19,2.55-.48,3-2.28,2.43-2.77s-1.31,0-2,.28c-.41.19-2.06.79-2.06.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M446.29,273.54c-.18.79-.27,2.38.71,2.37,1.77,0,1.26-1,2.41-1.19,2.54-.47,3-2.28,2.43-2.76s-1.31,0-2,.27c-.41.19-2.06.8-2.06.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.26,273.3c-.19.79-.28,2.39.71,2.37,1.76,0,1.26-1,2.4-1.18,2.55-.48,3-2.28,2.43-2.77s-1.31,0-2,.28c-.4.19-2.05.79-2.05.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M445.42,247.23s-1.44,1.84-.77,6.08,1.13,6.62.8,8.79.79,7.21.6,9.2.27,2.46.9,2.52,2.4.21,2.39-.63.09-4.83.27-6a29.87,29.87,0,0,0,.21-5.86c-.12-1.72,0-3.31-.11-5.35-.15-2.45-.74-6-.44-7.81C449.76,245.2,445.42,247.23,445.42,247.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M447.4,247.34s-.89,1.34-.52,5.09c.24,2.38,1.92,5.6,1.85,7.47a29.75,29.75,0,0,0,.11,7.07c.49,2.55.3,5.63.82,8.06a3.38,3.38,0,0,0,2.82-.64c.14-.54.14-3.86.67-6.38a52.27,52.27,0,0,0,.71-11.7c-.17-2,.29-3.93-.09-8.21C453.48,244.89,447.4,247.34,447.4,247.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.69,232.86c-2.83-.3-3.53,5.13-4.17,8.11-.6,2.82,2.76,3.51,4.47,3.62S446.69,232.86,446.69,232.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M446.22,232.87a4,4,0,0,1,2.43.45,5.94,5.94,0,0,0,2.52.54c1.24,0,4.06.25,4.75,1.6.86,1.66-1.4,6.32-1.8,7.81a25.58,25.58,0,0,0-.17,5.44c0,.55-4,.52-6.49.18s-2.81-.57-2.93-2.8c0-.84,0-2.82-.38-5.63C443.85,237.89,444.49,233.4,446.22,232.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M452.35,226c1,0,1.14,1,1.14,1.51s-.21,1.07-.16,1.4a5.4,5.4,0,0,1,.08,1.55c-.1.53,0,2-1.3,1.91-.94,0-.25,1.78-.25,1.78a2.89,2.89,0,0,1-1.78.91,3.44,3.44,0,0,1-1.88-.74,6.45,6.45,0,0,0,.61-3,27.45,27.45,0,0,1,0-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M462.41,236.93a2.08,2.08,0,0,0,.55-.83c.15-.48.09-2.14.71-2.09.41,0,0,1,.18,1,.45.1.89-2.54,1.39-2.43s-.33,1.35-.16,1.38a.45.45,0,0,1,.35.39c0,.16.12.11.23.25s-.06.25,0,.32a.31.31,0,0,1,.13.38,3.34,3.34,0,0,1-1.18,1.6c-.91.44-.93.93-.93.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M454.57,234.44c-1.81,0-2.06,3.36-1.23,6.28.72,2.55,1.9,3.72,3,4,2.69.78,7.9-7.31,7.9-7.31l-1.61-1.37L457.47,241S456.75,234.39,454.57,234.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M447.43,226.48a3.39,3.39,0,0,1,.86-1.12v0c.66-1.06,1.79-1.61,3.74-.9.92.34,2.13-.32,2.53,1.44a1.5,1.5,0,0,1-1.24,2h0a3.54,3.54,0,0,1-.62.44c-.65.38-1,.2-1,.73,0,.21,0,.69-.05.75s-.43,0-.43,0l0-1.15s-.42-.39-.72,0,.49,1,.19,1.55a3,3,0,0,1-1.1,1.08c-.59.29-.51.56-.79.29S446.57,228.24,447.43,226.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M461.09,204.38V208l-.65.37v-2.32c0-.16,0-.35,0-.54a4,4,0,0,1-.78.92l-.09-.59a4.08,4.08,0,0,0,1-1.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M348.34,240.71c4,2.33,4.06,6.12.05,8.45l-89.65,52.1a16.1,16.1,0,0,1-14.59,0l-90.24-52.1c-4-2.33-4.06-6.12,0-8.45l89.65-52.1a16.12,16.12,0,0,1,14.6,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M348.34,211.33c4,2.33,4.06,6.12.05,8.45l-89.65,52.1a16.1,16.1,0,0,1-14.59,0l-90.24-52.1c-4-2.33-4.06-6.12,0-8.45l89.65-52.1a16.12,16.12,0,0,1,14.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M349.23,210.81c4.53,2.61,4.55,6.87,0,9.48l-89.65,52.1c-4.5,2.61-11.84,2.61-16.37,0L153,220.29c-4.53-2.61-4.55-6.86-.06-9.48l89.65-52.1c4.5-2.61,11.84-2.61,16.37,0Zm-90.49,61.07,89.65-52.1c4-2.33,4-6.12-.05-8.45l-90.23-52.1a16.12,16.12,0,0,0-14.6,0l-89.65,52.1c-4,2.33-4,6.12,0,8.45l90.24,52.1a16.1,16.1,0,0,0,14.59,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M352.64,215.58l0,10.25c0,1.71-1.12,3.41-3.36,4.71l0-10.25C351.52,219,352.63,217.29,352.64,215.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M352.64,215.58l0,10.25v.1l0-10.24v-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M352.64,215.69l0,10.24a3.72,3.72,0,0,1-.08.67l0-10.25a3.72,3.72,0,0,0,.08-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M352.56,216.35l0,10.25a3,3,0,0,1-.19.65l0-10.24a4.1,4.1,0,0,0,.19-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M352.37,217l0,10.24a3.93,3.93,0,0,1-.3.66l0-10.24a3.92,3.92,0,0,0,.31-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M352.06,217.67l0,10.24a6.12,6.12,0,0,1-.47.7l0-10.25a5.51,5.51,0,0,0,.46-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M351.6,218.36l0,10.25a7.32,7.32,0,0,1-.72.77l0-10.25a7.32,7.32,0,0,0,.72-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M350.88,219.13l0,10.25a9.07,9.07,0,0,1-1.46,1.08l0-10.25a9.07,9.07,0,0,0,1.46-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M349.42,220.21l0,10.25-.14.08,0-10.25.14-.08Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M149.59,225.77l0-10.25c0,1.73,1.14,3.46,3.42,4.77l0,10.25C150.72,229.23,149.58,227.5,149.59,225.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M153,220.29l0,10.25c-2.28-1.31-3.42-3-3.41-4.77l0-10.25c0,1.73,1.14,3.46,3.42,4.77Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "349.28 220.29 349.25 230.54 259.6 282.64 259.63 272.39 349.28 220.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "243.26 272.39 243.23 282.64 153 230.54 153.03 220.29 243.26 272.39"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M259.63,272.39l0,10.25c-4.5,2.61-11.84,2.61-16.37,0l0-10.25C247.79,275,255.13,275,259.63,272.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M259.63,272.39l0,10.25a12.58,12.58,0,0,1-2.53,1.11l0-10.25a12.58,12.58,0,0,0,2.53-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M257.1,273.5l0,10.25a16.69,16.69,0,0,1-2.19.55l0-10.25a16.69,16.69,0,0,0,2.19-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M254.91,274.05l0,10.25c-.48.08-1,.15-1.48.2l0-10.25c.5-.05,1-.11,1.48-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M253.43,274.25l0,10.25c-.42,0-.85.07-1.28.09l0-10.25c.43,0,.86,0,1.28-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M252.15,274.34l0,10.25c-.4,0-.8,0-1.19,0l0-10.24c.39,0,.79,0,1.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M251,274.35l0,10.24c-.38,0-.77,0-1.15-.06l0-10.25c.38,0,.76.06,1.15.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M249.81,274.28l0,10.25c-.37,0-.75-.07-1.12-.12l0-10.25c.37,0,.74.09,1.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M248.69,274.16l0,10.25-1.15-.2,0-10.25c.37.08.76.14,1.15.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M247.54,274l0,10.25c-.41-.09-.82-.19-1.21-.3l0-10.25c.39.11.8.21,1.21.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M246.33,273.66l0,10.25c-.48-.14-1-.29-1.4-.47l0-10.25c.45.18.92.33,1.4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M244.93,273.19l0,10.25a12.26,12.26,0,0,1-1.67-.8l0-10.25a12.26,12.26,0,0,0,1.67.8Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M332.13,211.45l0,8.2c0,1.57-1,3.13-3.09,4.33l0-8.2C331.1,214.59,332.13,213,332.13,211.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M332.13,211.45l0,8.2v.09l0-8.2v-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M332.13,211.54l0,8.2a4.07,4.07,0,0,1-.07.61l0-8.19a4.36,4.36,0,0,0,.07-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M332.06,212.16l0,8.19a3,3,0,0,1-.18.6l0-8.19a4.5,4.5,0,0,0,.17-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M331.89,212.76l0,8.19a3.71,3.71,0,0,1-.28.61l0-8.2a4.12,4.12,0,0,0,.29-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M331.6,213.36l0,8.2a4.22,4.22,0,0,1-.43.64l0-8.2a5,5,0,0,0,.42-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M331.18,214l0,8.2a6.18,6.18,0,0,1-.66.71l0-8.2a8.68,8.68,0,0,0,.66-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M330.52,214.71l0,8.2a8.47,8.47,0,0,1-1.34,1l0-8.2a8.57,8.57,0,0,0,1.35-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M329.17,215.7l0,8.2L329,224l0-8.2.13-.08Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M170.73,219.59l0-8.2c0,1.59,1,3.18,3.14,4.4l0,8.19C171.78,222.77,170.73,221.18,170.73,219.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M173.9,215.79l0,8.19c-2.1-1.21-3.15-2.8-3.15-4.39l0-8.2c0,1.59,1,3.18,3.14,4.4Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "329.04 215.78 329.02 223.98 259.2 264.55 259.23 256.35 329.04 215.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "244.17 256.35 244.14 264.55 173.88 223.98 173.9 215.78 244.17 256.35"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M259.22,256.35l0,8.2a16.59,16.59,0,0,1-15.06,0l0-8.2A16.57,16.57,0,0,0,259.22,256.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M259.22,256.35l0,8.2a12,12,0,0,1-2.33,1l0-8.19a11.92,11.92,0,0,0,2.32-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M256.9,257.38l0,8.19a16,16,0,0,1-2,.51l0-8.2a16.11,16.11,0,0,0,2-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M254.88,257.88l0,8.2c-.45.08-.9.14-1.36.19l0-8.2c.46-.05.91-.11,1.36-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M253.52,258.07l0,8.2c-.39,0-.79.06-1.18.07l0-8.19c.39,0,.79,0,1.18-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M252.34,258.15l0,8.19c-.37,0-.73,0-1.1,0l0-8.2c.36,0,.72,0,1.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M251.25,258.15l0,8.2-1.05-.06,0-8.19,1.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M250.19,258.1l0,8.19c-.35,0-.69-.06-1-.11l0-8.2c.34,0,.69.09,1,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M249.16,258l0,8.2c-.35-.05-.7-.11-1-.19l0-8.19c.35.07.7.13,1.06.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M248.1,257.8l0,8.19a10,10,0,0,1-1.11-.27l0-8.2c.36.11.73.2,1.11.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M247,257.52l0,8.2a12.19,12.19,0,0,1-1.29-.43l0-8.2a13,13,0,0,0,1.29.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M245.7,257.09l0,8.2a12.17,12.17,0,0,1-1.54-.74l0-8.2a12,12,0,0,0,1.53.74Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M329,207.06c4.17,2.4,4.19,6.31.05,8.72l-69.82,40.57a16.57,16.57,0,0,1-15.05,0L173.9,215.79c-4.17-2.41-4.19-6.33-.06-8.73l69.82-40.57a16.61,16.61,0,0,1,15.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M295.33,108.84a.85.85,0,0,1,0,1.6,3.07,3.07,0,0,1-2.77,0,.85.85,0,0,1,0-1.6A3,3,0,0,1,295.33,108.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M295.16,111.27a.74.74,0,0,1,0,1.41,2.67,2.67,0,0,1-2.43,0,.74.74,0,0,1,0-1.41A2.67,2.67,0,0,1,295.16,111.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M295,113.7c.59.34.59.88,0,1.22a2.31,2.31,0,0,1-2.11,0c-.58-.34-.59-.89,0-1.22A2.31,2.31,0,0,1,295,113.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M294.84,116.13a.54.54,0,0,1,0,1,1.93,1.93,0,0,1-1.78,0,.54.54,0,0,1,0-1A1.93,1.93,0,0,1,294.84,116.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M294.68,118.56a.44.44,0,0,1,0,.84,1.61,1.61,0,0,1-1.45,0c-.41-.23-.41-.61,0-.84A1.63,1.63,0,0,1,294.68,118.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M294.51,121c.32.18.32.47,0,.65a1.25,1.25,0,0,1-1.13,0,.34.34,0,0,1,0-.65A1.23,1.23,0,0,1,294.51,121Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M294.35,123.42c.22.13.22.34,0,.46a.87.87,0,0,1-.8,0c-.22-.12-.22-.33,0-.46A.87.87,0,0,1,294.35,123.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M250.09,71a.55.55,0,0,1,0,1,1.91,1.91,0,0,1-1.77,0,.55.55,0,0,1,0-1A1.89,1.89,0,0,1,250.09,71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M250,74.81a.48.48,0,0,1,0,.91,1.65,1.65,0,0,1-1.53,0,.48.48,0,0,1,0-.91A1.67,1.67,0,0,1,250,74.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M249.87,78.62a.42.42,0,0,1,0,.78,1.41,1.41,0,0,1-1.31,0,.41.41,0,0,1,0-.78A1.46,1.46,0,0,1,249.87,78.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M249.75,82.44c.31.18.31.46,0,.64a1.17,1.17,0,0,1-1.09,0,.34.34,0,0,1,0-.64A1.15,1.15,0,0,1,249.75,82.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M249.64,86.25a.27.27,0,0,1,0,.51,1,1,0,0,1-.87,0,.27.27,0,0,1,0-.51A.93.93,0,0,1,249.64,86.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M249.53,90.07a.19.19,0,0,1,0,.37.66.66,0,0,1-.64,0,.2.2,0,0,1,0-.37A.66.66,0,0,1,249.53,90.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M249.42,93.88c.11.07.11.18,0,.24a.43.43,0,0,1-.41,0c-.12-.06-.12-.17,0-.24A.43.43,0,0,1,249.42,93.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M297.52,178.33c.59.31.59.81,0,1.12a2.5,2.5,0,0,1-2.09,0c-.58-.31-.59-.81,0-1.12A2.46,2.46,0,0,1,297.52,178.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M297.39,180.57c.51.27.51.71,0,1a2.17,2.17,0,0,1-1.83,0c-.51-.27-.51-.71,0-1A2.17,2.17,0,0,1,297.39,180.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M297.26,182.82c.44.23.44.6,0,.83a1.84,1.84,0,0,1-1.57,0c-.44-.23-.44-.6,0-.83A1.8,1.8,0,0,1,297.26,182.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M297.13,185.06c.37.19.37.5,0,.7a1.58,1.58,0,0,1-1.31,0c-.37-.2-.37-.51,0-.7A1.58,1.58,0,0,1,297.13,185.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M297,187.3c.3.16.3.41,0,.56a1.24,1.24,0,0,1-1.05,0c-.3-.15-.3-.41,0-.56A1.28,1.28,0,0,1,297,187.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M296.88,189.54c.22.12.22.31,0,.42a.91.91,0,0,1-.79,0c-.22-.11-.22-.3,0-.42A1,1,0,0,1,296.88,189.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M296.75,191.78a.15.15,0,0,1,0,.29.62.62,0,0,1-.53,0c-.15-.08-.15-.21,0-.29A.72.72,0,0,1,296.75,191.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M209.6,126a.76.76,0,0,1,0,1.44,2.73,2.73,0,0,1-2.49,0,.76.76,0,0,1,0-1.44A2.73,2.73,0,0,1,209.6,126Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M209.44,129.51a.67.67,0,0,1,0,1.26,2.44,2.44,0,0,1-2.17,0c-.6-.35-.61-.91,0-1.26A2.37,2.37,0,0,1,209.44,129.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M209.28,133c.52.3.52.78,0,1.07a2,2,0,0,1-1.85,0,.56.56,0,0,1,0-1.07A2,2,0,0,1,209.28,133Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M209.12,136.49a.47.47,0,0,1,0,.89,1.74,1.74,0,0,1-1.54,0,.47.47,0,0,1,0-.89A1.65,1.65,0,0,1,209.12,136.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M209,140a.37.37,0,0,1,0,.7,1.32,1.32,0,0,1-1.22,0,.37.37,0,0,1,0-.7A1.32,1.32,0,0,1,209,140Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M208.81,143.47c.25.14.25.37,0,.52a1,1,0,0,1-.9,0c-.25-.15-.25-.38,0-.52A1,1,0,0,1,208.81,143.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M208.65,147c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,208.65,147Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M207.59,171.67c1.32.77,1.32,2,0,2.75a5.21,5.21,0,0,1-4.74,0c-1.32-.76-1.32-2,0-2.75A5.27,5.27,0,0,1,207.59,171.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M207.56,172.17c1.3.75,1.3,2,0,2.7a5.15,5.15,0,0,1-4.68,0c-1.29-.74-1.3-2,0-2.7A5.13,5.13,0,0,1,207.56,172.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M207.53,172.66c1.28.74,1.28,1.93,0,2.67a5.09,5.09,0,0,1-4.61,0c-1.27-.74-1.28-1.94,0-2.67A5.06,5.06,0,0,1,207.53,172.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M207.5,173.15c1.26.73,1.26,1.9,0,2.63a5,5,0,0,1-4.54,0c-1.26-.73-1.27-1.91,0-2.63A5,5,0,0,1,207.5,173.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M207.46,173.64c1.25.72,1.25,1.88,0,2.59a4.92,4.92,0,0,1-4.48,0c-1.24-.71-1.25-1.88,0-2.59A4.92,4.92,0,0,1,207.46,173.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M207.43,174.13c1.23.71,1.23,1.85,0,2.55a4.83,4.83,0,0,1-4.41,0,1.35,1.35,0,0,1,0-2.55A4.83,4.83,0,0,1,207.43,174.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-201"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M207.4,174.62a1.33,1.33,0,0,1,0,2.52,4.81,4.81,0,0,1-4.34,0,1.33,1.33,0,0,1,0-2.52A4.77,4.77,0,0,1,207.4,174.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-203"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M207.36,175.11a1.31,1.31,0,0,1,0,2.48,4.71,4.71,0,0,1-4.28,0,1.31,1.31,0,0,1,0-2.48A4.74,4.74,0,0,1,207.36,175.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M207.33,175.6a1.29,1.29,0,0,1,0,2.44,4.63,4.63,0,0,1-4.21,0,1.29,1.29,0,0,1,0-2.44A4.66,4.66,0,0,1,207.33,175.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M207.3,176.09a1.27,1.27,0,0,1,0,2.4,4.54,4.54,0,0,1-4.15,0,1.27,1.27,0,0,1,0-2.4A4.6,4.6,0,0,1,207.3,176.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-209"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M207.26,176.58a1.25,1.25,0,0,1,0,2.37,4.51,4.51,0,0,1-4.08,0c-1.13-.66-1.14-1.72,0-2.37A4.51,4.51,0,0,1,207.26,176.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-211"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M207.23,177.07c1.12.65,1.12,1.69,0,2.33a4.45,4.45,0,0,1-4,0,1.23,1.23,0,0,1,0-2.33A4.43,4.43,0,0,1,207.23,177.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-213"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M207.2,177.56c1.1.64,1.1,1.66,0,2.29a4.36,4.36,0,0,1-4,0,1.21,1.21,0,0,1,0-2.29A4.36,4.36,0,0,1,207.2,177.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-215"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M207.17,178.05c1.07.63,1.08,1.63,0,2.25a4.25,4.25,0,0,1-3.88,0,1.19,1.19,0,0,1,0-2.25A4.3,4.3,0,0,1,207.17,178.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-217"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M207.13,178.55a1.17,1.17,0,0,1,0,2.21,4.22,4.22,0,0,1-3.82,0,1.17,1.17,0,0,1,0-2.21A4.19,4.19,0,0,1,207.13,178.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-219"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M207.1,179a1.15,1.15,0,0,1,0,2.17,4.13,4.13,0,0,1-3.75,0,1.15,1.15,0,0,1,0-2.17A4.13,4.13,0,0,1,207.1,179Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M207.07,179.53a1.13,1.13,0,0,1,0,2.13,4.07,4.07,0,0,1-3.69,0,1.13,1.13,0,0,1,0-2.13A4.07,4.07,0,0,1,207.07,179.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M207,180c1,.58,1,1.52,0,2.09a4,4,0,0,1-3.62,0,1.1,1.1,0,0,1,0-2.09A4,4,0,0,1,207,180Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-223"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M207,180.51a1.09,1.09,0,0,1,0,2.06,3.93,3.93,0,0,1-3.55,0,1.09,1.09,0,0,1,0-2.06A3.9,3.9,0,0,1,207,180.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M207,181a1.07,1.07,0,0,1,0,2,3.84,3.84,0,0,1-3.49,0,1.07,1.07,0,0,1,0-2A3.84,3.84,0,0,1,207,181Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-227"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M206.94,181.49a1,1,0,0,1,0,2,3.75,3.75,0,0,1-3.42,0c-.95-.55-1-1.43,0-2A3.75,3.75,0,0,1,206.94,181.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-229"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M206.9,182c.93.54.94,1.41,0,1.94a3.67,3.67,0,0,1-3.35,0,1,1,0,0,1,0-1.94A3.67,3.67,0,0,1,206.9,182Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-231"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M206.87,182.47a1,1,0,0,1,0,1.91,3.66,3.66,0,0,1-3.29,0,1,1,0,0,1,0-1.91A3.66,3.66,0,0,1,206.87,182.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-233"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M206.84,183a1,1,0,0,1,0,1.87,3.55,3.55,0,0,1-3.22,0,1,1,0,0,1,0-1.87A3.6,3.6,0,0,1,206.84,183Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M206.8,183.45c.88.51.88,1.33,0,1.83a3.43,3.43,0,0,1-3.15,0,1,1,0,0,1,0-1.83A3.49,3.49,0,0,1,206.8,183.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M206.77,183.94c.86.5.86,1.3,0,1.79a3.37,3.37,0,0,1-3.09,0,1,1,0,0,1,0-1.79A3.43,3.43,0,0,1,206.77,183.94Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-239"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M206.74,184.43a.93.93,0,0,1,0,1.76,3.37,3.37,0,0,1-3,0,.93.93,0,0,1,0-1.76A3.37,3.37,0,0,1,206.74,184.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-241"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M206.71,184.93a.9.9,0,0,1,0,1.71,3.28,3.28,0,0,1-3,0,.9.9,0,0,1,0-1.71A3.22,3.22,0,0,1,206.71,184.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-243"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M206.67,185.42a.88.88,0,0,1,0,1.67,3.17,3.17,0,0,1-2.89,0c-.8-.46-.81-1.21,0-1.67A3.14,3.14,0,0,1,206.67,185.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-245"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M206.64,185.91c.78.45.79,1.18,0,1.63a3.07,3.07,0,0,1-2.83,0,.86.86,0,0,1,0-1.63A3.14,3.14,0,0,1,206.64,185.91Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-247"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M206.61,186.4a.85.85,0,0,1,0,1.6,3.05,3.05,0,0,1-2.76,0,.84.84,0,0,1,0-1.6A3.05,3.05,0,0,1,206.61,186.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-249"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M206.57,186.89a.82.82,0,0,1,0,1.56,3,3,0,0,1-2.69,0,.82.82,0,0,1,0-1.56A3,3,0,0,1,206.57,186.89Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-251"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M206.54,187.38a.8.8,0,0,1,0,1.52,2.9,2.9,0,0,1-2.63,0,.8.8,0,0,1,0-1.52A2.9,2.9,0,0,1,206.54,187.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-253"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M206.51,187.87a.78.78,0,0,1,0,1.48,2.81,2.81,0,0,1-2.57,0,.78.78,0,0,1,0-1.48A2.82,2.82,0,0,1,206.51,187.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M206.48,188.36a.77.77,0,0,1,0,1.45,2.73,2.73,0,0,1-2.49,0,.77.77,0,0,1,0-1.45A2.75,2.75,0,0,1,206.48,188.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-255"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M206.44,188.85a.74.74,0,0,1,0,1.41,2.67,2.67,0,0,1-2.43,0,.75.75,0,0,1,0-1.41A2.67,2.67,0,0,1,206.44,188.85Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-257"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M206.41,189.34a.72.72,0,0,1,0,1.37,2.61,2.61,0,0,1-2.37,0,.73.73,0,0,1,0-1.37A2.59,2.59,0,0,1,206.41,189.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-259"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M206.38,189.83c.63.37.64,1,0,1.33a2.5,2.5,0,0,1-2.29,0,.7.7,0,0,1,0-1.33A2.58,2.58,0,0,1,206.38,189.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-261"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M206.34,190.32a.69.69,0,0,1,0,1.3,2.5,2.5,0,0,1-2.23,0,.69.69,0,0,1,0-1.3A2.5,2.5,0,0,1,206.34,190.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-263"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M206.31,190.81a.67.67,0,0,1,0,1.26,2.37,2.37,0,0,1-2.17,0,.67.67,0,0,1,0-1.26A2.44,2.44,0,0,1,206.31,190.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-265"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M206.28,191.31a.64.64,0,0,1,0,1.21,2.29,2.29,0,0,1-2.1,0,.64.64,0,0,1,0-1.21A2.29,2.29,0,0,1,206.28,191.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M206.24,191.8a.62.62,0,0,1,0,1.17,2.21,2.21,0,0,1-2,0,.62.62,0,0,1,0-1.17A2.21,2.21,0,0,1,206.24,191.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-269"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M206.21,192.29a.6.6,0,0,1,0,1.14,2.2,2.2,0,0,1-2,0c-.54-.32-.55-.83,0-1.14A2.14,2.14,0,0,1,206.21,192.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-271"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M206.18,192.78a.58.58,0,0,1,0,1.1,2.14,2.14,0,0,1-1.91,0,.58.58,0,0,1,0-1.1A2.06,2.06,0,0,1,206.18,192.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-273"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M206.15,193.27a.56.56,0,0,1,0,1.06,2,2,0,0,1-1.83,0,.56.56,0,0,1,0-1.06A2.05,2.05,0,0,1,206.15,193.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-275"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M206.11,193.76c.49.28.5.74,0,1a1.91,1.91,0,0,1-1.77,0,.54.54,0,0,1,0-1A2,2,0,0,1,206.11,193.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-277"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M206.08,194.25a.53.53,0,0,1,0,1,1.91,1.91,0,0,1-1.71,0c-.47-.28-.47-.72,0-1A1.89,1.89,0,0,1,206.08,194.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-279"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M206.05,194.74a.5.5,0,0,1,0,.95,1.8,1.8,0,0,1-1.63,0,.5.5,0,0,1,0-.95A1.82,1.82,0,0,1,206.05,194.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-281"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M206,195.23a.48.48,0,0,1,0,.91,1.74,1.74,0,0,1-1.57,0,.48.48,0,0,1,0-.91A1.74,1.74,0,0,1,206,195.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-283"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M206,195.72a.46.46,0,0,1,0,.87,1.64,1.64,0,0,1-1.51,0,.46.46,0,0,1,0-.87A1.65,1.65,0,0,1,206,195.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-285"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M206,196.21a.44.44,0,0,1,0,.84,1.59,1.59,0,0,1-1.44,0,.45.45,0,0,1,0-.84A1.59,1.59,0,0,1,206,196.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M205.92,196.7a.42.42,0,0,1,0,.8,1.5,1.5,0,0,1-1.37,0c-.38-.22-.39-.58,0-.8A1.53,1.53,0,0,1,205.92,196.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M264,150.86c1,.57,1,1.48,0,2a3.88,3.88,0,0,1-3.54,0,1.08,1.08,0,0,1,0-2A3.86,3.86,0,0,1,264,150.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M263.75,154.86a.94.94,0,0,1,0,1.78,3.35,3.35,0,0,1-3.08,0,.94.94,0,0,1,0-1.78A3.41,3.41,0,0,1,263.75,154.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M263.52,158.86c.74.42.74,1.1,0,1.52a2.9,2.9,0,0,1-2.63,0,.8.8,0,0,1,0-1.52A2.88,2.88,0,0,1,263.52,158.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M263.3,162.86c.61.35.61.91,0,1.26a2.39,2.39,0,0,1-2.18,0c-.6-.35-.61-.91,0-1.26A2.39,2.39,0,0,1,263.3,162.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M263.08,166.86a.53.53,0,0,1,0,1,1.89,1.89,0,0,1-1.73,0c-.47-.28-.48-.72,0-1A1.89,1.89,0,0,1,263.08,166.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M262.85,170.86a.39.39,0,0,1,0,.74,1.44,1.44,0,0,1-1.28,0c-.35-.21-.36-.54,0-.74A1.38,1.38,0,0,1,262.85,170.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M262.63,174.86a.25.25,0,0,1,0,.48.93.93,0,0,1-.83,0,.25.25,0,0,1,0-.48A.93.93,0,0,1,262.63,174.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M294.25,34.89c.58.31.58.81,0,1.12a2.54,2.54,0,0,1-2.09,0c-.58-.31-.58-.81,0-1.12A2.49,2.49,0,0,1,294.25,34.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M294.12,41.2c.51.27.51.71,0,1a2.17,2.17,0,0,1-1.83,0c-.51-.27-.51-.71,0-1A2.19,2.19,0,0,1,294.12,41.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M294,47.51c.43.23.43.61,0,.84a1.87,1.87,0,0,1-1.57,0c-.44-.23-.44-.61,0-.84A1.9,1.9,0,0,1,294,47.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M293.86,53.82c.36.2.36.51,0,.7a1.58,1.58,0,0,1-1.31,0c-.36-.19-.37-.51,0-.7A1.6,1.6,0,0,1,293.86,53.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M293.73,60.13c.29.16.29.41,0,.56a1.21,1.21,0,0,1-1.05,0c-.29-.15-.29-.4,0-.56A1.28,1.28,0,0,1,293.73,60.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M293.6,66.44c.22.12.22.31,0,.42a.91.91,0,0,1-.79,0c-.22-.11-.22-.3,0-.42A1,1,0,0,1,293.6,66.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M293.47,72.75c.15.08.15.21,0,.29a.7.7,0,0,1-.53,0c-.15-.08-.15-.21,0-.29A.69.69,0,0,1,293.47,72.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M211.3,66.16c.58.31.59.81,0,1.12a2.5,2.5,0,0,1-2.09,0c-.58-.31-.59-.81,0-1.12A2.46,2.46,0,0,1,211.3,66.16Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M211.17,70.12c.51.27.51.71,0,1a2.17,2.17,0,0,1-1.83,0c-.51-.27-.51-.71,0-1A2.17,2.17,0,0,1,211.17,70.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M211,74.09c.44.23.44.6,0,.83a1.8,1.8,0,0,1-1.57,0c-.44-.23-.44-.6,0-.83A1.87,1.87,0,0,1,211,74.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M210.91,78.05c.37.19.37.51,0,.7a1.58,1.58,0,0,1-1.31,0c-.37-.19-.37-.51,0-.7A1.58,1.58,0,0,1,210.91,78.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M210.78,82c.3.16.3.41,0,.56a1.21,1.21,0,0,1-1,0c-.3-.15-.3-.4,0-.56A1.28,1.28,0,0,1,210.78,82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M210.65,86c.22.11.22.3,0,.42a1,1,0,0,1-.8,0c-.21-.12-.22-.31,0-.42A.91.91,0,0,1,210.65,86Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M210.52,89.94c.15.08.15.2,0,.28a.64.64,0,0,1-.54,0c-.14-.08-.14-.2,0-.28A.62.62,0,0,1,210.52,89.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M304.62,206.26c2.85,1.65,2.86,4.31,0,6l-48.52,28.2a11.37,11.37,0,0,1-10.3,0L197,212.23c-2.85-1.65-2.86-4.32,0-6l48.52-28.2a11.33,11.33,0,0,1,10.3,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M308.71,182.78c3.06,1.77,3.08,4.64,0,6.41l-52.21,30.34a12.17,12.17,0,0,1-11.07,0l-52.57-30.35c-3.06-1.77-3.08-4.64,0-6.41l52.21-30.35a12.22,12.22,0,0,1,11.08,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M312.8,159.29c3.28,1.9,3.3,5,0,6.87l-55.9,32.49a13.05,13.05,0,0,1-11.86,0L188.8,166.16c-3.29-1.89-3.3-5,0-6.87l55.89-32.48a13.08,13.08,0,0,1,11.86,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M316.88,135.81c3.5,2,3.52,5.29,0,7.32l-59.59,34.63a13.94,13.94,0,0,1-12.64,0l-60-34.63c-3.5-2-3.52-5.3,0-7.32l59.58-34.63a13.94,13.94,0,0,1,12.64,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M321,112.32c3.72,2.15,3.74,5.63,0,7.78l-63.27,36.77a14.79,14.79,0,0,1-13.43,0L180.62,120.1c-3.72-2.15-3.74-5.63,0-7.78l63.26-36.76a14.76,14.76,0,0,1,13.43,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M325.06,88.84c3.93,2.27,3.95,6,0,8.23l-67,38.91a15.68,15.68,0,0,1-14.21,0l-67.4-38.91c-3.93-2.27-3.95-6,0-8.23l66.95-38.91a15.65,15.65,0,0,1,14.21,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M329.15,65.35c4.15,2.4,4.17,6.28,0,8.69l-70.64,41.05a16.5,16.5,0,0,1-15,0L172.44,74c-4.15-2.4-4.17-6.28,0-8.69l70.65-41a16.48,16.48,0,0,1,15,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M304.62,206.26c2.85,1.65,2.86,4.31,0,6l-48.52,28.2a11.37,11.37,0,0,1-10.3,0L197,212.23c-2.85-1.65-2.86-4.32,0-6l48.52-28.2a11.33,11.33,0,0,1,10.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M196.09,211.6A5.92,5.92,0,0,1,197,211l48.52-28.2a11.33,11.33,0,0,1,10.3,0L304.62,211a6.85,6.85,0,0,1,.88.63c1.93-1.65,1.64-3.9-.88-5.36l-48.85-28.2a11.33,11.33,0,0,0-10.3,0L197,206.26C194.44,207.72,194.17,210,196.09,211.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M183.26,202.54s1.45,12.36,1.45,15-.18,4.44-.18,4.44l3.94-.92s-2.42-18.51-2.6-18.48S183.26,202.54,183.26,202.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.69,246.41s-4.28,6.19-3.42,7.83c.94,1.81,3.21-.19,4-1.24.62-.83.41-2.19,2-2.53,1.43-.3,1.45-2.87,1.45-2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M172,249.32s-3.8,6.42-2.65,7.87c1.26,1.6,2.83.23,3.85-1,.65-.81,1.11-2.32,1.94-2.93,1.19-.85.9-3.09.9-3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M186.68,219.48c-6.65,2.22-15.15,3.91-16.87,6.9s-6.44,20.31-6.44,20.31,2.6,1.67,4.44,1.49c2.8-4.17,5.56-16.66,8.57-18.81s16.39-5.39,18.11-8.84A74.2,74.2,0,0,1,186.68,219.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M193.53,219.9s-13.91,5.8-15.64,9.68-6.45,20-6.45,20,3.27,1.76,5,1c1.24-2.62,4.47-15.12,7.06-18.14s14.12-2.23,16.69-5.44c2.43-3,.2-8.08.2-8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M195.89,192.68a28,28,0,0,0-.15,6.61,20.05,20.05,0,0,0-3.48,3.25l-4.78-1.89a18.21,18.21,0,0,0,1.84-5.58A43,43,0,0,0,195.89,192.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35,195.44s-2.75.37-3.93,4.58c-1.13,4-.85,4.08,0,4.32s2.48.74,2.48.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M190.08,200.75c-1.29-.43-1.23-4.26-.45-5.4-3.31-.12-3.06.17-3.63,1.1-.81,1.33-1.59,7.37-1.17,11.81s1.09,9.56,1.09,11.52,12.71,2.09,14.16,1.05.12-8,.56-12.77c.22-2.42,1.76-7.41-.18-9a13.16,13.16,0,0,0-4.86-2.25S192.27,201.47,190.08,200.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "192.84 224.86 192.84 224.31 185.26 228.68 185.26 229.24 192.84 224.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-290",
    points: "192.84 224.31 180.89 217.4 173.3 221.78 185.26 228.68 192.84 224.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M190.36,184.36a4.65,4.65,0,0,0-2.69,5.49,3.64,3.64,0,0,1-.21,3c-.45.84.71.36.86.83s.52,3.06,1.36,3c2.22-.25,5.43-1.94,6.58-4,1.28-2.25.15-6.27-1-7.43A4.24,4.24,0,0,0,190.36,184.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M197.23,202.75l-.1,10.28s-11,6.88-12.44,6.6c-.84-.16-1.27-.66-1.52-.39s.77.73.4.73-2.14.27-2.16.56,1.33,0,1.55.16,0,.17,0,.36a.25.25,0,0,0,.13.26c.14.08,0,.18.05.37s.15.19.17.25-.13.38.14.44a2.78,2.78,0,0,0,2.83-1.05c.8-.88,4.71-.88,8.93-2.68,4-1.73,6.09-1.53,6.29-5.54.19-3.67.47-11,.47-11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-291",
    points: "185.26 229.24 184.21 219.83 171.85 212.7 172.92 222.11 185.26 229.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "185.26 229.24 185.45 229.13 184.41 219.71 184.21 219.83 185.26 229.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "184.21 219.83 171.85 212.7 172.04 212.59 184.41 219.71 184.21 219.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M192.53,187.14c-1.41,1.45-5.67,3.07-6.29.12-.52-2.44,2-2.6,4.1-3.83,2.73-1.64,6,.2,6,1.6a2.81,2.81,0,0,1,2.12,2.21c.48,1.75.27,5.13-2.76,6.41a6.12,6.12,0,0,1-.59-1.83s1.48-.64,1.33-1.77-1.26-1.5-1.82-.68C193,188.89,193,188,192.53,187.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M199.92,198.8c-3.48,0-4.85,9.34-3,9.79s5.37.37,5.9-.72S203.5,198.81,199.92,198.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "307.53 208.11 305.75 208.06 305.66 207.38 298.37 211.59 299.24 211.78 299.76 212.6 307.53 208.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M300,211.61h0a.24.24,0,0,0,.24-.26v-.09c-.13-2.26.33-3.72,1.29-4.11a.8.8,0,0,1,.71,0,3.54,3.54,0,0,1,1.14,2.09.25.25,0,0,0,.5-.1c0-.07-.4-1.9-1.4-2.43a1.27,1.27,0,0,0-1.14,0c-1.19.49-1.75,2.08-1.61,4.61v.08A.26.26,0,0,0,300,211.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M301.77,212.17h0a.24.24,0,0,0,.24-.26v-.09c-.13-2.26.33-3.72,1.29-4.11a.77.77,0,0,1,.71,0c.66.35,1.05,1.62,1.15,2.09a.25.25,0,0,0,.3.19.25.25,0,0,0,.19-.3c0-.07-.39-1.89-1.4-2.43a1.3,1.3,0,0,0-1.14,0c-1.19.49-1.75,2.08-1.61,4.61v.08A.25.25,0,0,0,301.77,212.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "310.62 217.86 300.25 223.85 299.76 212.6 307.53 208.11 310.62 217.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "300.25 223.85 298.74 222.4 299.3 211.79 299.76 212.6 300.25 223.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "298.74 222.4 296.65 222.21 298.37 211.59 299.3 211.79 298.74 222.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M318.14,255.22c-1.45.47-3.42-5.77-4.71-4.88-1.51,1,5.25,10,7.4,8.31,1.94-1.5-4.2-9.65-5.95-8.81S318.14,255.22,318.14,255.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M301.94,257.18s-1.13,1.56-.56,2.79,1.39,1.27,2.48,2.55c1.77,2.09,3.75,3.71,5.1,2.72s-1.35-4.94-3.28-7.51C303.32,254.6,301.94,257.18,301.94,257.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M294.06,223.47s14.64,7.5,14.63,9.14-3.77,22-3.05,24.38c.9,3,3.83,6.7,2.54,7.44s-2.47-.95-4.25-2.52c-1.35-1.18-2.81-1.45-2.08-4.35.46-1.84.79-3.07.28-7.37-1.1-9.37-.5-12.16-.25-14.56C295.2,234.12,288,223.47,288,223.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M300.81,237.32a11,11,0,0,1,.9,1.2c2.75,4.16,6.91,7.18,9.45,10.21s1.76,2.55,3.35,4.6c.94,1.2,3.39,3.84,4.62,2.63.92-.9-2-4.56-5.12-9.15s-4.25-7.76-5.69-10.45a15.72,15.72,0,0,0-2.8-3.76C304.09,231.17,299.19,235.45,300.81,237.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M286.49,186.46a3.63,3.63,0,0,0-1.64-2.42c-1.51-1-4.45-1.57-7,1.33s-1.87,8.77-2,12.08a13,13,0,0,1-4,9s5.86,1.61,8.85-2.59c2.66-3.72,1-9.16,1.17-11.92s1.28-4.19,2-3.89S286.49,186.46,286.49,186.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M282.27,195.49a17.15,17.15,0,0,1,.71,7.1c2.16,1.18,4.71,3.92,6.06,3.79,1.52-.14,1.7-3.1,1.7-3.25s-1.83-4.19-2-6S282.27,195.49,282.27,195.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M296.16,207.54c.24,4.46-1,9.77-.71,13s.42,5.29.42,5.29l-3.63-1.23.61-10.54,2.22-6.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M290.52,199.36s1.5-.33,3.2,1.75c1.27,1.56,3.17,6.17,2.68,7a4.07,4.07,0,0,1-2.79.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M281.52,224.69a9.77,9.77,0,0,0-.82,6.81c1.14,4.92,11,6.58,15.76,6.26,4,.57,4.85,3.4,4.85,3.4s1.82.51,3.69-3.95c.91-2.17,3.31-.19,3.91-4-1-5.17-14.58-9.72-14.59-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M278.88,205.11c.1-1.34,1.86-2.56,4.15-2.92,1.52.6,5.92,3.25,5.92,3.25s1.12-4.08,0-6.29c1.12,0,2.71.14,3.13,1.25a29.83,29.83,0,0,0,1.55,3.22c.6,1.16,2.15,2.32,2.15,4.46s-.48,2.49-.85,5.5a57.08,57.08,0,0,0,0,10.33c.25,1.53-11.73,1-13.41.78.29-4.41,1.66-6,0-11.53C280.17,208.68,279.2,209.27,278.88,205.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M287.42,187.56c3.41.75,5.16,3,4.43,4.89-1.28,3.29.34,4.43-.41,4.72s-.53.07-.84,1c-.45,1.4-1,3.33-3.27,2.12-2.62-1.39-5.32-3.12-5.81-6.22S283.76,186.75,287.42,187.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M282.76,189.87c-.13.07-2.22-.62-.42-2.08,2.07-1.68,5.46-2.06,5.09.08C287.21,189.12,282.76,189.87,282.76,189.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "285.55 229.67 285.55 229.07 293.71 233.78 293.71 234.38 285.55 229.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-290",
    points: "285.55 229.07 298.42 221.63 306.58 226.34 293.71 233.78 285.55 229.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M281.84,211.39l.1,9.12s9.76,6.1,11,5.85c.74-.15,1.13-.58,1.34-.35s-.68.65-.35.65,1.9.24,1.92.5-1.19,0-1.38.14,0,.15,0,.32,0,.19-.12.23,0,.16,0,.33-.14.17-.16.22.12.34-.12.39a2.49,2.49,0,0,1-2.51-.93c-.71-.79-4.18-.78-7.92-2.38-3.57-1.53-5.4-1.36-5.58-4.91-.16-3.25-.41-9.77-.41-9.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-291",
    points: "293.71 234.38 294.85 224.25 308.15 216.57 306.99 226.7 293.71 234.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "293.71 234.38 293.5 234.26 294.62 224.12 294.85 224.25 293.71 234.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "294.85 224.25 308.15 216.57 307.94 216.45 294.62 224.12 294.85 224.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,192.92c-.7,1.27-4.47.25-5.37-.79-.65,1.91-2.05,2-2.05,2s-.36-1.69-1.36-.83c-.77.67,0,1.59.4,2.14-.07.59-.19,1.15-.92,1.37-1.82-.61-3.19-4.52-.63-7.36a6.18,6.18,0,0,1,7.9-1.15C292.16,189.47,292.5,192,292,192.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M280.66,203.31c-3.57-.39-4.19,7.69-3.31,8.31s5.32,1.34,5.68.3S284.36,203.72,280.66,203.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M301.94,257.18a4.24,4.24,0,0,0,.58,1.86c.79,1.26,2.18,3.42,3.61,4,1.87.7,2.17-.15,1.48-2.16-.18-.56,1.19,2.49,1.19,2.49v1.56a2.94,2.94,0,0,1-2.37-.28c-1.09-.71-2.81-3-3.82-3.46C301.29,260.57,300.31,259.26,301.94,257.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M290,188.28a6.53,6.53,0,0,0-5.93-.36,7.6,7.6,0,0,0-1,5.61,1,1,0,0,1,.21-.25c1-.86,1.36.83,1.36.83s1.4-.07,2.05-2c.9,1,4.67,2.06,5.37.79C292.5,192,292.16,189.47,290,188.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M216.87,230.44a3.05,3.05,0,0,1-1.52-.4,3.73,3.73,0,0,1-1.65-3.44,9.88,9.88,0,0,1,4.54-7.86,3.38,3.38,0,0,1,5.45,3.15,9.91,9.91,0,0,1-4.54,7.86A4.56,4.56,0,0,1,216.87,230.44Zm3.65-10.56a2.83,2.83,0,0,0-1.37.44,8.13,8.13,0,0,0-3.63,6.28,1.62,1.62,0,0,0,2.72,1.58,8.17,8.17,0,0,0,3.63-6.29,2.07,2.07,0,0,0-.74-1.86A1.23,1.23,0,0,0,220.52,219.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M218.74,219.32l0,12.37a3.06,3.06,0,0,1-1.79,2.52,9.65,9.65,0,0,1-8.77,0,3.1,3.1,0,0,1-1.84-2.56l0-12.37a3.1,3.1,0,0,0,1.83,2.56,9.65,9.65,0,0,0,8.77,0A3.06,3.06,0,0,0,218.74,219.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-293"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M218.74,219.32l0,12.37v.16l0-12.37a.86.86,0,0,0,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M218.73,219.48l0,12.37a2.52,2.52,0,0,1-.44,1.18l0-12.38a2.35,2.35,0,0,0,.44-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M218.29,220.65l0,12.38a4.19,4.19,0,0,1-1.35,1.18c-.14.09-.29.16-.44.24l0-12.38.44-.23a4.09,4.09,0,0,0,1.35-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M216.5,222.07l0,12.38a7.67,7.67,0,0,1-1.37.49l0-12.37a7.32,7.32,0,0,0,1.36-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M215.14,222.57l0,12.37a10.31,10.31,0,0,1-3,.32l0-12.37a10.38,10.38,0,0,0,3-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M212.13,222.89l0,12.37a10.14,10.14,0,0,1-2-.28l0-12.37a11.18,11.18,0,0,0,2,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M210.12,222.61l0,12.37a7.49,7.49,0,0,1-2-.77,3.1,3.1,0,0,1-1.84-2.56l0-12.37a3.1,3.1,0,0,0,1.83,2.56,8,8,0,0,0,2,.77Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M216.91,216.76c2.43,1.4,2.44,3.68,0,5.08a9.65,9.65,0,0,1-8.77,0c-2.42-1.4-2.45-3.67,0-5.08A9.68,9.68,0,0,1,216.91,216.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M217.1,220.84a2.84,2.84,0,0,1-.79.64,8.39,8.39,0,0,1-7.5,0,4,4,0,0,1-.85-.67c-1.15-1.18-.91-2.67.82-3.67a8.32,8.32,0,0,1,7.5,0C218,218.14,218.28,219.66,217.1,220.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M217.1,220.84a2.84,2.84,0,0,1-.79.64,8.39,8.39,0,0,1-7.5,0,4,4,0,0,1-.85-.67,3,3,0,0,1,.82-.64,8.39,8.39,0,0,1,7.5,0A3.17,3.17,0,0,1,217.1,220.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M212,220.94a.37.37,0,0,1-.25.45.36.36,0,0,1-.46-.25.37.37,0,0,1,.25-.46A.38.38,0,0,1,212,220.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M211.8,220.59a.41.41,0,0,1-.28.51.41.41,0,1,1-.23-.79A.4.4,0,0,1,211.8,220.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M211.67,220.23a.46.46,0,0,1-.31.57.44.44,0,0,1-.57-.31.46.46,0,0,1,.31-.57A.46.46,0,0,1,211.67,220.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M211.57,219.88a.5.5,0,0,1-1,.28.51.51,0,0,1,.34-.63A.52.52,0,0,1,211.57,219.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M211.5,219.51a.55.55,0,0,1-.37.68.55.55,0,0,1-.31-1.05A.55.55,0,0,1,211.5,219.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M211.46,219.14a.59.59,0,1,1-.74-.4A.6.6,0,0,1,211.46,219.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M211.45,218.77a.65.65,0,0,1-.44.79.62.62,0,0,1-.78-.43.64.64,0,0,1,.43-.79A.64.64,0,0,1,211.45,218.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M211.46,218.4a.68.68,0,0,1-.46.85.68.68,0,0,1-.84-.46.68.68,0,0,1,.46-.85A.68.68,0,0,1,211.46,218.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M211.5,218a.71.71,0,0,1-.49.9.74.74,0,0,1-.9-.49.72.72,0,0,1,1.39-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M211.57,217.66a.77.77,0,1,1-1-.52A.77.77,0,0,1,211.57,217.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M211.66,217.29a.81.81,0,1,1-1-.55A.81.81,0,0,1,211.66,217.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M211.77,216.92a.86.86,0,0,1-.58,1.06.87.87,0,0,1-1.07-.58.86.86,0,0,1,1.65-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M211.9,216.55a.9.9,0,1,1-1.12-.61A.91.91,0,0,1,211.9,216.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M212.05,216.19a.94.94,0,0,1-.64,1.17.94.94,0,1,1-.53-1.81A.94.94,0,0,1,212.05,216.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M212.22,215.83a1,1,0,0,1-1.9.56,1,1,0,1,1,1.9-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M212.4,215.48a1,1,0,1,1-1.28-.7A1,1,0,0,1,212.4,215.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M212.6,215.13a1.08,1.08,0,1,1-1.34-.73A1.08,1.08,0,0,1,212.6,215.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M212.81,214.79a1.12,1.12,0,0,1-2.15.63,1.12,1.12,0,0,1,2.15-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M213,214.46a1.17,1.17,0,1,1-1.45-.79A1.17,1.17,0,0,1,213,214.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M213.28,214.14a1.21,1.21,0,1,1-1.51-.82A1.21,1.21,0,0,1,213.28,214.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M213.52,213.83a1.25,1.25,0,0,1-.85,1.56A1.25,1.25,0,1,1,212,213,1.24,1.24,0,0,1,213.52,213.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M213.78,213.53a1.3,1.3,0,1,1-1.61-.88A1.3,1.3,0,0,1,213.78,213.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M214,213.24a1.34,1.34,0,1,1-1.67-.91A1.35,1.35,0,0,1,214,213.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M214.31,213a1.4,1.4,0,0,1-.94,1.72,1.39,1.39,0,1,1,.94-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M214.58,212.71a1.43,1.43,0,1,1-1.78-1A1.42,1.42,0,0,1,214.58,212.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M214.83,212.49a1.47,1.47,0,1,1-1.83-1A1.48,1.48,0,0,1,214.83,212.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M215.05,212.32a1.52,1.52,0,0,1-2.92.86,1.52,1.52,0,1,1,2.92-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M215.27,212.16a1.56,1.56,0,1,1-1.94-1.06A1.55,1.55,0,0,1,215.27,212.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M215.51,212a1.6,1.6,0,1,1-2-1.09A1.6,1.6,0,0,1,215.51,212Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M215.76,211.84a1.65,1.65,0,1,1-2-1.12A1.65,1.65,0,0,1,215.76,211.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M216,211.69a1.7,1.7,0,1,1-2.11-1.15A1.69,1.69,0,0,1,216,211.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M216.29,211.53a1.74,1.74,0,1,1-2.16-1.18A1.74,1.74,0,0,1,216.29,211.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M216.57,211.38a1.79,1.79,0,1,1-2.22-1.21A1.8,1.8,0,0,1,216.57,211.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M216.85,211.23a1.83,1.83,0,1,1-2.27-1.24A1.83,1.83,0,0,1,216.85,211.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M217.14,211.08a1.87,1.87,0,1,1-2.32-1.27A1.87,1.87,0,0,1,217.14,211.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M217.44,210.92a1.92,1.92,0,1,1-2.38-1.3A1.92,1.92,0,0,1,217.44,210.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M217.74,210.77a2,2,0,1,1-2.44-1.33A2,2,0,0,1,217.74,210.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M218.05,210.61a2,2,0,1,1-2.49-1.36A2,2,0,0,1,218.05,210.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M218.36,210.45a2.05,2.05,0,1,1-2.55-1.39A2.06,2.06,0,0,1,218.36,210.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M218.67,210.28a2.09,2.09,0,1,1-2.6-1.42A2.1,2.1,0,0,1,218.67,210.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M219,210.11a2.14,2.14,0,1,1-2.65-1.45A2.14,2.14,0,0,1,219,210.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M219.3,209.94a2.18,2.18,0,1,1-2.71-1.48A2.19,2.19,0,0,1,219.3,209.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M219.61,209.76a2.22,2.22,0,1,1-2.76-1.51A2.22,2.22,0,0,1,219.61,209.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M219.93,209.57a2.27,2.27,0,1,1-2.82-1.54A2.27,2.27,0,0,1,219.93,209.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M220.24,209.38a2.31,2.31,0,1,1-2.88-1.57A2.31,2.31,0,0,1,220.24,209.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M220.55,209.18a2.36,2.36,0,1,1-2.93-1.6A2.35,2.35,0,0,1,220.55,209.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M220.86,209a2.41,2.41,0,1,1-3-1.63A2.41,2.41,0,0,1,220.86,209Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M221.16,208.75a2.45,2.45,0,1,1-3-1.66A2.45,2.45,0,0,1,221.16,208.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M221.46,208.52a2.49,2.49,0,1,1-3.09-1.69A2.49,2.49,0,0,1,221.46,208.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M221.75,208.28a2.53,2.53,0,1,1-3.15-1.72A2.53,2.53,0,0,1,221.75,208.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M222,208a2.58,2.58,0,1,1-3.2-1.75A2.58,2.58,0,0,1,222,208Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M222.32,207.77a2.63,2.63,0,1,1-3.26-1.78A2.63,2.63,0,0,1,222.32,207.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M222.59,207.49a2.67,2.67,0,1,1-3.31-1.8A2.67,2.67,0,0,1,222.59,207.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M222.85,207.21a2.71,2.71,0,1,1-3.36-1.84A2.7,2.7,0,0,1,222.85,207.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M223.11,206.91a2.76,2.76,0,1,1-3.43-1.87A2.76,2.76,0,0,1,223.11,206.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M223.35,206.59a2.8,2.8,0,1,1-3.48-1.9A2.8,2.8,0,0,1,223.35,206.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M223.58,206.26a2.84,2.84,0,1,1-3.53-1.93A2.84,2.84,0,0,1,223.58,206.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M223.8,205.92a2.89,2.89,0,1,1-3.59-2A2.88,2.88,0,0,1,223.8,205.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M224,205.55a2.93,2.93,0,1,1-5.63,1.66,2.93,2.93,0,0,1,5.63-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M224.2,205.18a3,3,0,1,1-3.7-2A3,3,0,0,1,224.2,205.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M224.38,204.78a3,3,0,1,1-3.75-2.05A3,3,0,0,1,224.38,204.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M224.54,204.36a3.06,3.06,0,1,1-3.8-2.07A3.06,3.06,0,0,1,224.54,204.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M224.69,203.93a3.11,3.11,0,1,1-3.86-2.11A3.11,3.11,0,0,1,224.69,203.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M224.82,203.48a3.15,3.15,0,1,1-3.92-2.14A3.15,3.15,0,0,1,224.82,203.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M224.93,203a3.2,3.2,0,1,1-4-2.17A3.19,3.19,0,0,1,224.93,203Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M225,202.51a3.25,3.25,0,1,1-4-2.2A3.24,3.24,0,0,1,225,202.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M225.1,202a3.29,3.29,0,1,1-4.08-2.23A3.29,3.29,0,0,1,225.1,202Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M225.15,201.45a3.33,3.33,0,1,1-4.13-2.26A3.33,3.33,0,0,1,225.15,201.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M225.19,200.89A3.38,3.38,0,1,1,221,198.6,3.38,3.38,0,0,1,225.19,200.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M225.2,200.31A3.42,3.42,0,1,1,221,198,3.42,3.42,0,0,1,225.2,200.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M225.19,199.7a3.47,3.47,0,1,1-4.3-2.35A3.46,3.46,0,0,1,225.19,199.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M225.15,199.06a3.51,3.51,0,1,1-4.35-2.37A3.51,3.51,0,0,1,225.15,199.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "283.7 156.78 290.04 153.1 290.02 160.59 283.68 164.26 283.7 156.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "277.19 153.02 283.52 149.34 290.04 153.1 283.7 156.78 277.19 153.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "283.7 156.78 283.68 164.26 277.17 160.5 277.19 153.02 283.7 156.78"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "283.72 154.48 293.98 148.52 293.94 160.34 283.68 166.31 283.72 154.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "273.43 148.54 283.68 142.57 293.98 148.52 283.72 154.48 273.43 148.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "283.72 154.48 283.68 166.31 273.39 160.36 273.43 148.54 283.72 154.48"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "226.83 131.32 231.06 128.86 231.05 133.87 226.81 136.33 226.83 131.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "222.47 128.81 226.7 126.34 231.06 128.86 226.83 131.32 222.47 128.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "226.83 131.32 226.81 136.33 222.45 133.82 222.47 128.81 226.83 131.32"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "226.83 129.78 233.7 125.79 233.68 133.71 226.81 137.7 226.83 129.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "219.95 125.81 226.81 121.82 233.7 125.79 226.83 129.78 219.95 125.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "226.83 129.78 226.81 137.7 219.92 133.72 219.95 125.81 226.83 129.78"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "268.7 79.6 273 77.1 272.99 82.19 268.69 84.69 268.7 79.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "264.27 77.04 268.57 74.54 273 77.1 268.7 79.6 264.27 77.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "268.7 79.6 268.69 84.69 264.26 82.13 264.27 77.04 268.7 79.6"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "268.71 78.03 275.68 73.98 275.66 82.02 268.69 86.07 268.71 78.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "261.71 74 268.69 69.94 275.68 73.98 268.71 78.03 261.71 74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "268.71 78.03 268.69 86.07 261.69 82.03 261.71 74 268.71 78.03"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "226.11 62.5 228.72 60.98 228.72 64.07 226.1 65.59 226.11 62.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "223.42 60.95 226.03 59.43 228.72 60.98 226.11 62.5 223.42 60.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "226.11 62.5 226.1 65.59 223.41 64.04 223.42 60.95 226.11 62.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "226.12 61.55 230.35 59.09 230.34 63.97 226.1 66.43 226.12 61.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "221.87 59.1 226.1 56.63 230.35 59.09 226.12 61.55 221.87 59.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "226.12 61.55 226.1 66.43 221.85 63.98 221.87 59.1 226.12 61.55"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "226.3 172.31 234.35 167.63 234.32 177.16 226.27 181.84 226.3 172.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "218.01 167.53 226.06 162.85 234.35 167.63 226.3 172.31 218.01 167.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "226.3 172.31 226.27 181.84 217.98 177.05 218.01 167.53 226.3 172.31"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "226.31 169.5 239.35 161.91 239.31 176.96 226.26 184.54 226.31 169.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "213.21 161.94 226.26 154.35 239.35 161.91 226.31 169.5 213.21 161.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "226.31 169.5 226.26 184.54 213.17 176.98 213.21 161.94 226.31 169.5"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "231.99 96.83 234.84 95.17 234.84 98.54 231.98 100.2 231.99 96.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "229.05 95.13 231.91 93.47 234.84 95.17 231.99 96.83 229.05 95.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "231.99 96.83 231.98 100.2 229.04 98.51 229.05 95.13 231.99 96.83"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "231.99 95.83 236.62 93.14 236.6 98.47 231.98 101.16 231.99 95.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "227.35 93.14 231.98 90.46 236.62 93.14 231.99 95.83 227.35 93.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "231.99 95.83 231.98 101.16 227.33 98.48 227.35 93.14 231.99 95.83"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "258.29 49.47 261.46 47.62 261.45 51.38 258.27 53.22 258.29 49.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "255.02 47.58 258.19 45.73 261.46 47.62 258.29 49.47 255.02 47.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "258.29 49.47 258.27 53.22 255 51.34 255.02 47.58 258.29 49.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "258.29 48.35 263.44 45.36 263.42 51.3 258.27 54.29 258.29 48.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "253.12 45.37 258.27 42.38 263.44 45.36 258.29 48.35 253.12 45.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "258.29 48.35 258.27 54.29 253.11 51.31 253.12 45.37 258.29 48.35"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "261.4 119.98 267.1 116.67 267.08 123.41 261.38 126.72 261.4 119.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "255.54 116.6 261.24 113.29 267.1 116.67 261.4 119.98 255.54 116.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "261.4 119.98 261.38 126.72 255.52 123.34 255.54 116.6 261.4 119.98"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "261.41 117.99 270.64 112.63 270.61 123.27 261.38 128.63 261.41 117.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "252.15 112.64 261.38 107.28 270.64 112.63 261.41 117.99 252.15 112.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "261.41 117.99 261.38 128.63 252.12 123.29 252.15 112.64 261.41 117.99"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustRealityAbout);
export default __webpack_public_path__ + "static/media/Indust-reality-about.dd7a8c3449e919464d2e022f1f6f9ca6.svg";
export { ForwardRef as ReactComponent };